'use strict';

var root = document.body;

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function deleteCookie(cname) {
  document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + date.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

function initComparisons() {
  var x, i;
  x = document.getElementsByClassName('img-comp-overlay');
  for (i = 0; i < x.length; i++) {
    compareImages(x[i]);
  }
  function compareImages(img) {
    var slider,
      img,
      clicked = 0,
      w;
    w = img.offsetWidth;
    const icc = img.closest('.img-comp-container');
    if (icc) {
      slider = icc.querySelector('.image-comparison__button');
    }
    if (slider) {
      slider.addEventListener('touchstart', slideReady);
      slider.addEventListener('mousedown', slideReady);
    }
    window.addEventListener('mouseup', slideFinish);
    window.addEventListener('touchend', slideFinish);
    function slideReady(e) {
      e.preventDefault();
      clicked = 1;
      window.addEventListener('mousemove', slideMove);
      window.addEventListener('touchmove', slideMove);
    }
    function slideFinish() {
      clicked = 0;
      window.removeEventListener('mousemove', slideMove);
      window.removeEventListener('touchmove', slideMove);
    }
    function slideMove(e) {
      var pos;
      if (clicked == 0) return false;
      pos = getCursorPos(e);
      if (pos < 0) pos = 0;
      if (pos > w) pos = w;
      slide(pos);
    }
    function getCursorPos(e) {
      e = e.changedTouches ? e.changedTouches[0] : e;
      const a = img.getBoundingClientRect();
      let x = e.clientX - a.left + 14;
      x = Math.max(0, Math.min(x, w));

      return x;
    }

    function slide(x) {
      if (slider) {
        const sliderHalfWidth = slider.offsetWidth / 2;
        let percent = ((x - sliderHalfWidth) / w) * 100;
        let min = (sliderHalfWidth / icc.getBoundingClientRect().width) * 100;
        percent = Math.max(min - 0.1, Math.min(percent, 100));
        img
          .closest('.img-comp-container')
          .setAttribute('style', '--percent: ' + percent + '%;');
      }
    }
  }
}

initComparisons();
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initComparisons();
  }, 200);
});

/* Tayler upgraded this for fixing the bug.... 20260131 */
function initLazyloadItem() {
  const lazyVideos = document.querySelectorAll('video.lazy-video-item');

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          
          if (video.dataset.poster) {
            video.poster = video.dataset.poster;
            video.removeAttribute('data-poster');
          }

          const sources = video.querySelectorAll('source');
          sources.forEach((source) => {
            const realSrc = source.getAttribute('data-video-src') || 
                           source.getAttribute('data-src') || 
                           source.getAttribute('srcset');

            if (realSrc) {
              source.src = realSrc;
              source.removeAttribute('data-video-src');
              source.removeAttribute('data-src');
              source.removeAttribute('srcset');
            }
          });

          video.load(); 
          
          if (video.hasAttribute('autoplay')) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
              });
            }
          }

          video.classList.remove('lazy-video-item');
          observer.unobserve(video);
        }
      });
    },
    { threshold: 0.1, rootMargin: '50px' } 
  );

  lazyVideos.forEach((video) => observer.observe(video));
}
document.addEventListener('DOMContentLoaded', initLazyloadItem);

function initLazyBg() {
  const lazyBg = document.querySelectorAll('.lazy-bg');
  const isMobile = window.innerWidth < 768;
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const bg = entry.target;
          const data = bg.dataset;
          const src = (isMobile && data.srcMobile) || data.src;
          bg.style.setProperty('--bg', `url(${src})`);
          bg.classList.remove('lazy-bg');
          observer.unobserve(bg); // Stop observing once loaded
        }
      });
    },
    { threshold: 0.1 }
  );

  lazyBg.forEach((bg) => observer.observe(bg));
}
initLazyBg();

function initLazyload() {
  window.addEventListener('scroll', () => {
    scrollLazyload();
  });
  let pos = window.pageYOffset;
  if (pos > 40) {
    scrollLazyload();
  }
}
initLazyload();

function scrollLazyload() {
  document.querySelectorAll('video.lazy-video').forEach((el) => {
    scrollLazyloadItem(el);
  });
}

function scrollLazyloadItem(el) {
  const poster = el.dataset.poster;
  const src = el.dataset.src;
  if (poster) {
    el.setAttribute('poster', poster);
    el.removeAttribute('data-poster');
    el.setAttribute('src', src);
    el.removeAttribute('data-src');
  }
  el.querySelectorAll('source').forEach((source) => {
    const source_src = source.dataset.src;
    if (source_src) {
      source.setAttribute('src', source_src);
      source.removeAttribute('data-src');
    }
  });
  el.classList.remove('lazy-video');
}

function eventFlashingBrowseTab() {
  var enable = window.flashingBrowseTab?.enable,
    myTimer,
    message,
    titleTag = document.getElementsByTagName('title')[0],
    first_notification = window.flashingBrowseTab?.firstNotification,
    secondary_notification = window.flashingBrowseTab?.secondaryNotification;
  if (enable && titleTag) {
    var originalTitle = titleTag.innerText;
    var isActive = true;
    document.addEventListener('visibilitychange', () => {
      document.visibilityState === 'visible'
        ? (function () {
            if (isActive) return;
            clearInterval(myTimer), (titleTag.innerText = originalTitle);
          })()
        : (function () {
            var i = 1;
            if (
              ((isActive = false),
              !first_notification || !secondary_notification)
            )
              return;
            myTimer = setInterval(function () {
              if (i == 1) {
                message = first_notification;
                i = 2;
              } else {
                message = secondary_notification;
                i = 1;
              }
              titleTag.innerText = message;
            }, 2000);
          })();
    });
  }
}
eventFlashingBrowseTab();

function initializeLazyLoad() {
  const videoPlaceholders = document.querySelectorAll('.lazy-video-link');
  const loadYouTubeVideo = (element) => {
    const videoId = element.getAttribute('data-video-id');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=${videoId}`;
    iframe.allowFullscreen = true;
    iframe.frameBorder = '0';
    iframe.title = element.getAttribute('data-video-title') || 'YouTube video player';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    // For release-notes-video-container, preserve poster image and append iframe
    // Otherwise, replace content as before
    if (element.closest('.release-notes-video-container')) {
      element.appendChild(iframe);
      // Mark that iframe is loaded to hide poster via CSS
      element.classList.add('has-iframe');
    } else {
      element.innerHTML = '';
      element.appendChild(iframe);
    }
  };
  const loadVimeoVideo = (element) => {
    const videoId = element.getAttribute('data-video-id');
    const iframe = document.createElement('iframe');
    iframe.src = `https://player.vimeo.com/video/${videoId}?controls=0&background=1&autoplay=1&muted=1&loop=1`;
    iframe.allowFullscreen = true;
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.frameBorder = '0';
    iframe.title = element.getAttribute('data-video-title') || 'Vimeo video player';
    // For release-notes-video-container, preserve poster image and append iframe
    // Otherwise, replace content as before
    if (element.closest('.release-notes-video-container')) {
      element.appendChild(iframe);
      // Mark that iframe is loaded to hide poster via CSS
      element.classList.add('has-iframe');
    } else {
      element.innerHTML = '';
      element.appendChild(iframe);
    }
  };
  const loadVideo = (element) => {
    const videoType = element.getAttribute('data-video-type');
    if (videoType === 'youtube') {
      loadYouTubeVideo(element);
    } else if (videoType === 'vimeo') {
      loadVimeoVideo(element);
    }
  };
  const lazyLoadVideos = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });
    videoPlaceholders.forEach((videoPlaceholder) => {
      observer.observe(videoPlaceholder);
    });
  };
  lazyLoadVideos();
}
initializeLazyLoad();

const slideAnime = (() => {
  let isAnimating = false;

  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animeType: 'slideToggle',
      duration: 250,
      easing: 'ease',
      isDisplayStyle: 'block',
      parent: false,
      addFunction: () => {},
    };
    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    const ownAnimate = options.ownAnimate;
    if (ownAnimate) {
      isAnimating = false;
    }
    const parent = options.parent;
    if (!target) {
      return;
    }

    if (isAnimating) {
      return;
    }
    isAnimating = true;
    parent.classList?.toggle('opened');

    let animeType = options.animeType;
    const styles = getComputedStyle(target);
    if (animeType === 'slideToggle') {
      animeType = styles.display === 'none' ? 'slideDown' : 'slideUp';
    }
    if (
      (animeType === 'slideUp' && styles.display === 'none') ||
      (animeType === 'slideDown' && styles.display !== 'none') ||
      (animeType !== 'slideUp' && animeType !== 'slideDown')
    ) {
      isAnimating = false;
      return false;
    }
    target.style.overflow = 'hidden';
    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;

    if (animeType === 'slideDown') {
      target.style.display = isDisplayStyle;
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + 'px',
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };

    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });
    if (Object.keys(heightVal).length === 0) {
      isAnimating = false;
      return false;
    }
    let slideAnime;
    if (animeType === 'slideDown') {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animeType === 'slideUp') {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }
    slideAnime.finished.then(() => {
      options.addFunction();
      target.style.overflow = '';
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = '';
      });
      if (animeType === 'slideUp') {
        target.style.display = 'none';
      }
      isAnimating = false;
    });
  };
})();

class CollectionOverviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSections();

    document.addEventListener('shopify:section:load', (event) => {
      if (this.contains(event.target)) {
        this.initSection(event.target);
      }
    });

    document.addEventListener('shopify:section:reorder', (event) => {
      if (this.contains(event.target)) {
        this.initSection(event.target);
      }
    });
  }

  initSections() {
    const sections = this.querySelectorAll('.section__block-inner');
    sections.forEach((section) => {
      this.initSection(section);
    });
  }

  initSection(section) {
    const blocks = section.querySelectorAll('.content-overview-block');
    const banners = section.querySelectorAll('.banner__media-collection');

    banners.forEach((banner) => {
      banner.classList.remove('active');
    });

    if (banners.length > 0) {
      banners[0].classList.add('active');
    }

    blocks.forEach((block) => {
      block.classList.remove('active');
    });

    if (blocks.length > 0) {
      blocks[0].classList.add('active');
    }

    blocks.forEach((block) => {
      block.addEventListener('mousemove', () => {
        const blockIndex = block.getAttribute('data-index');

        banners.forEach((banner) => {
          banner.classList.remove('active');
        });

        blocks.forEach((b) => {
          b.classList.remove('active');
        });

        const targetBanner = section.querySelector(
          `.banner__media-collection[data-index="${blockIndex}"]`
        );
        if (targetBanner) {
          targetBanner.classList.add('active');

          // Tinsley
          const video = targetBanner.querySelector('video');
          if(video) {
            video.currentTime = 0;
          }
        }

        block.classList.add('active');
      });
    });
  }
}

customElements.define('collection-overviews', CollectionOverviews);

class MultiContent extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.swiperSlideInnerHtml = this.innerHTML;
    this.init();
  }
  init() {
    if (this.enable == 'true') {
      let width = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 576) {
        this.actionOnMobile();
      } else {
        this.actionOutMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add('swiper');
    const html = this.swiperSlideInnerHtml.replaceAll(
      'section__block',
      'swiper-slide'
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div> <div
    class="swiper-pagination  ${
      this.enable && this.dataset.mobile != 1.5 ? 'flex' : 'hidden'
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    this.innerHTML = wrapper;
    this.initSlide();
  }
  actionOutMobile() {
    if (this.classList.contains('swiper')) {
      this.classList.remove('swiper');
      this.innerHTML = this.swiperSlideInnerHtml;
    }
  }
}
customElements.define('multi-content', MultiContent);

/* ==========================================================================
   MultiContentWW - Fixed Class for Oura Layout
   ========================================================================== */
class MultiContentWW extends SlideSection {
  constructor() {
    super();
    // 基础属性
    this.enable = false;
    this.desktopEnable = false;
    this.isExpandable = false;
    this.swiperSlideInnerHtml = this.innerHTML;
    this.isInitialized = false;
    this.currentMode = null;
    this.expandableSlideInlineStyles = new Map();
  }

  // 禁用父类 SlideSection 的默认 init
  init() {}

  connectedCallback() {
    if (this.isInitialized) return;
    
    this.enable = this.dataset.enable === 'true'; 
    this.desktopEnable = this.dataset.desktopEnable === 'true';
    this.isExpandable = this.dataset.expandable === 'true';
    this.isProgressbar = this.dataset.paginationProgressbar === 'true';
    this.captureExpandableSlideInlineStyles();

    this.checkLayout();

    let width = window.innerWidth;
    window.addEventListener('resize', () => {
      const newWidth = window.innerWidth;
      if ((newWidth <= 767 && width > 767) || (newWidth > 767 && width <= 767)) {
        this.checkLayout();
      }
      width = newWidth;
    });

    this.isInitialized = true;
  }

  checkLayout() {
    const width = window.innerWidth;
    const isMobile = width <= 767;

    if (isMobile) {
      if (this.enable) {
        this.actionBuildSlider('mobile');
      } else {
        this.actionDestroySlider();
      }
    } else {
      // PC 端逻辑
      if (this.desktopEnable) {
        this.actionBuildSlider('desktop');
      } else {
        this.actionDestroySlider();
      }
    }
  }

  actionBuildSlider(mode) {
    if (this.classList.contains('swiper-initialized')) {
      if (this.currentMode === mode) return;
      this.actionDestroySlider();
    }

    this.classList.add('swiper');
    
    const columnGap = this.dataset.spacing ? parseFloat(this.dataset.spacing) : 15;

    // 获取自动播放设置
    const enableAutoplay = this.dataset.autoplay === 'true';
    const autoplaySpeed = this.dataset.autoplaySpeed ? parseInt(this.dataset.autoplaySpeed) * 1000 : 5000;

    // 1. 准备基础配置
    let config = {
      speed: 600, 
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      resistance: true, 
      resistanceRatio: 0.85,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el: this.querySelector('.swiper-pagination'),
        type: this.isProgressbar ? 'progressbar' : 'bullets',
      },
      observer: true,
      observeParents: true,
    };

    // [新增] 注入自动播放配置
    if (enableAutoplay) {
        config.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false, // 用户操作后不停止自动播放
            pauseOnMouseEnter: true      // (可选) 鼠标悬停时暂停
        };
    }

    // 2. 针对 PC Slider 的配置
    if (mode === 'desktop') {
      config = {
        ...config,
        slidesPerView: 'auto', 
        spaceBetween: columnGap, 
        slidesOffsetBefore: 0, 
        centerInsufficientSlides: false, 
        centeredSlides: false, 
        simulateTouch: true,
        loop: false,
        breakpoints: {
          1025: { slidesPerView: 'auto', spaceBetween: columnGap } 
        }
      };
    } else {
      // 3. 移动端 (Mobile) 配置
      const mobileCols = this.dataset.mobile ? parseFloat(this.dataset.mobile) : 1;
      const columnGapMb = this.dataset.spacingMb
        ? parseFloat(this.dataset.spacingMb)
        : (this.dataset.spacingMobile ? parseFloat(this.dataset.spacingMobile) : columnGap);

      config = {
        ...config,
        slidesPerView: mobileCols,
        spaceBetween: columnGapMb,
        centeredSlides: false,    
        freeMode: false            
      };
    }

    // 3. 修复 DOM (如果 swiper-wrapper 丢失)
    if (!this.querySelector('.swiper-wrapper')) {
      if(!this.innerHTML.includes('swiper-wrapper')) {
         let html = this.swiperSlideInnerHtml.replaceAll('section__block', 'swiper-slide');
         this.innerHTML = `<div class='swiper-wrapper'>${html}</div>`;
         // 补充分页器
         const pagination = document.createElement('div');
         pagination.className = 'swiper-pagination';
         this.appendChild(pagination);
      }
    }

    // 4. 初始化 Swiper
    this.globalSlide = new Swiper(this, config);
    this.currentMode = mode;
    
    // 5. 再次强制更新
    setTimeout(() => {
        if(this.globalSlide) {
            this.globalSlide.update();
            if(this.globalSlide.navigation) this.globalSlide.navigation.update();
        }
    }, 100);
  }

  captureExpandableSlideInlineStyles() {
    if (!this.isExpandable || this.expandableSlideInlineStyles.size) return;

    this.querySelectorAll('.ww-expandable-col[data-block-id]').forEach((slide) => {
      const blockId = slide.getAttribute('data-block-id');
      const inlineStyle = slide.getAttribute('style');

      if (blockId && inlineStyle) {
        this.expandableSlideInlineStyles.set(blockId, inlineStyle);
      }
    });
  }

  restoreExpandableSlideInlineStyles() {
    if (!this.isExpandable || !this.expandableSlideInlineStyles.size) return;

    this.querySelectorAll('.ww-expandable-col[data-block-id]').forEach((slide) => {
      const blockId = slide.getAttribute('data-block-id');
      const inlineStyle = this.expandableSlideInlineStyles.get(blockId);

      if (inlineStyle) {
        slide.setAttribute('style', inlineStyle);
      }
    });
  }

  actionDestroySlider() {
    if (this.globalSlide) {
      this.globalSlide.destroy(true, true);
      this.globalSlide = null;
    }
    this.classList.remove('swiper', 'swiper-initialized', 'swiper-horizontal');
    this.currentMode = null;
    this.restoreExpandableSlideInlineStyles();
    
    if (!this.isExpandable) {
       this.innerHTML = this.swiperSlideInnerHtml; 
    }
  }
}
if (!customElements.get('multi-content-ww')) {
  customElements.define('multi-content-ww', MultiContentWW);
}

var getScrollBarWidth = (function () {
  return {
    init: function () {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    },
  };
})();

var wishlistHeader = (function () {
  return {
    init: function () {
      this.handleCount();
    },
    handleCount: function () {
      const wishlist = document.querySelectorAll('.wishlist-count');
      let items = [];
      try {
        const stored = localStorage.getItem('glozin__wishlist-items');
        items = stored ? JSON.parse(stored) : [];
        if (!Array.isArray(items)) items = [];
      } catch (e) {
        console.warn('Failed to parse wishlist items', e);
        localStorage.removeItem('glozin__wishlist-items');
      }
      wishlist.forEach((item) => {
        item.innerText = items.length !== 0 ? items.length : 0;
      });
    },
  };
})();
wishlistHeader.init();

// New function to handle Account Dropdown interaction -- Tayler added.... 20250909
function initAccountDropdown() {
  const accountWrapper = document.querySelector('[data-account-dropdown-wrapper]');
  if (!accountWrapper) return;

  const trigger = accountWrapper.querySelector('[data-account-dropdown-trigger]');
  const menu = accountWrapper.querySelector('[data-account-dropdown-menu]');

  if (!trigger || !menu) return;

  trigger.addEventListener('click', (event) => {
    event.stopPropagation();
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      menu.hidden = true;
      menu.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    } else {
      menu.hidden = false;
      setTimeout(() => { // Allows CSS transition to work
        menu.classList.add('is-open');
      }, 10);
      trigger.setAttribute('aria-expanded', 'true');
    }
  });

  // Close dropdown when clicking outside of it
  document.addEventListener('click', (event) => {
    if (!accountWrapper.contains(event.target) && menu.classList.contains('is-open')) {
      menu.hidden = true;
      menu.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
  });
}

// Enhance the existing wishlistHeader.handleCount function
// This will make the count bubble visible only when there are items.
(function enhanceWishlistCounter() {
  const originalHandleCount = wishlistHeader.handleCount;

  wishlistHeader.handleCount = function() {
    // Call the original function first to set the numbers
    originalHandleCount.apply(this, arguments);

    // Now, add visibility logic
    const wishlistCounters = document.querySelectorAll('.wishlist-count');
    let items = [];
    try {
      const stored = localStorage.getItem('glozin__wishlist-items');
      items = stored ? JSON.parse(stored) : [];
      if (!Array.isArray(items)) items = [];
    } catch (e) {
      items = [];
    }
    const count = items.length;

    wishlistCounters.forEach(counter => {
      if (count > 0) {
        // Use inline-flex for the main bubble to center content properly
        if (!counter.classList.contains('wishlist-count-bubble--inner')) {
            counter.style.display = 'inline-flex';
            counter.style.alignItems = 'center';
            counter.style.justifyContent = 'center';
        }
      } else {
        counter.style.display = 'none';
      }
    });
  };

  // Re-initialize to apply the enhancement immediately
  wishlistHeader.init();
})();

// Initialize the new dropdown functionality on page load
document.addEventListener('DOMContentLoaded', initAccountDropdown);

function HoverIntent(exitTime, elements, userConfig) {
  // 合并配置
  const config = { exitDelay: exitTime, interval: 100, sensitivity: 6, ...userConfig };
  const allElems = elements;

  // 架构修复：严格隔离每个 DOM 元素的状态，彻底消除闭包变量污染和竞态条件
  for (let elem of allElems) {
    if (!elem) continue;

    // 为每个菜单项分配独立的定时器与坐标空间
    let hoverTimer = null;
    let exitTimer = null;
    let currX = 0, currY = 0, prevX = 0, prevY = 0;

    const track = (e) => {
      currX = e.pageX;
      currY = e.pageY;
    };

    const compare = () => {
      const distX = prevX - currX;
      const distY = prevY - currY;
      const distance = Math.sqrt(distX * distX + distY * distY);

      // 架构修复：防范 NaN 陷阱。如果鼠标未移动距离为 0 或 NaN，强制触发展开
      if (distance < config.sensitivity || isNaN(distance)) {
        clearTimeout(exitTimer);
        
        // 互斥关闭：当一个菜单准备展开时，安全地收起其他正在激活的菜单
        allElems.forEach(other => {
          if (other !== elem && other.isActive) {
            config.onExit(other);
            other.isActive = false;
          }
        });
        
        config.onEnter(elem);
        elem.isActive = true;
      } else {
        prevX = currX;
        prevY = currY;
        hoverTimer = setTimeout(compare, config.interval);
      }
    };

    elem.addEventListener('mousemove', track);

    elem.addEventListener('mouseenter', (e) => {
      // 架构修复：在进入瞬间强制初始化坐标，彻底阻断 NaN 导致引擎死锁的可能
      prevX = e.pageX;
      prevY = e.pageY;
      currX = e.pageX; 
      currY = e.pageY; 

      clearTimeout(exitTimer);
      if (elem.isActive) return;

      hoverTimer = setTimeout(compare, config.interval);
    });

    elem.addEventListener('mouseleave', () => {
      clearTimeout(hoverTimer);
      if (!elem.isActive) return;

      exitTimer = setTimeout(() => {
        config.onExit(elem);
        elem.isActive = false;
      }, config.exitDelay);
    });
  }
}

let BlsMainMenuShopify = (function () {
  return {
    init: function () {
      this.initMenu();
      this.initMainMenu();
      this.initMobileMenu();
      this.initVerticalMenu();
    },

    // Tayler modified here ... 20260228 for ADA tab adapt
    initMenu: function () {
      const header = document.querySelector('header');
      if (!header) return;

      // Cache DOM elements
      const elements = {
        categoriesListMenuMobile: document.querySelector('.categories-list-menu-mobile'),
        categoriesListMenu: document.querySelector('[data-menu="categories-list"]'),
        categoriesListMenuVertical: document.querySelector('[data-menu="verticalmenu-list"]'),
        categoriesListMenuVerticalMobile: document.querySelector('.verticalmenu-mobile'),
        horizontalList: document.querySelector('nav.mobile .horizontal-list')
      };

      // Calculate section padding bottom value
      const sectionPbValue = this.calculateSectionPadding(header);

      // Initialize fade-in-down animation if present
      this.initFadeInDownAnimation(header, sectionPbValue);

      // Handle menu tab switching
      this.setupMenuTabSwitching(elements);

      // Initialize menu tab state based on window width
      this.updateMenuTabState(elements);
      this.updateMenuVerticalMobile(elements);

      // Add resize event listener for responsive behavior
      window.addEventListener('resize', () => this.updateMenuTabState(elements));
      window.addEventListener('resize', () => this.updateMenuVerticalMobile(elements));
    },

    calculateSectionPadding: function (header) {
      let sectionPbValue = parseInt(getComputedStyle(header).getPropertyValue('--section-pb').trim());
      if (header.querySelector('.header__layout-2')) {
        sectionPbValue = 0;
      }
      return sectionPbValue;
    },

    initFadeInDownAnimation: function (header, sectionPbValue) {
      const isFadeInDown = document.querySelector('.animation-fade-in-down, .fade-in-down');
      const menus = document.querySelectorAll('.menu-parent__horizontal');
      if (!menus.length) return;

      let onEnterFn, onExitFn;

      if (!isFadeInDown) {
        onEnterFn = function (targetItem) { targetItem.classList.add('visible'); };
        onExitFn = function (targetItem) { targetItem.classList.remove('visible'); };
      } else {
        onEnterFn = (targetItem) => this.handleMenuEnter(targetItem, header, sectionPbValue);
        onExitFn = (targetItem) => this.handleMenuExit(targetItem, header);
      }

      HoverIntent(180, menus, {
        onEnter: onEnterFn,
        onExit: onExitFn
      });

      menus.forEach((parent) => {
        const link = parent.querySelector('a');

        if (link) {
          link.addEventListener('focus', () => {
            menus.forEach(otherParent => {
              if (otherParent !== parent && (otherParent.classList.contains('visible') || otherParent.isActive)) {
                onExitFn(otherParent);
                otherParent.isActive = false; 
              }
            });
            onEnterFn(parent);
            parent.isActive = true; 
          });
        }

        parent.addEventListener('focusout', (e) => {
          if (!e.relatedTarget || !parent.contains(e.relatedTarget)) {
            onExitFn(parent);
            parent.isActive = false; 
          }
        });
      });

      // 3. ADA 核心要求：按 Escape (ESC) 键必须能随时关闭菜单
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const visibleMenus = Array.from(menus).filter(m => m.classList.contains('visible') || m.isActive);
          visibleMenus.forEach(parent => {
            onExitFn(parent);
            parent.isActive = false; 
            const link = parent.querySelector('a');
            if (link) link.focus(); 
          });
        }
      });
    },

    handleMenuEnter: function (targetItem, header, sectionPbValue) {
      const submenu = targetItem.querySelector('.submenu-horizontal');
      if (!submenu) return;

      const width = window.innerWidth;
      if (width < 1280) return; // [HEADER-BP-1280] was 1024

      const sticky = header?.getAttribute('data-sticky');
      if (sticky == 'on-scroll-up') {
        header.classList.add('open-submenu');
      }

      if (document.documentElement.classList.contains('open-search')) {
        this.handleMenuEnterWithSearchOpen(targetItem, submenu, sectionPbValue);
      } else {
        this.handleStandardMenuEnter(targetItem, submenu, header);
      }
    },

    handleStandardMenuEnter: function (targetItem, submenu, header) {
      const outerRect = header.getBoundingClientRect();
      const innerRect = targetItem.getBoundingClientRect();
      const heightScrollDown = outerRect.bottom - innerRect.bottom;

      motion.animate(
        submenu,
        {
          y: ['-105%', heightScrollDown],
          visibility: ['hidden', 'visible'],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 0.35,
        }
      );

      targetItem.classList.add('visible');
      if (!header.classList.contains('border-bottom')) {
        header.classList.add('active');
      }
    },

    handleMenuEnterWithSearchOpen: function(targetItem, submenu, sectionPbValue) {
      const ps = document.querySelector('.popup-search');
      const overlay_search = document.querySelector('.overlay_search');
      const sf = document.querySelector('.search-full');

      if (!ps || !overlay_search || !sf) return;

      overlay_search.classList.remove('open');
      let topCaculate = sf.getBoundingClientRect().bottom + 10;

      Promise.all([
        motion.animate(
          ps,
          {
            y: [topCaculate, '-105%'],
            visibility: ['visible', 'hidden'],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.2,
          }
        ),
        motion.animate(
          overlay_search,
          {
            opacity: [1, 0],
            visibility: ['visible', 'hidden'],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.2,
          }
        ),
      ]).then(() => {
        setTimeout(() => {
          // Update document classes
          if (document.documentElement.classList.contains('open-minicart')) {
            document.documentElement.classList.remove('open-search');
          } else {
            document.documentElement.classList.remove('open-drawer', 'open-search');
            root.style.removeProperty('padding-right');
          }

          // Show submenu with animation
          motion.animate(
            submenu,
            {
              y: ['-105%', sectionPbValue],
              visibility: ['hidden', 'visible'],
            },
            {
              ease: [0.7, 0, 0.2, 1],
              duration: 0.35,
            }
          );
          targetItem.classList.add('visible');
        }, 20);
      });
    },

    handleMenuExit: function (targetItem, header) {
      const submenu = targetItem.querySelector('.submenu-horizontal');
      if (!submenu) return;

      const width = window.innerWidth;
      if (width < 1280) return; // [HEADER-BP-1280] was 1024

      const sticky = header?.getAttribute('data-sticky');
      const outerRect = header.getBoundingClientRect();
      const innerRect = targetItem.getBoundingClientRect();
      const heightScrollDown = outerRect.bottom - innerRect.bottom;

      if (sticky == 'on-scroll-up') {
        header.classList.remove('open-submenu');
      }

      motion.animate(
        submenu,
        {
          y: [heightScrollDown, '-105%'],
          visibility: ['visible', 'hidden'],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 0.4,
        }
      );

      targetItem.classList.remove('visible');
      if (header.classList.contains('active')) {
        header.classList.remove('active');
      }
    },

    setupMenuTabSwitching: function (elements) {
      document.querySelectorAll('.menu-mobile-title button').forEach((tabToggle) => {
        tabToggle.addEventListener('click', (e) => {
          e.preventDefault();
          const target = e.currentTarget;
          const data = target.dataset.menu;

          // Reset active state on all tabs
          document.querySelectorAll('.menu-mobile-title button')
            .forEach(item => item.classList.remove('active'));

          // Set current tab as active
          target.classList.add('active');

          // Show appropriate menu based on selected tab
          this.showMenuForTab(data, elements);
        });
      });
    },

    showMenuForTab: function (tabId, elements) {
      const { horizontalList, categoriesListMenuMobile } = elements;
      const categoriesListMenuVerticalMobile = document.querySelector('.verticalmenu-mobile');

      if (!horizontalList) return;
      
      // Hide horizontal list if we're showing a specific menu
      horizontalList.style.display = tabId !== 'horizontal-list' ? 'none' : 'block';
      
      // Show appropriate menu based on tab
      if (tabId === 'categories-list') {
        if (categoriesListMenuMobile) categoriesListMenuMobile.style.display = 'block';
        if (categoriesListMenuVerticalMobile) categoriesListMenuVerticalMobile.style.display = 'none';
      } else if (tabId === 'verticalmenu-list') {
        if (categoriesListMenuMobile) categoriesListMenuMobile.style.display = 'none';
        if (categoriesListMenuVerticalMobile) categoriesListMenuVerticalMobile.style.display = 'block';
      } else {
        if (categoriesListMenuMobile) categoriesListMenuMobile.style.display = 'none';
        if (categoriesListMenuVerticalMobile) categoriesListMenuVerticalMobile.style.display = 'none';
      }
    },

    updateMenuVerticalMobile: function (elements) {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 1279.98) { // [HEADER-BP-1280] was 1024
        const headerVertical = document.querySelector('.header-vertical');
        const headerVerticalMobile = document.querySelector('.verticalmenu-mobile');
        const titleVertical = headerVerticalMobile?.dataset.title;
        const menuMobileTitle = document.querySelector('.menu-mobile-title');
        if (!headerVertical) return;
        if (!menuMobileTitle.querySelector('[data-menu="verticalmenu-list"]')){
          const contentAppendTitleVertical = `
            <a
              class="no-underline heading-style py-10"
              data-menu="verticalmenu-list"
              role="link"
              aria-disabled="true"
            >
              ${titleVertical}
            </a>
          `
          menuMobileTitle.insertAdjacentHTML('beforeend', contentAppendTitleVertical);
          const newTabButton = menuMobileTitle.querySelector('[data-menu="verticalmenu-list"]');
          if (newTabButton) {
            newTabButton.addEventListener('click', (e) => {
              e.preventDefault();
              document.querySelectorAll('.menu-mobile-title button').forEach(item => item.classList.remove('active'));
              newTabButton.classList.add('active');
              this.showMenuForTab('verticalmenu-list', elements);
            });
          }
        }
        const wrapperVerticalmenu = document.querySelector('.verticalmenu-mobile');
        const navigationMenuContent = document.querySelector('.navigation__menu-content-mobile');
        if (!wrapperVerticalmenu || !navigationMenuContent) {
          return;
        }
        if (!navigationMenuContent.querySelector('.verticalmenu-mobile')){
          const cloneWrapper = wrapperVerticalmenu.cloneNode(true);
          navigationMenuContent.appendChild(cloneWrapper);
        }
      }
    },
    
    updateMenuTabState: function(elements) {
      const windowWidth = window.innerWidth;
      const {
        horizontalList,
        categoriesListMenu,
        categoriesListMenuVertical,
        categoriesListMenuMobile,
        categoriesListMenuVerticalMobile
      } = elements;

      if (!horizontalList || !categoriesListMenu) return;

      if (windowWidth <= 1279.98) { // [HEADER-BP-1280] was 1024
        // Mobile view
        if (categoriesListMenu?.classList.contains('active') || 
            categoriesListMenuVertical?.classList.contains('active')) {
          horizontalList.style.display = 'none';
        }
        
        if (categoriesListMenuVerticalMobile && 
            categoriesListMenuVertical?.classList.contains('active')) {
          categoriesListMenuVerticalMobile.style.display = 'block';
        }
      } else {
        // Desktop view
        if (categoriesListMenuMobile && 
            categoriesListMenu?.classList.contains('active')) {
          categoriesListMenuMobile.style.display = 'none';
        }
        
        if (categoriesListMenuVerticalMobile && 
            categoriesListMenuVertical?.classList.contains('active')) {
          categoriesListMenuVerticalMobile.style.display = 'none';
        }
        
        if (categoriesListMenu?.classList.contains('active') || 
            categoriesListMenuVertical?.classList.contains('active')) {
          horizontalList.style.display = 'inline-flex';
        }
      }
    },

    initMainMenu: function() {
      const header = document.querySelector('header');
      if (!header) return;
      
      this.setupNavToggle();
      this.setupMenuMouseEvents();
      this.setupHeaderAttributes();
      this.initStickyHeader(header);
      this.initSubMenu();
    },
    
    setupNavToggle: function() {
      document.querySelectorAll('.nav-toggle').forEach((navToggle) => {
        navToggle.addEventListener('click', (e) => {
          const target = e.currentTarget;
          const main_menu = document.querySelector('.navigation.horizontal');
          
          if (document.documentElement.classList.contains('nav-open')) {
            // Close menu
            root.style.removeProperty('padding-right');
            document.documentElement.classList.remove('nav-open', 'open-drawer');
            target.classList.remove('open');
            target.setAttribute('aria-expanded', 'false');
            if (!main_menu) {
              document.documentElement.classList.remove('nav-verticalmenu');
            }
          } else {
            // Open menu
            root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
            document.documentElement.classList.add('nav-open', 'open-drawer');
            target.classList.add('open');
            target.setAttribute('aria-expanded', 'true');
            if (!main_menu) {
              document.documentElement.classList.add('nav-verticalmenu');
            }
          }
        });
      });
    },
    
    setupMenuMouseEvents: function() {
      let width = screen.width;
      if (width <= 1279) return; // [HEADER-BP-1280] was 1024
      
      document.querySelectorAll('li.menu-parent .submenu').forEach((menuItem) => {
        menuItem.addEventListener('mouseenter', (e) => {
          const target = e.currentTarget;
          target.closest('.menu-parent').classList.add('active-submenu');
        });
        
        menuItem.addEventListener('mouseleave', (e) => {
          const target = e.currentTarget;
          target.closest('.menu-parent').classList.remove('active-submenu');
        });
      });
    },
    
    setupHeaderAttributes: function() {
      // Calculate heights for CSS variables
      let announcement_bar = document.querySelector('.section-announcement-bar')?.clientHeight || 0;
      let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
      let headerpage = document.querySelector('header')?.clientHeight || 0;
      
      document.querySelector('body').setAttribute(
        'style',
        `--height-bar: ${announcement_bar}px; --height-header: ${headerpage}px; --height-topbar: ${top_bar}px`
      );
    },
    
    initStickyHeader: function(header) {
      const sticky = header?.getAttribute('data-sticky');
      const sticky_mobile = header?.getAttribute('data-sticky-mobile');
      
      if (sticky === 'none') return;
      if (sticky_mobile === 'false' && window.innerWidth < 1280) return; // [HEADER-BP-1280] was 1025
      
      // Tinsley add
      const stickyNavList = document.querySelectorAll('.category-tab');
      if(stickyNavList.length > 0) return;

      // Setup header sticky behavior
      const headerSpaceH = document.getElementById('header-sticky')?.offsetHeight || 0;
      const announcement_bar = document.querySelector('.section-announcement-bar')?.clientHeight || 0;
      const top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
      const headerh = announcement_bar + top_bar + headerSpaceH;
      this.lastScrollPosition = 0; // Initialize lastScrollPosition property
      const sec_header = header.closest('.section-header');
      
      if (!sec_header) return;
      
      if (sticky === 'on-scroll-up') {
        sec_header.classList.add('scroll-up');
      }
      
      window.addEventListener('scroll', () => {
        if (header.classList.contains('open-submenu')) return;
        this.updateStickyHeader(sec_header, sticky, headerh);
      });
    },
    
    updateStickyHeader: function(sec_header, sticky, headerh) {
      let wpy = window.scrollY;
      
      if (sticky === 'always') {
        // Always sticky behavior
        if (wpy > headerh) {
          sec_header.classList.add('shopify-section-header-sticky', 'animate');
        } else {
          sec_header.classList.remove('shopify-section-header-sticky', 'animate');
        }
      } else {
        // Scroll-up sticky behavior
        if (wpy > 0) {
          if (wpy > headerh) {
            sec_header.classList.add('scr-pass-header');
            
            if (wpy > this.lastScrollPosition) {
              sec_header.classList.add('shopify-section-header-hidden');
            } else {
              sec_header.classList.remove('shopify-section-header-hidden');
              sec_header.classList.add('animate');
            }
            sec_header.classList.add('header-sticky', 'shopify-section-header-sticky');
            this.lastScrollPosition = wpy;
          } else {
            sec_header.classList.remove('header-sticky', 'scr-pass-header');
            this.lastScrollPosition = 0;
          }
        } else {
          sec_header.classList.remove(
            'shopify-section-header-hidden', 
            'header-sticky', 
            'animate', 
            'shopify-section-header-sticky'
          );
        }
      }
    },
    
    initSubMenu: function() {
      const main_menu = document.querySelector('.navigation.horizontal');
      if (!main_menu || window.innerWidth <= 1279) return; // [HEADER-BP-1280] was 1024

      this.addCssSubMenu();

      window.addEventListener('resize', () => {
        if (window.innerWidth > 1279) { // [HEADER-BP-1280] was 1024
          this.addCssSubMenu();
        }
      });
    },

    addCssSubMenu: function () {
      const bodyWidth = document.documentElement.clientWidth || document.body.clientWidth;
      const header = document.querySelector('header');
      const submenu_center = document.querySelector('.submenu-center');
      const width_sub_center = 800;
      
      if (!header || bodyWidth < 1279) return; // [HEADER-BP-1280] was 1024
      
      const padding = 30;
      document.querySelectorAll('.horizontal-list .mega-menu-fix-width').forEach((submenu) => {
        if (submenu_center) {
          // Handle center aligned submenu
          const submenu_data = submenu.getBoundingClientRect();
          const width = submenu_data.width;
          const left = submenu_data.left;
          const right = submenu_data.right;
          
          if (width_sub_center <= width) {
            const left_style = (left - (right - bodyWidth)) / 2;
            submenu.style.left = left_style + 'px';
          }
        } else {
          // Handle default submenu positioning
          const elementWidth = submenu.clientWidth;
          const elementLeft = submenu.offsetLeft;
          
          if (bodyWidth - (elementWidth + elementLeft) < 0) {
            let left = bodyWidth - (elementWidth + elementLeft);
            left = left + elementLeft - padding;
            
            if (elementLeft < 0) {
              left = 0;
            }
            
            submenu.style.left = left + 'px';
          }
        }
      });
    },
    
    initVerticalMenu: function() {
      const article = document.querySelector('.verticalmenu-html');
      if (!article) return;
      
      const verticalMenu = document.querySelector('.vertical-menu');
      if (!verticalMenu) return;
      verticalMenu.addEventListener('mouseenter', function() {
        setTimeout(function() {
          verticalMenu.classList.add('open-vertical');
        }, 150);
      });
      verticalMenu.addEventListener('mouseleave', function() {
        verticalMenu.classList.remove('open-vertical');
      });
      this.setupSimpleHoverIntent(1,'.menu-parent__vertical');
    },
    
    initMobileMenu: function() {
      // Reserved for mobile menu specific initialization
    }
  };
})();
BlsMainMenuShopify.init();
var BlsSearchShopify = (function () {
  return {
    init: function () {
      var predictive = document.querySelector('#predictive-search');
      if (predictive) {
        this.setupEventListeners();
      }
      const form = document.querySelector('#search-form');
      document.querySelectorAll('.top-search-toggle').forEach((navToggle) => {
        navToggle.onclick = (e) => {
          const target = e.currentTarget;
          if (!form.classList.contains('open')) {
            form.classList.add('open');
            target.classList.add('open');
            document.documentElement.classList.add(
              'open-drawer',
              'open-search'
            );
            root.style.setProperty(
              'padding-right',
              getScrollBarWidth.init() + 'px'
            );
            setTimeout(function () {
              form.querySelector('input[type="search"]').focus();
            }, 100);
          } else {
            form.classList.remove('open');
            target.classList.remove('open');
            setTimeout(() => {
              document.documentElement.classList.remove('open-drawer');
              root.style.removeProperty('padding-right');
            }, 300);

            document.documentElement.classList.remove('open-search');
          }
        };
      });
      document.querySelectorAll('.btn-search-close').forEach((navToggle) => {
        navToggle.onclick = () => {
          form.classList.remove('open');
          document
            .querySelector('.dropdown-toggle .top-search-toggle')
            ?.classList.remove('open');
          document.documentElement.classList.remove('open-search');
          setTimeout(() => {
            document.documentElement.classList.remove('open-drawer');
            root.style.removeProperty('padding-right');
          }, 300);
        };
        const overlay_search = document.querySelector('.overlay_search');
        if (overlay_search) {
          overlay_search.onclick = () => {
            navToggle.click();
          };
        }
      });
      const sf = document.querySelector('.search-full');
      if (sf) {
        const hs = sf.closest('.header_search');
        var unSubcribeCloseCanvas;
        if (unSubcribeCloseCanvas) {
          unSubcribeCloseCanvas();
          unSubcribeCloseCanvas = null;
        }
        unSubcribeCloseCanvas = subscribe('closeCanvas', (data) => {
          if (document.documentElement.classList.contains('open-search')) {
            const width = window.innerWidth;
            const ps = document.querySelector('.popup-search');
            if (width >= 767.95 && ps) {
              this.closeDefaultSearch();
            }
          }
        });
        this._boundHandleClickSearch =
          this._boundHandleClickSearch || this.handleClickSearch.bind(this);

        document.removeEventListener('click', this._boundHandleClickSearch);

        document.addEventListener('click', this._boundHandleClickSearch);
      }
    },
    handleClickSearch: function (e) {
      const sf = document.querySelector('.search-full');
      const hs = sf.closest('.header_search');
      const ehs = e.target.closest('.header_search');

      const search_container = e.target.closest('header-search');

      if (ehs || search_container) {
        const ps = document.querySelector('.popup-search');
        const width = window.innerWidth;
        if (ps) {
          ps.classList.add('popup-search-show');
          if (document.documentElement.classList.contains('open-search')) {
            return;
          }
          if (width >= 767.95) {
            this.openDefaultSearch();
          }
        }
      } else {
        if (hs) {
          if (document.documentElement.classList.contains('open-search')) {
            const width = window.innerWidth;
            if (width >= 767.95) {
              this.closeDefaultSearch();
            } else {
              const form = document.querySelector('#search-form');
              form.classList.remove('open');
              if (
                document.documentElement.classList.contains('open-minicart')
              ) {
                document.documentElement.classList.remove('open-search');
              } else {
                document.documentElement.classList.remove(
                  'open-drawer',
                  'open-search'
                );
                root.style.removeProperty('padding-right');
              }
            }
          }
        }
      }
    },
    openDefaultSearch: function () {
      const headerNavigation = document.querySelector('.header-bottom__navigation');
      const headerTopActions = document.querySelector('.header-top__actions');
      const headerWrapper = document.querySelector('header');
      if (headerNavigation && headerWrapper) {
        const headerNavigationHeight = headerNavigation.offsetHeight;
        headerNavigation.style.opacity = '0';
        headerNavigation.style.transition = 'opacity 0.3s ease';
        headerNavigation.style.display = 'none';
        headerWrapper.style.marginBottom = `${headerNavigationHeight}px`;
      }
      const overlay_search = document.querySelector('.overlay_search');
      overlay_search.classList.add('open');
      const containsHeaderLayoutOne =
        document.querySelector('.header__layout-1');
      const containsHeaderLayoutTwo =
        document.querySelector('.header__layout-2');
      const containsHeaderLayoutThree =
        document.querySelector('.header__layout-3');
      const sf = document.querySelector(
        containsHeaderLayoutOne
          ? 'header'
          : containsHeaderLayoutTwo
          ? 'header-inner'
          : containsHeaderLayoutThree
          ? '.header-mega-store'
          : '.search-full'
      );
      let topCaculate = sf.getBoundingClientRect().bottom;
      const ps = document.querySelector('.popup-search');
      document.documentElement.classList.add('open-drawer');
      root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
      Promise.all([
        motion.animate(
          ps,
          {
            y: ['-105%', topCaculate],
            visibility: ['hidden', 'visible'],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),

        motion.animate(
          overlay_search,
          {
            opacity: [0, 1],
            visibility: ['hidden', 'visible'],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),
      ]).then(() => {
        setTimeout(() => {
          document.documentElement.classList.add('open-search');
        }, 20);
      });
    },

    closeDefaultSearch: function () {
      const headerNavigation = document.querySelector('.header-bottom__navigation');
      const headerWrapper = document.querySelector('header');
      const ps = document.querySelector('.popup-search');
      const sf = document.querySelector('.search-full');
      const overlay_search = document.querySelector('.overlay_search');
      overlay_search.classList.remove('open');
      ps.classList.remove('popup-search-show');
      let topCaculate = sf.getBoundingClientRect().bottom + 10;
      if (headerNavigation && headerWrapper) {
        headerNavigation.style.opacity = '';
        headerNavigation.style.transition = '';
        headerNavigation.style.display = '';
        headerWrapper.style.marginBottom = '';
      }
      Promise.all([
        motion.animate(
          ps,
          {
            y: [topCaculate, '-105%'],
            visibility: ['visible', 'hidden'],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),

        motion.animate(
          overlay_search,
          {
            opacity: [1, 0],
            visibility: ['visible', 'hidden'],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),
      ]).then(() => {
        setTimeout(() => {
          if (document.documentElement.classList.contains('open-minicart')) {
            document.documentElement.classList.remove('open-search');
          } else {
            document.documentElement.classList.remove(
              'open-drawer',
              'open-search'
            );
            root.style.removeProperty('padding-right');
          }
        }, 20);
      });
    },

    setupEventListeners: function () {
      const input = document.querySelector('input[type="search"]');
      const form = document.querySelector('form.search');
      if (!input || !form) return;
      form.addEventListener('submit', this.onFormSubmit.bind(this));
      input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      input.addEventListener('focus', this.onFocus.bind(this));
      document.addEventListener('focusout', this.onFocusOut.bind(this));
      document.addEventListener('keyup', this.onKeyup.bind(this));
    },

    debounce: function (fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },

    getQuery: function () {
      return document.querySelector('input[type="search"]').value.trim();
    },

    onChange: function () {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.close(true);
        return;
      }

      this.getSearchResults(searchTerm);
    },

    onFormSubmit: function (event) {
      if (
        !this.getQuery().length ||
        this.querySelector('[aria-selected="true"] a')
      )
        event.preventDefault();
    },

    onFocus: function () {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;
      if (
        document
          .querySelector('#predictive-search')
          .classList.contains('results')
      ) {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    },

    onFocusOut: function () {
      setTimeout(() => {
        if (!document.contains(document.activeElement)) this.close();
      });
    },

    onKeyup: function (event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();

      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    },

    switchOption: function (direction) {
      if (!this.isOpen) return;
      const moveUp = direction === 'up';
      const selectedElement = document.querySelector('#predictive-search [aria-selected="true"]');
      const allElements = document.querySelectorAll('#predictive-search li');
      let activeElement = document.querySelector('#predictive-search li');

      if (moveUp && !selectedElement) return;

      this.statusElement.textContent = '';

      if (!moveUp && selectedElement) {
        activeElement = selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement =
          selectedElement.previousElementSibling ||
          allElements[allElements.length - 1];
      }

      if (activeElement === selectedElement) return;

      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-activedescendant', activeElement.id);
    },

    selectOption: function () {
      const selectedProduct = document.querySelector(
        '#predictive-search [aria-selected="true"] a, #predictive-search [aria-selected="true"] button'
      );

      if (selectedProduct) selectedProduct.click();
    },

    getSearchResults: function (searchTerm) {
      if (!this._cachedResults) this._cachedResults = {};
      const queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();
      if (this._cachedResults[queryKey]) {
        this.renderSearchResults(this._cachedResults[queryKey]);
        return;
      }
      var loading = document.querySelector('.search__loading-state');
      var collection_suggest = document.querySelector('.collection-suggest');

      if (collection_suggest) {
        collection_suggest.style.display = 'none';
      }
      var section_id = 'search-predictive-grid';
      if (document.querySelector('.predictive_search_suggest')) {
        var search_url = `${
          routes?.predictive_search_url
        }?q=${encodeURIComponent(
          searchTerm
        )}&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=query,product,collection,page,article&section_id=${section_id}`;
      } else {
        var search_url = `${routes.search_url}?q=${encodeURIComponent(
          searchTerm
        )}&options[prefix]=last&options[unavailable_products]=last&type=query,product,collection,page,article&section_id=${section_id}`;
      }
      fetch(`${search_url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-' + section_id + '').innerHTML;
          this._cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
          BlsLazyloadImg.init();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    },

    setLiveRegionLoadingState: function () {
      document.querySelector('#search_mini_form').classList.add('loading');
      document.querySelector('#predictive-search').classList.add('loading');
    },

    setLiveRegionResults: function () {
      document.querySelector('#search_mini_form').classList.remove('loading');
      document.querySelector('#predictive-search').classList.remove('loading');
    },

    renderSearchResults: function (resultsMarkup) {
      document.querySelector('[data-predictive-search]').innerHTML =
        resultsMarkup;
      document.querySelector('#predictive-search').classList.add('results');
      if (document.querySelector('.search-not-sugges')) {
        document
          .querySelector('.search-not-sugges')
          .classList.remove('search-hidden');
        document.documentElement.classList.add('open-drawer', 'open-search');
        root.style.setProperty(
          'padding-right',
          getScrollBarWidth.init() + 'px'
        );
      }
      const quick_search = document.querySelector('#quick-search');
      if (quick_search) {
        quick_search.classList.add('hidden');
      }
      this.setLiveRegionResults();
      this.open();
    },

    open: function () {
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-expanded', true);
      this.isOpen = true;
    },

    close: function (clearSearchTerm = false) {
      if (clearSearchTerm) {
        document.querySelector('input[type="search"]').value = '';
        document
          .querySelector('#predictive-search')
          .classList.remove('results');
        if (document.querySelector('.search-not-sugges')) {
          document
            .querySelector('.search-not-sugges')
            .classList.add('search-hidden');
          document.documentElement.classList.remove(
            'open-drawer',
            'open-search'
          );
          root.style.removeProperty('padding-right');
        }

        const quick_search = document.querySelector('#quick-search');
        if (quick_search) {
          quick_search.classList.remove('hidden');
        }
      }
      const selected = document.querySelector('#predictive-search [aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', false);
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-activedescendant', '');
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false;
      document
        .querySelector('[data-predictive-search]')
        .removeAttribute('style');
      this.isOpen = false;
    },
  };
})();
BlsSearchShopify.init();
class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    const header = document.querySelector('header');
    const button_search_default = document.querySelector(
      '#button_search_default'
    );
    if (
      header.classList.contains('popup-search-mobile') &&
      this.classList.contains('search_type_default')
    ) {
      let sectionId = 'top-search';
      if (window.innerWidth <= 767) {
        _this.fetchUrl(
          `${window.location.pathname}?section_id=${sectionId}&type=popup&ajax=1`,
          'popup'
        );
        button_search_default.classList.add('top-search-toggle');
      }
      let width = window.innerWidth;
      window.addEventListener('resize', function () {
        const newWidth = window.innerWidth;

        if (newWidth <= 767 && width > 767) {
          const overlay_search = document.querySelector('.overlay_search');
          overlay_search.style.visibility = 'hidden';
          overlay_search.style.opacity = 0;
          overlay_search.classList.remove('open');
          _this.fetchUrl(
            `${window.location.pathname}?section_id=${sectionId}&type=popup&ajax=1`,
            'popup'
          );
          button_search_default.classList.add('top-search-toggle');
        }
        if (newWidth > 767 && width <= 767) {
          button_search_default.classList.remove('top-search-toggle');
          _this.fetchUrl(
            `${window.location.pathname}?section_id=${sectionId}&type=default&ajax=1`
          );
          var popup_search_form_popup = document.querySelector(
            '.search__type-popup'
          );
          if (popup_search_form_popup) {
            popup_search_form_popup.style.display = 'none';
          }
        }
        width = newWidth;
      });
    } else {
      let width = window.innerWidth;
      window.addEventListener('resize', function () {
        const newWidth = window.innerWidth;
        var popup_search_form_popup = document.querySelector(
          '.search__type-popup'
        );
        if (newWidth <= 767 && width > 767) {
          if (
            popup_search_form_popup &&
            !document.documentElement.classList.contains('open-search')
          ) {
            popup_search_form_popup.style.display = 'none';
            setTimeout(() => {
              popup_search_form_popup.style.display = 'block';
            }, 20);
          }
        }
        if (newWidth > 767 && width <= 767) {
          if (
            popup_search_form_popup &&
            !document.documentElement.classList.contains('open-search')
          ) {
            popup_search_form_popup.style.display = 'none';
            setTimeout(() => {
              popup_search_form_popup.style.display = 'block';
            }, 20);
          }
        }

        width = newWidth;
      });
    }
  }
  fetchUrl(url, type = 'default') {
    var input = document.querySelector('.search__input');
    if (type == 'default') {
      input.setAttribute('type', 'search');
    } else {
      input.removeAttribute('type');
    }
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('header-search').innerHTML;
        document.querySelector('header-search').innerHTML = newSection;
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        if (document.documentElement.classList.contains('open-search')) {
          document.documentElement.classList.remove(
            'open-search',
            'open-drawer'
          );
        }
        BlsSearchShopify.init();
      });
  }
}

customElements.define('header-search', HeaderSearch);

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('minicart_wrapper');
    this.giftwrap = document.querySelector('.add-giftwrap');
    this.cartCountDown = document.querySelector('.cart-countdown-time');
    this.minicart__wrapper =
      this.notification.querySelector('.minicart__wrapper');
    this.cartUpsellBeside = document.querySelector('.recommendations-beside');
    this.startTime = Date.now();
    // EAA/ADA: announce cart count changes to screen readers
    document.querySelectorAll('.cart-count').forEach((el) => {
      if (!el.hasAttribute('aria-live')) el.setAttribute('aria-live', 'polite');
      if (!el.hasAttribute('aria-atomic')) el.setAttribute('aria-atomic', 'true');
    });
    this.querySelectorAll('.minicart__wrapper .close-cart-button').forEach(
      (closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
    );
    document.querySelectorAll('.minicart__action').forEach((navToggle) => {
      navToggle.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          if (
            this.notification
              .querySelector('.minicart__wrapper')
              .classList.contains('open')
          ) {
            this.close();
          } else {
            this.open();
          }
        },
        false
      );
    });
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.notification.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );
    this.cartAction();
    this.addonsUpdate();
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target != this &&
      !target.closest('.header__minicart') &&
      !target.closest('cart-notification') &&
      !target.closest('.cart-quick-edit-modal') &&
      !target.closest('.tingle-modal')
    ) {
      this.close();
    }
  }

  cartAction() {

    //Tayler added.... for fix the bug regarding the checkout button bug 20251022
    const checkoutButton = this.querySelector('.btn-checkout');
    if (checkoutButton) {
      if (!checkoutButton.dataset.handlerAttached) {
        
        const buttonSpan = checkoutButton.querySelector('span');
        if (buttonSpan) {
          checkoutButton.dataset.originalText = buttonSpan.textContent;
        }

        checkoutButton.addEventListener('click', (event) => {
          event.preventDefault();
          if (!buttonSpan) return;

          checkoutButton.setAttribute('disabled', true);
          checkoutButton.classList.add('custom-loading');

          // "Generating offer..." 
          let loadingText = 'Generating offer';
          buttonSpan.textContent = loadingText;
          let dotCount = 0;

          checkoutButton.dataset.intervalId = setInterval(() => {
            dotCount = (dotCount + 1) % 4;
            buttonSpan.textContent = loadingText + '.'.repeat(dotCount);
          }, 400);

          setTimeout(() => {
            window.location.href = '/checkout';
          }, 200);
        });

        checkoutButton.dataset.handlerAttached = 'true';
      }
    }

    //Tayler added.... for fix the bug regarding the checkout button bug 20251022
    if (!window.isCheckoutResetAttached) {
      window.addEventListener('pageshow', (event) => {
        document.querySelectorAll('.btn-checkout.custom-loading').forEach((btn) => {
          btn.removeAttribute('disabled');
          btn.classList.remove('custom-loading');
          
          if (btn.dataset.intervalId) {
            clearInterval(btn.dataset.intervalId);
            delete btn.dataset.intervalId;
          }

          const span = btn.querySelector('span');
          if (span && btn.dataset.originalText) {
            span.textContent = btn.dataset.originalText;
          }
        });
      });
      window.isCheckoutResetAttached = true;
    }

    this.querySelectorAll('.close-cart').forEach((navToggle) => {
      navToggle.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          if (
            this.notification
              .querySelector('.minicart__wrapper')
              .classList.contains('open')
          ) {
            this.close();
          }
        },
        false
      );
    });
    this._boundCartAddons = this._boundCartAddons || this.cartAddons.bind(this);
    this._boundCartAddonsSave = this._boundCartAddonsSave || this.cartAddonsSave.bind(this);

    this.querySelectorAll('.cart-addons button').forEach((button) => {
      button.removeEventListener('click', this._boundCartAddons, false);
      button.addEventListener('click', this._boundCartAddons, false);
    });

    document.querySelectorAll('.addon-actions .btn-save').forEach((button) => {
      button.removeEventListener('click', this._boundCartAddonsSave, false);
      button.addEventListener('click', this._boundCartAddonsSave, false);
    });

    this.querySelectorAll('.add-giftwrap').forEach((giftwrap) => {
      giftwrap.removeEventListener(
        'click',
        this.addGiftwrapClick.bind(this),
        false
      );
      giftwrap.addEventListener(
        'click',
        this.addGiftwrapClick.bind(this),
        false
      );
    });

    this.querySelectorAll('.addon-actions .btn-cancel').forEach(
      (addonCancel) => {
        addonCancel.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            target.closest('.cart__addon-content').classList.remove('is-open');
            target
              .closest('.minicart__wrapper')
              .querySelector('.open')
              .classList.remove('open');
          },
          false
        );
      }
    );
  }

  addonsUpdate() {
    const address_country = document.getElementById('address_country');
    const address_province = document.getElementById('address_province');
    if (address_country && address_province) {
      new Shopify.CountryProvinceSelector(
        'address_country',
        'address_province',
        { hideElement: 'address_province_container' }
      );
    }

    const discount_code = document.querySelector('.discount_code');
    const code = localStorage.getItem('discount_code');
    if (code && discount_code) {
      document.querySelector('.discount_code').value = code;
    }
  }

  cartAddons(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const open = target.getAttribute('data-open');
    if (!document.getElementById(open).classList.contains('is-open')) {
      document.getElementById(open).classList.add('is-open');
      target.classList.add('open');
      if (open == 'shipping') {
        const address_country = document.getElementById('address_country');
        const address_province = document.getElementById('address_province');
        if (address_country && address_province) {
          new Shopify.CountryProvinceSelector(
            'address_country',
            'address_province',
            { hideElement: 'address_province_container' }
          );
        }
      }
    } else {
      document.getElementById(open).classList.remove('is-open');
      target.classList.remove('open');
    }
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  }

  cartAddonsSave(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const action = target.getAttribute('data-action');
    if (action == 'note') {
      const body = JSON.stringify({
        note: document.querySelector('.cart-note').value,
      });
      fetch(`${routes?.cart_update_url}`, {
        ...this.fetchConfig(),
        ...{ body },
      });
      document.getElementById(action).classList.remove('is-open');
      target
        .closest('.minicart__wrapper')
        .querySelector('.open')
        .classList.remove('open');
    } else if (action == 'shipping') {
      var e = {};
      (e.zip = document.querySelector('#AddressZip').value || ''),
        (e.country = document.querySelector('#address_country').value || ''),
        (e.province = document.querySelector('#address_province').value || ''),
        this._getCartShippingRatesForDestination(e);
    }
  }

  _getCartShippingRatesForDestination(event) {
    fetch(
      `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${event.zip}&shipping_address%5Bcountry%5D=${event.country}&shipping_address%5Bprovince%5D=${event.province}`
    )
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const message = document.querySelector('.addon-message');
        for (var item of document.querySelectorAll('.addon-message p')) {
          item.remove();
        }
        const { showDeliveryDays, deliveryDayOne, deliveryDaysOther } =
          message.dataset;
        const parsedState = JSON.parse(state);
        if (parsedState && parsedState.shipping_rates) {
          if (parsedState.shipping_rates.length > 0) {
            message.classList.remove('error', 'warning');
            message.classList.add('success');
            const p = document.createElement('p');
            p.innerText = cartStrings?.shipping_rate.replace(
              '{{address}}',
              event.zip + ', ' + event.country + ' ' + event.province
            );
            message.appendChild(p);
            parsedState.shipping_rates.map((rate) => {
              let daysShipping = '';
              if (rate.delivery_days.length > 0 && showDeliveryDays == 'true') {
                let typeDay = deliveryDayOne;
                const day = rate.delivery_days[0];
                const dayAt = rate.delivery_days.at(-1);
                if (day > 1) typeDay = deliveryDaysOther;
                if (day === dayAt) {
                  daysShipping = `(${day} ${typeDay})`;
                } else {
                  daysShipping = `(${day} - ${dayAt} ${typeDay})`;
                }
              }
              const rateNode = document.createElement('p');
              rateNode.innerHTML =
                rate.name +
                ': ' +
                Shopify.formatMoney(rate.price, cartStrings?.money_format) +
                ' ' +
                daysShipping;
              message.appendChild(rateNode);
            });
          } else {
            message.classList.remove('error', 'success');
            message.classList.add('warning');
            const p = document.createElement('p');
            p.innerText = cartStrings?.no_shipping;
            message.appendChild(p);
          }
        } else {
          message.classList.remove('success', 'warning');
          message.classList.add('error');
          Object.entries(parsedState).map((error) => {
            const message_error = `${error[1][0]}`;
            const p = document.createElement('p');
            p.innerText = message_error;
            message.appendChild(p);
          });
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  addGiftwrapClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const variant_id = target.getAttribute('data-variant-id');
    const config = fetchConfig('json');
    config.body = JSON.stringify({
      id: Number(variant_id),
      quantity: 1,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    target.classList.add('loading');
    fetch(`${routes?.cart_add_url}`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        fetch('/cart.json')
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll('.cart-count').forEach((el) => {
                if (el.classList.contains('cart-count-drawer')) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector('header-total-price')) {
                document.querySelector('header-total-price').updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                'free-ship-progress-bar'
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          const html = new DOMParser().parseFromString(
            parsedState.sections[section.id],
            'text/html'
          );
          elementToReplace.innerHTML =
            html.querySelector('#minicart-form').innerHTML;
        });
        this.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        BlsLazyloadImg.init();
        document.querySelector('.add-giftwrap').classList.remove('loading');
      });
  }

  onChange(event) {
    if (event.target.getAttribute('name') == 'updates[]')
      this.updateQuantity(
        event.target.dataset.id,
        event.target.value,
        event.target.dataset.value,
        event.target,
        document.activeElement.getAttribute('name')
      );
  }

  updateQuantity(id, quantity, currentQuantity, _this, name) {
    quantity = quantity ? quantity : 0;
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    const selector = `mini-cart-remove-button[data-index="${id}"]`;
    const cart_select = `minicart-wishlist-action[data-index="${id}"]`;

    const minicart_wishlist_action = this.querySelector(cart_select);
    if (minicart_wishlist_action) {
      minicart_wishlist_action.classList.add('loading');
    }
    const cart_item = this.querySelector(selector);
    cart_item.classList.add('loading');
    const cartRecommend = document.querySelector('.cart-recommend');
    if (cartRecommend && cartRecommend.classList.contains('open')) {
      cartRecommend.classList.remove('open');
    }
    const cart_free_ship = document.querySelector('free-ship-progress-bar');
    fetch(`${routes?.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) {
          this.updateMessageErrors(id, parsedState.errors, _this);
          return;
        }
        if (parsedState.item_count != undefined) {
          document.querySelectorAll('.cart-count').forEach((el) => {
            if (el.classList.contains('cart-count-drawer')) {
              el.innerHTML = `(${parsedState.item_count})`;
            } else {
              el.innerHTML =
                parsedState.item_count > 100 ? '~' : parsedState.item_count;
            }
          });
          if (document.querySelector('header-total-price')) {
            document
              .querySelector('header-total-price')
              .updateTotal(parsedState);
          }
        }
        if (document.querySelector('.quantity__label')) {
          const items = parsedState.items;
          const pro_id = document
            .querySelector('.quantity__label')
            .getAttribute('data-pro-id');
          var variant_id, variant_quantity;
          items.forEach(function (item) {
            variant_id = item.variant_id;
            if (variant_id == pro_id) {
              document.querySelector('.quantity-cart').innerHTML =
                item.quantity;
              document
                .querySelector('.quantity__label')
                .classList.remove('hidden');
              variant_quantity = pro_id;
              return;
            }
          });
          if (!variant_quantity) {
            document.querySelector('.quantity-cart').innerHTML = 0;
            document.querySelector('.quantity__label').classList.add('hidden');
          }
        }

        if (document.querySelector('header-total-price')) {
          document.querySelector('header-total-price').updateTotal(parsedState);
        }
        if (parsedState.item_count == 0 && this.cartCountDown) {
          this.cartCountDown.querySelector('countdown-timer').remove();
        }
        if (parsedState.item_count == 0 && this.cartUpsellBeside) {
          if (this.cartUpsellBeside.classList.contains('is-open')) {
            this.cartUpsellBeside.classList.remove('is-open');
          }
        }
        if (!parsedState.error && parsedState.item_count != undefined) {
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              'text/html'
            );
            elementToReplace.innerHTML =
              html.querySelector('#minicart-form').innerHTML;
            if (cart_free_ship) {
              cart_free_ship.init(parsedState.items_subtotal_price);
            }
          });
        }
        this.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        BlsLazyloadImg.init();
        cart_item.classList.remove('loading');
        if (minicart_wishlist_action) {
          minicart_wishlist_action.classList.remove('loading');
        }
        setTimeout(() => {
          this.cart = document.querySelector('cart-notification');
        }, 500);
        const cartRecommend = document.querySelector('.cart-recommend');
        if (
          cartRecommend &&
          !cartRecommend.classList.contains('hidden-recommend')
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem =
              document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll(
              '.swiper-cart-upsell .swiper-slide'
            );
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add('open');
              }, 800);
            } else if (cartUpsellSlide.length === 0) {
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          } else {
            setTimeout(function () {
              cartRecommend.classList.add('open');
            }, 800);
          }
        }
      });
  }

  updateMessageErrors(line, message, target) {
    const val = target.dataset.value;
    target.value = val;
    const lineItemError = document.getElementById(
      `CartDrawer-LineItemError-${line}`
    );
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').textContent =
        message;
  }

  async open() {
    if (!this.notification.classList.contains('go_to_cart_page')) {
      if (this.classList.contains('show_popup')) {
        this.cart_icon = document.querySelector('header');
        this.minicart__wrapper.style.top = `calc(${
          this.cart_icon.getBoundingClientRect().bottom
        }px)`;
      }
      let delay;
      if (document.documentElement.classList.contains('open-search')) {
        delay = new Promise((resolve) => setTimeout(resolve, 650));
      }
      delay && (await delay);
      this.notification
        .querySelector('.minicart__wrapper')
        .classList.add('open');
      this.notification.classList.add('open');
      setTimeout(() => {
        if (!this.classList.contains('show_popup')) {
          document.documentElement.classList.add(
            'open-drawer',
            'open-minicart'
          );
          if (this.notification.classList.contains('open_drawer')) {
            root.style.setProperty(
              'padding-right',
              getScrollBarWidth.init() + 'px'
            );
          }
        }
      }, 100);

      BlsLazyloadImg.init();
    } else {
      this.notification.querySelector('a').click();
    }
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.querySelector('.minicart__wrapper').classList.remove('open');
    const cartRecommend = document.querySelector('.cart-recommend');
    let time = 0;
    if (cartRecommend && cartRecommend.classList.contains('open')) {
      time = 500;
      cartRecommend.classList.remove('open');
    }

    setTimeout(() => {
      this.notification.classList.remove('open');
      this.notification
        .querySelector('.minicart__wrapper')
        .classList.remove('open');
      document.documentElement.classList.remove('open-minicart');
    }, time);
    setTimeout(() => {
      root.style.removeProperty('padding-right');
      document.documentElement.classList.remove('open-drawer');
      if (document.querySelector('minicart-recommendations-beside')) {
        document
          .querySelector('minicart-recommendations-beside')
          .classList.remove('open');
      }
    }, time + 550);
    document.body.removeEventListener('click', this.onBodyClick);
    for (var item of document.querySelectorAll('.addon')) {
      item.classList.remove('is-open');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'minicart-form',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-notification', CartNotification);

class MinicartItemEdit extends PopupBase {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const key = this.getAttribute('data-key');
      const quantity = this.getAttribute('data-quantity');
      const href = this.getAttribute('href');
      const variant =
        href.indexOf('?') > -1 ||
        href.indexOf('?variant=') > -1 ||
        href.indexOf('&variant=') > -1
          ? '&'
          : '/?';
      fetch(`${window.shopUrl}${href}${variant}section_id=cart-quick-edit`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((response) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(response, 'text/html')
            .getElementById('shopify-section-cart-quick-edit');
          this.initPopup(
            resultsMarkup,
            `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
          );
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          BlsLazyloadImg.init();
          if (document.querySelector('[data-template-quick-cart-edit]')) {
            document
              .querySelector('[data-template-quick-cart-edit]')
              .setAttribute('data-line', key);
          }
          if (
            document.querySelector(
              '.product-form-quick-edit quantity-input input'
            )
          ) {
            document.querySelector(
              '.product-form-quick-edit quantity-input input'
            ).value = quantity;
          }
        });
    });
  }
}
customElements.define('minicart-item-edit', MinicartItemEdit);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ||
    event.target.closest('button').name === 'plus'
      ? this.input.stepUp()
      : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    const orders = this.dataset.order;
    this.init(orders);
  }
  init(orders) {
    const fe_unavaiable = this.dataset.feUnavaiable;
    const fe_avaiable = this.dataset.feAvaiable;
    const rate = Number(Shopify.currency.rate);
    const min = Number(this.dataset.feAmount);
    if (!min || !rate) return;
    const order = Number(orders) / 100;
    const min_by_currency = min * rate;
    if (order == undefined) return;
    if ((order / min_by_currency) * 100 > 100) {
      this.setProgressBar(100);
    } else {
      this.setProgressBar((order / min_by_currency) * 100);
    }
    this.setProgressBarTitle(
      order,
      min_by_currency,
      fe_unavaiable,
      fe_avaiable
    );
  }
  setProgressBarTitle(order, min_by_currency, fe_unavaiable, fe_avaiable) {
    const title = this.querySelector('.free-shipping-message');
    if (!title) return;
    title.classList.remove('opacity-0');
    if (order >= min_by_currency) {
      title.innerHTML = fe_avaiable;
    } else {
      const ammount = '{{ amount }}';
      title.innerHTML = fe_unavaiable.replace(
        ammount.trim(),
        Shopify.formatMoney(
          (min_by_currency - order) * 100,
          cartStrings.money_format
        )
      );
    }
  }
  setProgressBar(progress) {
    const p = this.querySelector('.progress');
    p.style.width = progress + '%';
    if (progress === 100) {
      this.classList.add('cart_shipping_free');
    } else {
      this.classList.remove('cart_shipping_free');
    }
  }
}
customElements.define('free-ship-progress-bar', ProgressBar);

//Tayler upgraded it.... 20260228
class OpenChildrenToggle extends HTMLElement {
  constructor() {
    super();
    
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.isDragging = false;
    this.threshold = 10; 

    this.wasToggledByTouch = false;

    this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
    this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });
    this.addEventListener('touchend', this.handleTouchEnd.bind(this));
    this.addEventListener('click', this.handleClick.bind(this));
    this.addEventListener('keydown', this.handleKeyDown.bind(this));
  }
  
  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchStartY = e.touches[0].clientY;
    this.isDragging = false;
    this.wasToggledByTouch = false;
  }

  handleTouchMove(e) {
    if (this.isDragging) return;

    const deltaX = Math.abs(e.touches[0].clientX - this.touchStartX);
    const deltaY = Math.abs(e.touches[0].clientY - this.touchStartY);

    if (deltaX > this.threshold || deltaY > this.threshold) {
      this.isDragging = true;
    }
  }

  handleTouchEnd(e) {
    if (!this.isDragging) {
      e.preventDefault(); 
      this.onToggle();
      this.wasToggledByTouch = true;
    }
  }

  handleClick(e) {
    if (this.wasToggledByTouch) {
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    this.onToggle();
  }

  handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); 
      this.onToggle();
    }
  }

  onToggle() {
    const parent = this.parentElement;
    if (parent) {
      const isOpen = parent.classList.contains('is-open');
      
      if (!isOpen) {
        parent.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true'); 
      } else {
        parent.classList.remove('is-open');
        this.setAttribute('aria-expanded', 'false');
      }
    }
  }
}
customElements.define('open-children-toggle', OpenChildrenToggle);

class CloseMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClose.bind(this), false);
  }
  onClose() {
    document.querySelector('.nav-toggle').classList.remove('open');
    document.querySelectorAll('menu-item').forEach((item) => {
      item.classList.remove('is-open');
    });
    document.documentElement.classList.remove('nav-open');
    setTimeout(() => {
      document.documentElement.classList.remove('open-drawer');
      root.style.removeProperty('padding-right');
    }, 400);
  }
}
customElements.define('close-menu', CloseMenu);

/* Tayler upgraded it for performance.... 20250913 */
/*class ReviewProduct extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;

    if (document.body.classList.contains('index')) {
      this.fetchDataReviewProduct();
      window.addEventListener('scroll', () => {
        this.fetchDataReviewProduct();
      });
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains('review-lazy')) {
        this.fetchDataReviewProduct();
      }
    } else {
      this.fetchDataReviewProduct();
    }
  }
  fetchDataReviewProduct() {
    if (!this.classList.contains('review-product-added')) {
      return;
    }
    this.classList.remove('review-product-added');
    this.innerHTML = this.querySelector('.product-review-json').innerHTML;
    this.classList.remove('inline-loading');
  }
}
customElements.define('review-product', ReviewProduct);*/
class ReviewProduct extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    this.initialized = false; 
    
    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        this.fetchDataReviewProduct();
        observer.unobserve(this);
      }
    }, {
      // rootMargin: '200px' 
    });

    observer.observe(this);
  }

  fetchDataReviewProduct() {
    if (this.initialized || !this.classList.contains('review-product-added')) {
      return;
    }
    this.initialized = true;
    
    this.classList.remove('review-product-added');
    const reviewJsonEl = this.querySelector('.product-review-json');
    if (reviewJsonEl) {
      this.innerHTML = reviewJsonEl.innerHTML;
    }
    this.classList.remove('inline-loading');
  }
}
customElements.define('review-product', ReviewProduct);

class BackMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onBackMenu.bind(this), false);
  }
  onBackMenu() {
    if (this.classList.contains('back-lv1')) {
      this.closest('.level-1')
        .querySelector('menu-item')
        .classList.remove('is-open');
    } else {
      this.closest('.level0')
        .querySelector('menu-item')
        .classList.remove('is-open');
    }
  }
}
customElements.define('back-menu', BackMenu);

var BlsLoginPopup = (function () {
  return {
    init: function () {
      this.showLogin();
    },
    clickTab: function (modal) {
      const hidden = document.querySelectorAll('[data-login-hidden]');
      const show = document.querySelectorAll('[data-login-show]');
      const iTitle = document.querySelector('#login-popup .login-heading');
      show.forEach((e) => {
        var s = e?.dataset.loginShow;
        e.addEventListener('click', function (el) {
          el.preventDefault();
          hidden.forEach((eh) => {
            var h = eh?.dataset.loginHidden;
            if (eh.getAttribute('aria-hidden') === 'true' && s === h) {
              eh.setAttribute('aria-hidden', 'false');
              if (iTitle) {
                iTitle.innerText = s;
              }
            } else {
              eh.setAttribute('aria-hidden', 'true');
            }
          });
        });
      });
    },
    showLogin: function () {
      const action = document.querySelector('.action-login-popup');
      const _this = this;
      if (action) {
        action.addEventListener('click', (e) => {
          e.preventDefault();
          _this.fetchDataLogin();
        });
      }
    },
    fetchDataLogin: function () {
      const url = `${window.location.pathname}?section_id=login-popup`;
      const _this = this;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = parser.parseFromString(responseText, 'text/html');
          const content = html.querySelector('#login-popup');
          if (content) {
            const modal = new tingle.modal({
              footer: false,
              stickyFooter: false,
              closeMethods: ['overlay', 'button', 'escape'],
              closeLabel: 'Close',
              cssClass: ['login-popup-modal'],
              onOpen: function () {},
              onClose: function () {},
              beforeOpen: function () {},
              beforeClose: function () {
                return true;
              },
            });
            modal.setContent(content);
            modal.open();

            document
              .querySelectorAll('.login__popup-button-close')
              .forEach((navToggle) => {
                navToggle.addEventListener(
                  'click',
                  (e) => {
                    e.preventDefault();
                    modal.close();
                  },
                  false
                );
              });
          }
          _this.clickTab();
        })
        .catch((e) => {
          throw e;
        });
    },
  };
})();
BlsLoginPopup.init();

class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.backToTop.bind(this), false);
  }

  connectedCallback() {
    this._scrollHandler = this.updateScrollPercentage.bind(this);
    window.addEventListener('scroll', this._scrollHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._scrollHandler);
  }

  backToTop() {
    if (document.documentElement.scrollTop > 0 || document.body.scrollTop > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  updateScrollPercentage() {
    const scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    this.style.setProperty('--height', scrollPercentage.toFixed(2) + '%');
    if (scrollTop > 200) {
      this.classList.add('show');
    } else {
      this.classList.remove('show');
    }
  }
}
customElements.define('back-to-top', BackToTop);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector('.button-localization'),
      panel: this.querySelector('ul'),
    };
    // Compatibility: Check if elements exist before adding event listeners
    if (this.elements.button) {
      this.elements.button.addEventListener(
        'click',
        this.openSelector.bind(this)
      );
      this.elements.button.addEventListener(
        'focusout',
        this.closeSelector.bind(this)
      );
    }
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    const links = this.querySelectorAll('a');
    if (links && links.length > 0) {
      links.forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      );
    }
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target != this && !target.closest('localization-form')) {
      this.hidePanel();
    }
  }

  hidePanel() {
    document.body.removeEventListener('click', this.onBodyClick);
    this.elements.button.classList.remove('open');
    this.elements.button.setAttribute('aria-expanded', 'false');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button.classList.contains('open')) {
      this.hidePanel();
    } else {
      document.body.addEventListener('click', this.onBodyClick);
      this.elements.button.focus();
      for (var item of document.querySelectorAll('.button-localization')) {
        item.classList.remove('open');
      }
      this.elements.button.classList.add('open');
      this.elements.button.setAttribute('aria-expanded', 'true');
    }
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

class CollapsibleBlock extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const block = _this.querySelectorAll('.collapsible-heading');
    block.forEach((trigger) => {
      if (trigger.hasAttribute('aria-controls')) {
        trigger.setAttribute(
          'aria-expanded',
          _this.classList.contains('active') ? 'true' : 'false'
        );
      }
      trigger.addEventListener('click', (e) => {
        const target = e.currentTarget;
        const parent = target.parentElement;
        const footerContent = parent.querySelector('.collapsible-content');
        if (!footerContent) return;

        const collectionFilter = _this.closest(
          '.collection-filter.horizontal'
        );
        const shouldExpand = !_this.classList.contains('active');
        if (collectionFilter && window.innerWidth > 1024) {
          collectionFilter
            .querySelectorAll('collapsible-block.active')
            .forEach((collapsible) => {
              if (collapsible !== _this) {
                this.setExpanded(collapsible, false);
              }
            });
          this.setExpanded(_this, shouldExpand);
        } else {
          slideAnime({
            target: footerContent,
            animeType: 'slideToggle',
          });
          this.setExpanded(_this, shouldExpand);
        }
        if (!target.hasAttribute('aria-controls')) {
          target.setAttribute(
            'aria-expanded',
            _this.classList.contains('active') ? 'true' : 'false'
          );
        }
      });
      trigger.addEventListener('keydown', (e) => {
        const collectionFilter = _this.closest(
          '.collection-filter.horizontal'
        );
        if (
          e.key === 'Escape' &&
          collectionFilter &&
          window.innerWidth > 1024 &&
          _this.classList.contains('active')
        ) {
          e.preventDefault();
          this.setExpanded(_this, false);
          trigger.focus();
        }
      });
    });
    // Store bound handlers so they can be removed in disconnectedCallback
    this._bodyClickHandler = this.handleBodyClick.bind(this);
    document.body.addEventListener('click', this._bodyClickHandler);
    if (this.classList.contains('collection')) {
      this.actionInMobile();
      this._resizeHandler = () => { this.actionInMobile(); };
      window.addEventListener('resize', this._resizeHandler);
    }
  }

  disconnectedCallback() {
    document.body.removeEventListener('click', this._bodyClickHandler);
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
  }

  setExpanded(collapsible, expanded) {
    collapsible.classList.toggle('active', expanded);
    const trigger = collapsible.querySelector(
      '.collapsible-heading[aria-controls]'
    );
    if (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  actionInMobile() {
    var _this = this;
    var width = window.innerWidth;
    if (width <= 1024) {
      const footerContent = _this.querySelector('.collapsible-content');
      if (footerContent) footerContent.style.display = 'block';
      this.setExpanded(_this, true);
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    const collectionFilter = this.closest('.collection-filter.horizontal');
    if (
      target != this &&
      !target.closest('collapsible-block') &&
      collectionFilter &&
      window.innerWidth > 1024
    ) {
      const block = collectionFilter.querySelectorAll('collapsible-block');
      block.forEach((collapsible) => {
        this.setExpanded(collapsible, false);
      });
    }
  }
}
customElements.define('collapsible-block', CollapsibleBlock);

class StickyElement extends HTMLElement {
  constructor() {
    super();
    this.collapsibleHeading = this.querySelector('.collapsible-bundle');
    this.contentWrapper = this.querySelector('.bundle-items__wrapper');
    this.isOpen = true;
    this.isMobile = window.innerWidth <= 1024;
    this.init();
  }
  
  init() {
    if (this.isMobile) {
      this.setupCollapsible();
    }
    
    window.addEventListener('resize', this.onResize.bind(this));
  }
  
  setupCollapsible() {
    if (!this.collapsibleHeading || !this.contentWrapper) return;
    
    if (this.isMobile) {
      this.isOpen = false;
      this.contentWrapper.style.display = 'none';
      this.classList.remove('opened');
    }
    
    if (!this.collapsibleHeading.hasEventListener) {
      this.collapsibleHeading.hasEventListener = true;
      this.collapsibleHeading.addEventListener('click', this.toggleCollapse.bind(this));
    }
  }
  
  toggleCollapse(event) {
    if (!this.isMobile) return;
    
    event.preventDefault();
    
    this.isOpen = !this.isOpen;
    
    slideAnime({
      target: this.contentWrapper,
      animeType: 'slideToggle',
      parent: this
    });
  }
  
  onResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 1024;
    
    if (wasMobile !== this.isMobile) {
      if (this.isMobile) {
        this.setupCollapsible();
      } else {
        if (this.contentWrapper) {
          this.contentWrapper.style.display = 'block';
          this.contentWrapper.style.height = 'auto';
        }
      }
    }
  }
  
  showContent() {
    if (this.isMobile && !this.isOpen && this.contentWrapper) {
      this.isOpen = true;
      slideAnime({
        target: this.contentWrapper,
        animeType: 'slideDown',
        parent: this
      });
      this.classList.add('opened');
    }
  }
}

customElements.define('sticky-element', StickyElement);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const close = _this.querySelector('.announcement-bar-close');
    if (!close) {
      return;
    }
    close.addEventListener('click', (e) => {
      slideAnime({
        target: _this,
        animeType: 'slideToggle',
      });
      sessionStorage.setItem('announcement_bar', 'false');
    });
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.btn = this.querySelector('.custom-play-pause-btn');
    this.playIcon = this.querySelector('.play-icon');
    this.pauseIcon = this.querySelector('.pause-icon');
    this.thumb = this.querySelector('.video-thumbnail');
    this.video_iframe = this.querySelector('.video-has-bg iframe');
    
    this.initCustomControls();
    this.init();
  }

  ensureLazySourcesLoaded() {
    const video = this.video;
    if (!video) return Promise.resolve();

    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    }

    const sources = video.querySelectorAll('source');
    let hadLazy = false;
    sources.forEach((source) => {
      const realSrc =
        source.getAttribute('data-video-src') ||
        source.getAttribute('data-src') ||
        source.getAttribute('srcset');
      if (realSrc) {
        source.src = realSrc;
        source.removeAttribute('data-video-src');
        source.removeAttribute('data-src');
        source.removeAttribute('srcset');
        hadLazy = true;
      }
    });

    if (hadLazy || video.classList.contains('lazy-video-item')) {
      video.classList.remove('lazy-video-item');
      video.load();
      return new Promise((resolve) => {
        const done = () => resolve();
        if (video.readyState >= 2) {
          done();
          return;
        }
        video.addEventListener('loadeddata', done, { once: true });
        video.addEventListener('error', done, { once: true });
        setTimeout(done, 8000);
      });
    }
    return Promise.resolve();
  }

  initCustomControls() {
    if (!this.video || !this.btn) return;

    this.btn.addEventListener('click', () => {
      if (this.video.paused) {
        this.ensureLazySourcesLoaded().then(() => {
          this.video.muted = false;
          const p = this.video.play();
          if (p !== undefined) {
            p.catch(() => {});
          }
        });
      } else {
        this.video.pause();
      }
    });

    this.video.addEventListener('play', () => this.updateIcons(true));
    this.video.addEventListener('pause', () => this.updateIcons(false));
    this.video.addEventListener('ended', () => this.updateIcons(false));
  }

  updateIcons(isPlaying) {
    if (!this.btn) return;
    if (isPlaying) {
      this.playIcon.classList.add('hidden');
      this.pauseIcon.classList.remove('hidden');

      this.btn.setAttribute('aria-label', 'Pause video');
    } else {
      this.playIcon.classList.remove('hidden');
      this.pauseIcon.classList.add('hidden');
      this.btn.setAttribute('aria-label', 'Play video');
    }
  }

  init() {
    if (this.video_iframe) {
      this.video_iframe.addEventListener('load', () => {
        if (this.thumb) {
          this.thumb.remove();
        }
      });
    }
  }
}
customElements.define('video-section', VideoSection);

class AgeVerifier extends HTMLElement {
  constructor() {
    super();
    this.ageVerifyDetail = this.querySelector('.age-verify-detail');
    this.declineVerifyDetail = this.querySelector('.decline-verify-detail');
    this.init();
    this.mainFunction();
  }
  init() {
    const _this = this;
    if (!Shopify.designMode) {
      if (!getCookie('age_verifier')) {
        this.classList.add('active');
        this.declineVerifyDetail.classList.add('hidden');
        this.ageVerifyDetail.classList.remove('hidden');
      } else {
        if (getCookie('age_verifier') == 'false') {
          this.classList.add('active');
          this.declineVerifyDetail.classList.remove('hidden');
          this.ageVerifyDetail.classList.add('hidden');
        } else {
          this.remove();
        }
      }
    }
  }

  mainFunction() {
    const approve = this.querySelector('.age-verifier-approve');
    const decline = this.querySelector('.age-verifier-decline');
    const returnBtn = this.querySelector('.age-verifier-return');
    if (returnBtn) {
      returnBtn.addEventListener('click', () => this.handleReturn());
    }

    if (!approve || !decline) return;
    approve.addEventListener('click', () => this.handleApprove());
    decline.addEventListener('click', () => this.handleDecline());
  }
  handleReturn() {
    if (!Shopify.designMode) {
      setCookie('age_verifier', 'false', '-1');
      this.init();
    }
  }
  handleDecline() {
    if (!Shopify.designMode) {
      setCookie('age_verifier', 'false', '365');
      this.init();
    }
  }
  handleApprove() {
    setCookie('age_verifier', 'true', 'false');
    this.classList.add('fadeOut');
    setTimeout(() => {
      this.remove();
    }, 1000);
  }
}
customElements.define('age-verifier', AgeVerifier);

class PromotionPopup extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init();
    }, 15000);
  }

  init() {
    const _this = this;
    const s = _this?.dataset.show;
    const m = _this?.dataset.showMb === 'true';
    if (!Shopify.designMode) {
      if (s === 'show-on-all-pages' || s === 'show-on-homepage') {
        if (getCookie('promotion-popup') === '') {
          let _promotionTrapCleanup = null;
          const modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: 'Close',
            cssClass: [
              `promotion-popup-modal`,
              `${m ? 'enable-on-mobile' : 'show-all'}`,
            ],
            onOpen: function () {
              _promotionTrapCleanup = trapFocus(this.modalBox);
            },
            beforeClose: function () {
              if (_promotionTrapCleanup) { _promotionTrapCleanup(); _promotionTrapCleanup = null; }
              return true;
            },
          });
          modal.setContent(_this.innerHTML);
          modal.open();
          _this.copyPromotion();
          _this.checkNotShowPromotion();
        }
      }
    }
  }
  checkNotShowPromotion() {
    const check = document.querySelector(
      '.promotion-popup-modal .do-not-show-again'
    );
    if (check) {
      check.addEventListener('click', (e) => {
        setCookie('promotion-popup', 1, 1);
        document
          .querySelector('.promotion-popup-modal .tingle-modal__close')
          .click();
      });
    }
  }
  copyPromotion() {
    const cp = document.querySelectorAll('.promotion-popup-modal .discount');
    if (cp !== null) {
      cp.forEach((e) => {
        e.addEventListener('click', (el) => {
          el.preventDefault();
          navigator.clipboard.writeText(e?.dataset.code);
          e.classList.add('action-copy');
          setTimeout(() => {
            e.classList.remove('action-copy');
          }, 1500);
        });
      });
    }
  }
}
customElements.define('promotion-popup', PromotionPopup);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init();
    }, 12000);
  }
  init() {
    const sectionId = this.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('newsletter-popup').innerHTML;
        document.querySelector('newsletter-popup').innerHTML = newSection;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        this.initPopup();
      });
  }

  initPopup() {
    const _this = this;
    const s = _this?.dataset.show;
    const m = _this?.dataset.showMb === 'true';
    if (!Shopify.designMode) {
      const cookie = getCookie('newsletter_popup');
      const width = window.innerWidth;
      if (!m && width < 768) {
        return false;
      }
      if ((s == 'show_homepage' || s == 'show_all_page') && cookie === '') {
        let _newsletterTrapCleanup = null;
        const modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ['overlay', 'button', 'escape'],
          closeLabel: 'Close',
          beforeOpen: function () {
            CloseAllPopup();
          },
          onOpen: function () {
            _newsletterTrapCleanup = trapFocus(this.modalBox);
          },
          beforeClose: function () {
            if (_newsletterTrapCleanup) { _newsletterTrapCleanup(); _newsletterTrapCleanup = null; }
            return true;
          },
          cssClass: [
            `newsletter-popup-modal`,
            `${m ? 'show-all' : 'disable-on-mobile'}`,
          ],
        });
        modal.setContent(_this.innerHTML);
        modal.open();
        _this.onShowNewletter();
      }
    }
  }

  onShowNewletter() {
    const _this = this;
    const setC = document.querySelector(
      '.newsletter-popup-modal .newsletter-popup__dont-show'
    );
    if (!setC) return;
    setC.addEventListener('click', _this.notShow.bind(_this));
    setC.addEventListener(
      'keypress',
      function (event) {
        if (event.key === 'Enter') {
          _this.notShow.bind(_this)(event);
        }
      }.bind(_this),
      false
    );
  }

  notShow(e) {
    e.preventDefault();
    setCookie('newsletter_popup', 30, 1);
    document
      .querySelector('.newsletter-popup-modal .tingle-modal__close')
      .click();
  }
}
customElements.define('newsletter-popup', NewsletterPopup);

class TiktokVideo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    window.addEventListener('scroll', () => {
      let wpy = window.scrollY;
      if (wpy > 0) {
        this.scrollLazyloadVideo();
      }
    });
    let pos = window.pageYOffset;
    if (pos > 40) {
      this.scrollLazyloadVideo();
    }
  }

  scrollLazyloadVideo() {
    const _this = this;
    if (!_this.classList.contains('tiktok-loading')) {
      return;
    }
    _this.classList.remove('tiktok-loading');
    const sectionId = _this.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('tiktok-video').innerHTML;
        _this.innerHTML = newSection;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.tiktok.com/embed.js';
        document.body.appendChild(script);
      });
  }
}
customElements.define('tiktok-video', TiktokVideo);

var returnMessageWhenSubmit = (function () {
  return {
    init: function () {
      this.checkUrlReturn();
    },
    checkUrlReturn: function () {
      const getUrl = window.location.href;
      if (
        getUrl.indexOf('customer_posted=true#newsletter-form') >= 1 ||
        getUrl.indexOf('customer_posted=true') >= 1
      ) {
        this.handleMessageSuccessPopup();
        setCookie('newsletter_popup', 30, 1);
        const newURL = location.href.split('?')[0];
        window.history.pushState('object', document.title, newURL);
      }

      if (
        getUrl.indexOf('contact%5Btags%5D=newsletter&form_type=customer') >= 1
      ) {
        this.handleMessageErrorPopup();
        const newURL = location.href.split('?')[0];
        window.history.pushState('object', document.title, newURL);
      }
    },

    handleMessageSuccessPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const elementSuccessMessage = html.querySelector(
            '.newsletter-form__success-message-wrapper'
          );
          const elementMessage = elementSuccessMessage.querySelector(
            '.newsletter-form__message'
          );
          showToast(elementSuccessMessage.innerHTML, 5000, 'modal-success');
        })
        .catch((e) => {
          throw e;
        });
    },

    handleMessageErrorPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const elementErrorMessage = html.querySelector(
            '.newsletter-form__error-message-wrapper'
          );
          const elementMessage = elementErrorMessage.querySelector(
            '.newsletter-form__message'
          );
          showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
        })
        .catch((e) => {
          throw e;
        });
    },
  };
})();
returnMessageWhenSubmit.init();
class NavBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    document.body.classList.add('mobi-navigation-bar');
  }
}
customElements.define('mobile-navigation-bar', NavBar);

class IconBox extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.swiperSlideInnerHtml = this.innerHTML;
    this.init();
  }
  init() {
    if (this.enable == 'true') {
      let width = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 767) {
        this.actionOnMobile();
      } else {
        this.actionOutMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add('swiper');
    this.classList.remove('grid', 'grid-cols');
    const html = this.swiperSlideInnerHtml.replaceAll(
      'sec__icon-switch-slide',
      'swiper-slide'
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div> <div
    class="swiper-pagination  ${
      this.enable && this.dataset.mobile != 1.5 ? 'flex' : 'hidden'
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    this.innerHTML = wrapper;
    this.initSlide();
  }
  actionOutMobile() {
    this.classList.remove('swiper');
    this.classList.add('grid', 'grid-cols');
    this.innerHTML = this.swiperSlideInnerHtml;
  }
}
customElements.define('icon-box', IconBox);

class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.initLoadMore();
    if (this.classList.contains('collection-infinite-scroll')) {
      this.querySelector('a').addEventListener(
        'click',
        async (e) => {
          this.toggleLoading(e.currentTarget, true);
          await new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
              this.toggleLoading(e.currentTarget, false);
              this.remove();
            }, 400);
          });
          for (var item of document.querySelectorAll(
            '.sec__collections-list .collection-item.grid-custom-item'
          )) {
            item.classList.remove('hidden');
          }
          if (!this.hasAttribute('hold')) {
            motion.animate(
              document.querySelectorAll(
                '.sec__collections-list .collection-item.grid-custom-item.trigger_slidein'
              ),
              {
                transform: ['translateY(3.5rem)', 'translateY(0)'],
                opacity: [0.01, 1],
                visibility: ['hidden', 'visible'],
              },
              {
                duration: 0.5,
                delay: motion.stagger(0.1),
                easing: [0, 0, 0.3, 1],
              }
            );
          }
        },
        false
      );
    }
  }
  initLoadMore() {
    this.querySelectorAll('.actions-loadmore').forEach((loadMore) => {
      var _this = this;
      if (loadMore.classList.contains('infinit-scrolling')) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1) {
                _this.loadMoreItem(loadMore);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(loadMore);
      } else {
        loadMore.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            _this.loadMoreItem(target);
          },
          false
        );
      }
    });
  }
  loadMoreItem(target) {
    const loadMore_url = target.getAttribute('href');
    const _this = this;
    let sectionContainer = document.querySelector(`#product-grid`);
    sectionContainer?.classList.add('bls-image-js');
    _this.toggleLoading(target, true);
    fetch(`${loadMore_url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const resultNodes = parser.parseFromString(responseText, 'text/html');
        const resultNodesHtml = resultNodes.querySelectorAll(
          '.loadmore-lists .loadmore-item'
        );
        resultNodesHtml.forEach((prodNode) =>
          document.querySelector('.loadmore-lists').appendChild(prodNode)
        );
        const load_more = resultNodes.querySelector('.actions-loadmore');
        document.querySelector('.load-more-bar').innerHTML =
          resultNodes.querySelector('.load-more-bar').innerHTML;
        if (load_more) {
          target.setAttribute('href', load_more.getAttribute('href'));
        } else {
          target.remove();
        }
        _this.toggleLoading(target, false);
      })
      .catch((error) => {
        _this.toggleLoading(target, false);
        throw error;
      })
      .finally(async () => {
        initLazyloadItem();
        BlsLazyloadImg.init();
        setTimeout(() => {
          const grid_list = document.querySelector('grid-list');
          grid_list?.showGridItems();
        }, 100);
      });
  }
  toggleLoading(event, loading) {
    if (event) {
      const method = loading ? 'add' : 'remove';
      event.classList[method]('loading');
    }
  }
}
customElements.define('loadmore-button', PaginateLoadmore);

class SingleItem extends HTMLElement {
  constructor() {
    super();
    this.position = this.dataset.position;
    this.section = this.closest('.section-slide-single');
    this.init();
  }
  init() {
    this.addEventListener('click', this.onClick.bind(this));
  }
  onClick() {
    if (this.section && this.position) {
      const slideSEction = this.section.querySelector(`slide-section-single`);
      const allDots = this.section.querySelectorAll(`single-item`);
      allDots.forEach((dot) => {
        dot.classList.remove('active');
      });
      this.classList.add('active');
      if (slideSEction) {
        slideSEction.functionGoto(this.position);
      }
    }
  }
}
customElements.define('single-item', SingleItem);

class SlideSectionSingle extends SlideSection {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(position) {
    this.globalSlide.slideToLoop(position - 1, 500);
  }
}
customElements.define('slide-section-single', SlideSectionSingle);

class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.swiper-wrapper');
        if (recommendations && recommendations.innerHTML.trim().length) {
          if (this.querySelector('.swiper-wrapper')) {
            this.querySelector('.swiper-wrapper').innerHTML =
              recommendations.innerHTML;
          }
        } else {
          this.classList.add('hidden');
        }
      })
      .finally(() => {})
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('minicart-recommendations', CartUpsell);

class CartUpsellBeside extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendationsBeside = html.querySelector(
          '.cart-upsell-wrapper'
        );
        if (
          recommendationsBeside &&
          recommendationsBeside.innerHTML.trim().length
        ) {
          if (this.querySelector('.cart-upsell-wrapper')) {
            this.querySelector('.cart-upsell-wrapper').innerHTML =
              recommendationsBeside.innerHTML;
          }
        } else {
          this.classList.add('hidden');
        }
      })
      .finally(() => {})
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('minicart-recommendations-beside', CartUpsellBeside);

class CartUpsellHeading extends HTMLElement {
  constructor() {
    super();
    if (this.querySelector('.button-close-beside')) {
      this.querySelector('.button-close-beside').addEventListener(
        'click',
        (e) => {
          const target = e.currentTarget;
          const closeBeside = target.closest('.cart-recommend');
          closeBeside.classList.remove('open');
        },
        false
      );
    }
  }
}
customElements.define('minicart-recommendations-heading', CartUpsellHeading);

class VariantRadiosQuickEdit extends SwatchInit {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      this.checkSwatches(btn);
    });
    this.querySelectorAll('.option-swatch-js').forEach((button) =>
      button.addEventListener('click', this.onVariantChange.bind(this), false)
    );
  }

  onVariantChange(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const value = target.getAttribute('data-value');
    for (var item of target
      .closest('fieldset')
      .querySelectorAll('.option-swatch-js')) {
      item.classList.remove('active');
      item.setAttribute('aria-pressed', 'false');
    }
    target.classList.toggle('active');
    target.setAttribute('aria-pressed', target.classList.contains('active') ? 'true' : 'false');
    target
      .closest('fieldset')
      .querySelector('.swatch-selected-value').textContent = value;
    this.options = Array.from(
      this.querySelectorAll('.option-swatch-js.active'),
      (select) => select.getAttribute('data-value')
    );
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const form = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    if (form.querySelector('.product__media img')) {
      form.querySelector('.product__media img').removeAttribute('srcset');
      form
        .querySelector('.product__media img')
        .setAttribute(
          'src',
          this.currentVariant.featured_media.preview_image.src
        );
    }
  }

  updateVariantInput() {
    // Tayler modified it .... 20260306 for 架构修复：防范 Ajax 弹窗导致的 DOM ID 冲突
    // 优先锁定当前变体选择器所处的最近容器，强制更新局部 input，而不是盲目依赖全局 ID
    const localContainer = this.closest('.product__item-js, .product-quickview__content, .sec__featured-product, .product-item');
    if (localContainer) {
      const localInputs = localContainer.querySelectorAll('input[name="id"]');
      localInputs.forEach(input => {
        input.value = this.currentVariant.id;
      });
    }

    // 保留原有的基于 ID 的查询，兼容 Sticky Add to Cart
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #sticky-addcart-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  renderProductInfo() {
    if (!this.currentVariant) return;
    const compare_at_price = this.currentVariant.compare_at_price;
    const current_price = this.currentVariant.price;
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      cartStrings?.money_format
    );
    const form = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    form.querySelector('.price-regular .price').innerHTML = price_format;
    const price = form.querySelector('.price');
    price.classList.remove('price--sold-out', 'price--on-sale');
    price
      .querySelector('.price-regular .price')
      .classList.remove('special-price');
    if (compare_at_price && compare_at_price > current_price) {
      const compare_format = Shopify.formatMoney(
        compare_at_price,
        cartStrings?.money_format
      );
      if (!price.querySelector('.compare-price')) {
        var ps = price.querySelector('.price__sale');
        var sp = document.createElement('span');
        var cp = document.createElement('s');
        cp.classList.add('price-item', 'compare-price');
        sp.appendChild(cp);
        if (ps) {
          ps.appendChild(sp);
        }
      }
      if (price.querySelector('.compare-price')) {
        price.querySelector('.compare-price').innerHTML = compare_format;
      }
      price.classList.add('price--on-sale');
      price
        .querySelector('.price-regular .price')
        .classList.add('special-price');
    } else if (!this.currentVariant.available) {
      price.classList.add('price--sold-out');
    }
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings?.soldOut
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const buttonPayment = productForm.querySelector(
      '.product-dynamic-checkout'
    );
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings?.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings?.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  setAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.dataset.value)) {
        input.classList.remove('option-disabled');
      } else {
        input.classList.add('option-disabled');
      }
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.getVariantData().filter(
      (variant) =>
        this.querySelector('.active').dataset.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('.option-swatch-js')];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector('.active').dataset.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios-quick-edit', VariantRadiosQuickEdit);

class VariantRadiosBundle extends SwatchInit {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      this.checkSwatches(btn);
      this.variantHover(btn);
    });
    this.querySelectorAll('.option-swatch-js').forEach((button) =>
      button.addEventListener('click', this.onVariantChange.bind(this), false)
    );
  }

  onVariantChange(event) {
    event.preventDefault();
    this.productTarget = this.closest('.product__item-js');
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector('.productVariantsQty').textContent
    );
    const target = event.currentTarget;
    const value = target.getAttribute('data-value');
    for (var item of target
      .closest('fieldset')
      .querySelectorAll('.option-swatch-js')) {
      item.classList.remove('active');
      item.setAttribute('aria-pressed', 'false');
    }
    target.classList.toggle('active');
    target.setAttribute('aria-pressed', target.classList.contains('active') ? 'true' : 'false');
    target
      .closest('fieldset')
      .querySelector('.swatch-selected-value').textContent = value;
    this.options = Array.from(
      this.querySelectorAll('.option-swatch-js.active'),
      (select) => select.getAttribute('data-value')
    );
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductInfo(this.productTarget, variantQtyData, target);
      this.updateMedia();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  async updateMedia() {
    if (!this.currentVariant) return;
    if (
      !this.productTarget
        .querySelector('.product__media img')
        .classList.contains('hidden')
    ) {
      const productItem = this.productTarget
        .querySelector('.product__media img')
        .closest('.product-item');
      if (
        productItem.querySelector('video') ||
        productItem.querySelector('iframe')
      ) {
        this.productTarget
          .querySelector('.product__media img')
          .classList.add('hidden');
        productItem.querySelector('video')?.classList.remove('hidden');
        productItem.querySelector('iframe')?.classList.remove('hidden');
      }
    }
    if (!this.currentVariant.featured_media) return;
    if (this.productTarget.querySelector('.product__media img')) {
      this.productTarget
        .querySelector('.product__media img')
        .removeAttribute('srcset');
    }
    if (
      this.productTarget
        .querySelector('.product__media img')
        .classList.contains('hidden')
    ) {
      this.productTarget
        .querySelector('.product__media img')
        .classList.remove('hidden');
      const productItem = this.productTarget
        .querySelector('.product__media img')
        .closest('.product-item');
      if (
        productItem.querySelector('video') ||
        productItem.querySelector('iframe')
      ) {
        productItem.querySelector('video')?.classList.add('hidden');
        productItem.querySelector('iframe')?.classList.add('hidden');
      }
    }
    if (this.productTarget.querySelector('.product__media img')) {
      await motion.animate(
        this.productTarget.querySelector('.product__media img'),
        { opacity: [1, 0] },
        { duration: 0.1, easing: 'ease-in' }
      );
      this.productTarget
        .querySelector('.product__media img')
        .setAttribute(
          'src',
          this.currentVariant.featured_media.preview_image.src
        );
      await new Promise((resolve) => {
        this.productTarget.querySelector('.product__media img').onload = () => {
          resolve();
        };
      });
      motion.animate(
        this.productTarget.querySelector('.product__media img'),
        { opacity: [0, 1] },
        { duration: 0.1, easing: 'ease-in' }
      );
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#quick-add-bundle-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo(productTarget, variantQtyData, target) {
    if (!this.currentVariant) return;
    if (!productTarget) return;
    let qty = 0;
    let percent = 0;
    let sale = false;
    let soldOut = false;
    let pre_order = false;
    let av = this.currentVariant.available;
    let im = this.currentVariant.inventory_management;
    const compare_at_price = this.currentVariant.compare_at_price;
    const current_price = this.currentVariant.price;
    let avaiable = productTarget.querySelector('.available-value');
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      cartStrings?.money_format
    );
    const typePercent = productTarget.querySelector(
      '.product__badges-type-percent'
    );
    productTarget.querySelector('.price-regular .price').innerHTML = price_format;
    const price = productTarget.querySelector('.price');
    price.classList.remove('price--sold-out', 'price--on-sale');
    productTarget.querySelector('.price-regular .price').classList.remove('special-price');
    variantQtyData.find((variantQty) => {
      if (variantQty.id === this.currentVariant.id) {
        qty = Number(variantQty.qty) || 0;
        av = variantQty.available;
        im = variantQty.mamagement === '' ? null : variantQty.mamagement;
      }
    });
    if (compare_at_price && compare_at_price > current_price) {
      sale = true;
      if (typePercent) {
        percent = ((compare_at_price - current_price) / compare_at_price) * 100;
      } else {
        percent = compare_at_price - current_price;
      }

      const compare_format = Shopify.formatMoney(
        compare_at_price,
        cartStrings?.money_format
      );
      if (!price.querySelector('.compare-price')) {
        var ps = price.querySelector('.price__sale');
        var sp = document.createElement('span');
        var cp = document.createElement('s');
        cp.classList.add('price-item', 'compare-price');
        sp.appendChild(cp);
        if (ps) {
          ps.appendChild(sp);
        }
      }
      if (price.querySelector('.compare-price')) {
        price.querySelector('.compare-price').innerHTML = compare_format;
      }
      price.classList.add('price--on-sale');
      productTarget.querySelector('.price-regular .price').classList.add('special-price');
    } else if (!this.currentVariant.available) {
      price.classList.add('price--sold-out');
    }
    if (im === null || im === '' || im === undefined) {
      soldOut = false;
      pre_order = false;
      if (avaiable) {
        avaiable.innerHTML = window.variantStrings.inStock;
      }
    } else {
      if (av) {
        if (qty < 1) {
          pre_order = true;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.preOrder;
          }
        } else {
          soldOut = false;
          pre_order = false;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.inStock;
          }
        }
      } else {
        soldOut = true;
        if (avaiable) {
          avaiable.innerHTML = window.variantStrings.outStock;
        }
      }
    }
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings?.soldOut
    );

    this.renderLabel(sale, pre_order, soldOut, percent, productTarget);
  }

  //Tayler alterred this badges function....20251014
  /*
  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    const label = productTarget.querySelector('.product__badges');
    const sale_badge = productTarget.querySelector('.sale_badge');
    const productBadgesScrolling = productTarget.querySelector(
      '.product__badges-sale-scrolling'
    );
    if (sale || pre_order || soldOut) {
      if (!label) {
        var element = document.createElement('div');
        element.classList.add(
          'product__badges',
          'fs-small',
          'flex',
          'flex-wrap',
          'gap-5',
          'uppercase'
        );
        if (sale_badge) {
          sale_badge.appendChild(element);
        }
      }
    }

    if (label) {
      const saleColor = label.dataset.saleColor;
      const soldOutColor = label.dataset.soldOutColor;
      const preOrderColor = label.dataset.preOrderColor;
      const saleBg = label.dataset.saleBg;
      const soldOutBg = label.dataset.soldOutBg;
      const preOrderBg = label.dataset.preOrderBg;
      const show_sale = label?.dataset.showSale === 'true';
      const show_pre_order = label?.dataset.showPreorder === 'true';
      const show_sold_out = label?.dataset.showSoldOut === 'true';
      const prd = Shopify.formatMoney(
        percent,
        themeGlobalVariables.settings.money_format
      );
      const dsale = label.querySelector('.product__badges-sale');
      const dsoldout = label.querySelector('.product__badges-sold-out');
      const dpreorder = label.querySelector('.product__badges-pre-order');
      const typePrice = label.querySelector('.product__badges-type-price');
      const typePercent = label.querySelector('.product__badges-type-percent');
      if (sale && show_sale) {
        if (!dsale) {
          var elementsale = document.createElement('div');
          elementsale.classList.add(
            'product__badges-sale',
            'product__badges-inner',
            'px-15',
            'align-self-start',
            'sale',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementsale.style.setProperty('--badges-color', saleColor);
          elementsale.style.setProperty('--badges-bg', saleBg);
          elementsale.innerHTML = `${
            window.variantStrings.save ? window.variantStrings.save : 'Save'
          } ${prd}`;
          if (dsoldout) {
            label.insertBefore(elementsale, dsoldout);
          } else if (dpreorder) {
            label.insertBefore(elementsale, dpreorder);
          } else {
            label.appendChild(elementsale);
          }
        } else {
          if (typePrice) {
            dsale.innerHTML = `${
              window.variantStrings.save ? window.variantStrings.save : 'Save'
            } ${prd}`;
          } else if (typePercent) {
            dsale.innerHTML = -percent.toFixed(0) + '%';
          }
        }
      } else {
        dsale?.remove();
      }
      if (pre_order && show_pre_order) {
        if (!dpreorder) {
          var elementpo = document.createElement('div');
          elementpo.classList.add(
            'product__badges-pre-order',
            'product__badges-inner',
            'py-8',
            'px-15',
            'align-self-start',
            'pre-order',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementpo.style.setProperty('--badges-color', preOrderColor);
          elementpo.style.setProperty('--badges-bg', preOrderBg);
          elementpo.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : 'Pre-order';
          label.appendChild(elementpo);
        } else {
          dpreorder.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : 'Pre-order';
        }
      } else {
        dpreorder?.remove();
      }
      if (soldOut && show_sold_out) {
        if (!dsoldout) {
          var elementso = document.createElement('div');
          elementso.classList.add(
            'product__badges-sold-out',
            'product__badges-inner',
            'py-8',
            'px-15',
            'align-self-start',
            'sold-out',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementso.style.setProperty('--badges-color', soldOutColor);
          elementso.style.setProperty('--badges-bg', soldOutBg);
          elementso.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : 'Sold out';
          label.appendChild(elementso);
        } else {
          dsoldout.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : 'Sold out';
        }
      } else {
        dsoldout?.remove();
      }
    }

    if (productBadgesScrolling && sale) {
      const dataBadgesScrolling =
        productBadgesScrolling?.dataset.textProductScrolling;
      const allProductBadgesScrolling = productBadgesScrolling.querySelectorAll(
        '.content-badges-scrolling'
      );
      allProductBadgesScrolling.forEach((content) => {
        content.innerText = dataBadgesScrolling.replace(
          '[percent_sale]',
          percent.toFixed(0) + '%'
        );
      });
    }
  }*/

  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    const label = productTarget.querySelector('.product__badges');
    if (!label) return;

    const dsale = label.querySelector('.product__badges-sale');
    const dsoldout = label.querySelector('.product__badges-sold-out');
    const dpreorder = label.querySelector('.product__badges-pre-order');

    const show_sale = label.dataset.showSale === 'true';
    const show_sold_out = label.dataset.showSoldOut === 'true';
    const show_pre_order = label.dataset.showPreorder === 'true';

    // 1. 处理 Sale 徽章
    if (sale && show_sale && dsale) {
      const prd = Shopify.formatMoney(percent, window.cartStrings?.money_format);
      
      if (dsale.classList.contains('product__badges-type-percent')) {
        dsale.innerHTML = `-${percent.toFixed(0)}%`;
      } else if (dsale.classList.contains('product__badges-type-price')) {
        dsale.innerHTML = `${window.variantStrings.save ? window.variantStrings.save : 'Save'} ${prd}`;
      } else {
        dsale.innerHTML = window.variantStrings.sale_label || 'Sale';
      }
      dsale.classList.remove('hidden-important');
    } else if (dsale) {
      dsale.classList.add('hidden-important');
    }

    // 2. 处理 Sold Out 和 Pre-order 徽章 (它们是互斥的)
    // [DTC-768] 非售卖区 IP（data-region-out，服务端初始+真实 IP 精修写回）不展示售罄徽章，变体切换不得复显
    const regionOut = label.dataset.regionOut === 'true';
    if (soldOut && show_sold_out && dsoldout && !regionOut) {
      dsoldout.classList.remove('hidden-important');
      if (dpreorder) dpreorder.classList.add('hidden-important'); // 如果售罄，则强制隐藏预购
    } else {
      if (dsoldout) dsoldout.classList.add('hidden-important');

      // 仅在未售罄时检查预购
      if (pre_order && show_pre_order && dpreorder) {
        dpreorder.classList.remove('hidden-important');
      } else if (dpreorder) {
        dpreorder.classList.add('hidden-important');
      }
    }
    
    // 3. (可选) 处理滚动文本
    const productBadgesScrolling = productTarget.querySelector('.product__badges-sale-scrolling');
    if (productBadgesScrolling) {
      if (sale) {
        const dataBadgesScrolling = productBadgesScrolling.dataset.textProductScrolling;
        const allProductBadgesScrolling = productBadgesScrolling.querySelectorAll('.content-badges-scrolling');
        allProductBadgesScrolling.forEach((content) => {
          content.innerText = dataBadgesScrolling.replace('[percent_sale]', `${percent.toFixed(0)}%`);
        });
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `quick-add-bundle-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const buttonPayment = productForm.querySelector(
      '.product-dynamic-checkout'
    );
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) {
        addButtonText.textContent = window.variantStrings?.addToCartBundle;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `quick-add-bundle-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings?.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  setAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.dataset.value)) {
        input.classList.remove('option-disabled');
      } else {
        input.classList.add('option-disabled');
      }
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.getVariantData().filter(
      (variant) =>
        this.querySelector('.active').dataset.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('.option-swatch-js')];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector('.active').dataset.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  variantHover(e) {
    const productTarget = e.closest('.product-item');
    if (!productTarget) return;

    const swiperElement = e.closest('.swiper');
    if (!swiperElement) return;

    let timeout;

    const handleMouseOut = () => {
      swiperElement.classList.remove('show-tooltip');
    };

    const handleMouseOver = () => {
      swiperElement.classList.add('show-tooltip');
    };

    e.addEventListener('mouseout', handleMouseOut, false);
    e.addEventListener('mouseover', handleMouseOver, false);
    e.addEventListener('mouseenter', handleMouseOver, false);
    e.addEventListener('mouseleave', handleMouseOut, false);
  }
}
customElements.define('variant-radios-bundle', VariantRadiosBundle);

if (!customElements.get('product-form-bundle')) {
  customElements.define(
      'product-form-bundle',
      class ProductForm extends PopupBase {
          constructor() {
              super();
              this.form = this.querySelector('form');
              this.form.querySelector('[name=id]').disabled = false;
              this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
              this.cart =
                  document.querySelector('cart-notification') ||
                  document.querySelector('cart-drawer');
              this.submitButton = this.querySelector('[type="submit"]');
              this.hideErrors = this.dataset.hideErrors === 'true';
              this.productItem =
                  this.form.closest('.product-item') ||
                  this.form.closest('sticky-add-cart');
          }

          updateBundleButtonStatus() {
            const productFormBundle = this.closest('product-form-bundle');
            const minimum = productFormBundle.dataset.minimum;
            const maximum = productFormBundle.dataset.maximum;
            const submitButton = document.querySelector('button-submit-bundle');
            if (!submitButton) return;
        
            const bundleItems = document.querySelectorAll('[data-product-bundle-variant][data-variant-id]');
            if (bundleItems.length >= minimum) {
                submitButton.classList.remove('disabled');
            } else {
                submitButton.classList.add('disabled');
            }
            const btnAddCart = this.closest('product-bundle').querySelectorAll('product-form-bundle button');
            if (bundleItems.length >= maximum) {
              btnAddCart.forEach((btn) => {
                btn.classList.add('disabled');
              })
            }
          }

          onSubmitHandler(evt) {
              evt.preventDefault();
              if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

              this.handleErrorMessage();

              this.submitButton.classList.add('disabled');
              this.submitButton.textContent = window.variantStrings?.addedToCartBundle;

              const formData = new FormData(this.form);
              const variantId = formData.get('id');
              const quantity = formData.get('quantity') || 1;
              const productHandle = this.dataset.handle || this.dataset.productHandle;

              fetch(`/products/${productHandle}?section_id=bundle-item&variant=${variantId}`)
                  .then(response => response.text())
                  .then(responseText => {
                      const doc = parser.parseFromString(responseText, 'text/html');
                      const bundleContainers = document.querySelectorAll('[data-product-bundle-variant]');
                      if (!bundleContainers.length) {
                          console.error('No bundle container found');
                          return;
                      }

                      let existingItemContainer = null;
                      for (const container of bundleContainers) {
                          if (container.getAttribute('data-variant-id') === variantId) {
                              existingItemContainer = container;
                              break;
                          }
                      }

                      if (existingItemContainer) {
                          const currentQty = parseInt(existingItemContainer.getAttribute('data-quantity') || 0);
                          existingItemContainer.setAttribute('data-quantity', currentQty + parseInt(quantity));

                          const quantityDisplay = existingItemContainer.querySelector('.bundle-item-quantity');
                          if (quantityDisplay) {
                              quantityDisplay.textContent = currentQty + parseInt(quantity);
                          }

                          existingItemContainer.classList.add('flash-highlight');
                          setTimeout(() => {
                              existingItemContainer.classList.remove('flash-highlight');
                          }, 1500);
                      } else {
                          let targetContainer = null;
                          for (const container of bundleContainers) {
                              if (!container.hasAttribute('data-variant-id')) {
                                  targetContainer = container;
                                  break;
                              }
                          }

                          if (!targetContainer) {
                              this.handleErrorMessage('Bundle is full. Please remove an item first.');
                              return;
                          }

                          const bundleImage = doc.querySelector('.bundle-image');
                          const bundleContent = doc.querySelector('.bundle-content');
                          const bundleRemoveButton = doc.querySelector('bundle-cart-remove-button');

                          if (!bundleImage || !bundleContent) {
                              console.error('Missing required elements in response', { bundleImage, bundleContent });
                              this.handleErrorMessage('Error processing product data');
                              return;
                          }

                          targetContainer.setAttribute('data-variant-id', variantId);
                          targetContainer.setAttribute('data-quantity', quantity);
                          targetContainer.classList.add('bundle-item-dev');

                          const mediaContainer = targetContainer.querySelector('[data-product-bundle-variant-media]');
                          if (mediaContainer && bundleImage) {
                              mediaContainer.classList.remove('skeleton');
                              mediaContainer.innerHTML = bundleImage.innerHTML;
                          }

                          const contentContainer = targetContainer.querySelector('[data-product-bundle-variant-content]');
                          if (contentContainer && bundleContent) {
                              contentContainer.querySelectorAll('.horizontal-product__skeleton').forEach(el => el.remove());

                              contentContainer.innerHTML = bundleContent.innerHTML;
                              let bundleActionContainer = targetContainer.querySelector('.bundle-action');
                              if (!bundleActionContainer) {
                                  bundleActionContainer = document.createElement('div');
                                  bundleActionContainer.classList.add('bundle-action');
                                  targetContainer.appendChild(bundleActionContainer);
                              }
                              if (bundleRemoveButton) {
                                  const existingButtons = bundleActionContainer.querySelectorAll('bundle-cart-remove-button');
                                  existingButtons.forEach(button => button.remove());
                                  const removeButtonHTML = bundleRemoveButton.outerHTML;

                                  bundleActionContainer.insertAdjacentHTML('beforeend', removeButtonHTML);

                                  const newRemoveButton = bundleActionContainer.querySelector('bundle-cart-remove-button:last-child');

                                  if (newRemoveButton) {
                                      newRemoveButton.addEventListener('click', () => {
                                        const _this = this;
                                          targetContainer.removeAttribute('data-variant-id');
                                          targetContainer.removeAttribute('data-quantity');

                                          if (mediaContainer) {
                                              mediaContainer.innerHTML = '';
                                          }

                                          if (contentContainer) {
                                              contentContainer.innerHTML = `
                                                <span class="horizontal-product__skeleton skeleton-1"></span>
                                                <span class="horizontal-product__skeleton skeleton-2"></span>
                                                <span class="horizontal-product__skeleton skeleton-3"></span>
                                              `;
                                          }
                                          _this.submitButton.classList.remove('disabled');
                                          _this.submitButton.textContent = window.variantStrings?.addToCartBundle;
                                          _this.updateContainerOrders();
                                          _this.updateBundleTotal();
                                          document.dispatchEvent(new CustomEvent('bundle:item-changed'));
                                          const bundleItems = document.querySelectorAll('[data-product-bundle-variant][data-variant-id]');
                                          const maximum = _this.closest('product-form-bundle').dataset.maximum;
                                          if (bundleItems.length < maximum) {
                                            const btnAddCart = _this.closest('product-bundle').querySelectorAll('product-form-bundle button.disabled');
                                            btnAddCart.forEach((btn) => {
                                              const productForm = btn.closest('product-form-bundle');
                                              const productId = productForm.querySelector('input[name="id"]').value;
                                              const isInBundle = Array.from(bundleItems).some(item => 
                                                item.getAttribute('data-variant-id') === productId
                                              );
                                              if (!isInBundle) {
                                                btn.classList.remove('disabled');
                                              }
                                            });
                                          }
                                          _this.updateBundleButtonStatus();
                                      });
                                  }
                              }
                          }

                          targetContainer.classList.add('flash-highlight');
                          setTimeout(() => {
                              targetContainer.classList.remove('flash-highlight');
                          }, 1500);
                      }

                      this.form.reset();
                      this.updateBundleTotal();
                  })
                  .catch(error => {
                      console.error('Error adding product to bundle:', error);
                      this.handleErrorMessage('Could not add product to bundle');
                  })
                  .finally(() => {
                    // this.submitButton.classList.remove('disabled');
                    document.dispatchEvent(new CustomEvent('bundle:item-changed'));
                    this.updateBundleButtonStatus();
                  });
          }

          updateContainerOrders() {
            const bundleContainers = document.querySelectorAll('[data-product-bundle-variant]');
            
            bundleContainers.forEach(container => {
              container.style.order = '';
            });
            
            let filledCount = 0;
            let emptyCount = 0;
            
            bundleContainers.forEach((container, index) => {
              if (container.hasAttribute('data-variant-id')) {
                container.style.order = filledCount.toString();
                filledCount++;
              } else {
                container.style.order = (bundleContainers.length + emptyCount).toString();
                emptyCount++;
              }
            });
          }

          updateBundleTotal() {
            let totalPrice = 0;
            let itemTotalPrice = 0;
            const bundleItems = document.querySelectorAll('[data-product-bundle-variant][data-variant-id]');
            bundleItems.forEach(item => {
                const priceElement = item.querySelector('.price-item--regular');
                const price = priceElement?.dataset.price;
                const quantity = parseInt(item.getAttribute('data-quantity')) || 1;
                itemTotalPrice += price * quantity;
                totalPrice = Shopify.formatMoney(
                  itemTotalPrice,
                  cartStrings?.money_format
                );
            });
            const totalElement = document.querySelector('.subtotal-price__bundle');
            if (itemTotalPrice > 0) {
              totalElement.textContent = totalPrice;
            }else{
              totalElement.textContent = Shopify.formatMoney(
                0,
                cartStrings?.money_format
              )
            }
          }

          getMainCartSectionRender() {
              return [
                  {
                      id: 'main-cart-items',
                      section: document.getElementById('main-cart-items')?.dataset.id,
                      selector: '.js-contents',
                  },
              ];
          }

          getSectionInnerHTML(html, selector) {
              return new DOMParser()
                  .parseFromString(html, 'text/html')
                  .querySelector(selector).innerHTML;
          }

          handleErrorMessage(errorMessage = false) {
              if (this.hideErrors) return;

              this.errorMessageWrapper =
                  this.errorMessageWrapper ||
                  this.querySelector('.product-form__error-message-wrapper');
              if (!this.errorMessageWrapper) return;
              this.errorMessage =
                  this.errorMessage ||
                  this.errorMessageWrapper.querySelector(
                      '.product-form__error-message'
                  );

              this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

              if (errorMessage) {
                  this.errorMessage.textContent = errorMessage;
              }
          }

          handleErrorMessagePopup(errorMessage = false) {
              const url = `${window.location.pathname}?section_id=form-message`;
              fetch(url)
                  .then((response) => response.text())
                  .then((responseText) => {
                      const html = new DOMParser().parseFromString(
                          responseText,
                          'text/html'
                      );
                      const elementErrorMessage = html.querySelector(
                          '.product-form__error-message-wrapper'
                      );
                      const elementMessage = elementErrorMessage.querySelector(
                          '.product-form__error-message'
                      );
                      elementMessage.textContent = errorMessage;
                      showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
                  })
                  .catch((e) => {
                      throw e;
                  });
          }
      }
  );
}

class QuantityInputBundle extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    
    this.previousValue = parseInt(this.input.value) || 1;
    
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onInputChange() {
    this.updateBundleQuantity();
  }

  onButtonClick(event) {
    event.preventDefault();
    this.previousValue = parseInt(this.input.value);

    event.target.name === 'plus' ||
    event.target.closest('button').name === 'plus'
      ? this.input.stepUp()
      : this.input.stepDown();
    
    if (this.previousValue !== parseInt(this.input.value)) {
      this.input.dispatchEvent(this.changeEvent);
      this.updateBundleQuantity();
    }
  }

  updateBundleQuantity() {
    const bundleContainer = this.closest('[data-product-bundle-variant]');
    if (!bundleContainer) return;
    
    const currentValue = parseInt(this.input.value) || 1;
    bundleContainer.setAttribute('data-quantity', currentValue);
    
    this.updateBundleTotal();
  }

  updateBundleTotal() {
    let itemTotalPrice = 0;
    const bundleItems = document.querySelectorAll('[data-product-bundle-variant][data-variant-id]');
    
    bundleItems.forEach(item => {
      const priceElement = item.querySelector('.price-item--regular');
      if (!priceElement || !priceElement.dataset.price) return;
      
      const price = parseFloat(priceElement.dataset.price);
      const quantity = parseInt(item.getAttribute('data-quantity')) || 1;
      
      if (!isNaN(price) && !isNaN(quantity)) {
        itemTotalPrice += price * quantity;
      }
    });
    
    const totalElement = document.querySelector('.subtotal-price__bundle');
    if (totalElement) {
      if (itemTotalPrice > 0) {
        totalElement.textContent = Shopify.formatMoney(
          itemTotalPrice,
          cartStrings?.money_format
        );
      } else {
        totalElement.textContent = Shopify.formatMoney(
          0,
          cartStrings?.money_format
        );
      }
    }
  }
}

customElements.define('quantity-input-bundle', QuantityInputBundle);

class ButtonSubmitBundle extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this;
    this.addEventListener('click', this.onSubmitHandler.bind(this));
    this.minimum = this.dataset.minimum;
    this.maximum = this.dataset.maximum;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    if (this.classList.contains('loading')) return;
    
    this.classList.add('loading');
    this.setAttribute('aria-disabled', 'true');
    this.querySelector('span').textContent = window.variantStrings?.addingToCart || 'Adding to cart...';
    
    const bundleItems = document.querySelectorAll('[data-product-bundle-variant][data-variant-id]');
    
    if (!bundleItems.length) {
      this.handleErrorMessagePopup('Please add products to your bundle first');
      this.resetButton();
      return;
    }
    
    const items = Array.from(bundleItems).map(item => {
      return {
        id: item.getAttribute('data-variant-id'),
        quantity: parseInt(item.getAttribute('data-quantity')) || 1
      };
    });
    
    this.addItemsToCart(items);
  }
  
  addItemsToCart(items) {
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
    const formData = {
      items: items,
      sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
      sections_url: window.location.pathname
    };
    
    fetch(`${routes?.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        this.handleErrorMessagePopup(response.description);
        return;
      }else if (response.errors) {
        this.handleErrorMessagePopup(response.errors);
        return;
      }
      
      this.updateCartCount();
      
      this.clearBundle();
      
      if (this.cart) {
        this.updateCartSections(response);
      }
      
      if (this.cart) {
        this.cart.open();
      }else{
        window.location = window.routes.cart_url;
      }
    })
    .catch(error => {
      throw error;
    })
    .finally(() => {
      this.resetButton();
    });
  }
  
  updateCartCount() {
    fetch('/cart.json')
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count !== undefined) {
          document.querySelectorAll('.cart-count').forEach((el) => {
            if (el.classList.contains('cart-count-drawer')) {
              el.innerHTML = `(${cart.item_count})`;
            } else {
              el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
            }
          });
          
          if (document.querySelector('header-total-price')) {
            document.querySelector('header-total-price').updateTotal(cart);
          }
          
          const cartFreeShip = document.querySelector('free-ship-progress-bar');
          if (cartFreeShip) {
            cartFreeShip.init(cart.items_subtotal_price);
          }
        }
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }
  
  updateCartSections(response) {
    this.cart.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      const html = new DOMParser().parseFromString(
        response.sections[section.id],
        'text/html'
      );
      
      if (elementToReplace) {
        elementToReplace.innerHTML = html.querySelector('#minicart-form').innerHTML;
      }
    });
    
    if (this.cart && typeof this.cart.cartAction === 'function') {
      this.cart.cartAction();
    }
  }
  
  clearBundle() {
    const bundleContainers = document.querySelectorAll('[data-product-bundle-variant]');
    bundleContainers.forEach(container => {
      container.removeAttribute('data-variant-id');
      container.removeAttribute('data-quantity');
      
      const mediaContainer = container.querySelector('[data-product-bundle-variant-media]');
      if (mediaContainer) {
        mediaContainer.innerHTML = '';
      }
      
      const contentContainer = container.querySelector('[data-product-bundle-variant-content]');
      if (contentContainer) {
        contentContainer.innerHTML = `
          <span class="horizontal-product__skeleton skeleton-1"></span>
          <span class="horizontal-product__skeleton skeleton-2"></span>
          <span class="horizontal-product__skeleton skeleton-3"></span>
        `;
      }
      
      const actionContainer = container.querySelector('.bundle-action');
      if (actionContainer) {
        actionContainer.innerHTML = '';
      }
    });
    
    const totalElement = document.querySelector('.subtotal-price__bundle');
    if (totalElement) {
      totalElement.textContent = Shopify.formatMoney(0, cartStrings?.money_format);
    }

    this.updateButtonStatus();
    document.dispatchEvent(new CustomEvent('bundle:item-changed'));
  }
  
  handleErrorMessagePopup(errorMessage = false) {
    const url = `${window.location.pathname}?section_id=form-message`;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );
        const elementErrorMessage = html.querySelector(
          '.product-form__error-message-wrapper'
        );
        const elementMessage = elementErrorMessage.querySelector(
          '.product-form__error-message'
        );
        elementMessage.textContent = errorMessage;
        showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
      })
      .catch((e) => {
        throw e;
      });
  }
  
  resetButton() {
    this.classList.remove('loading');
    this.setAttribute('aria-disabled', 'false');
    this.querySelector('span').textContent = window.variantStrings?.addAllToCart || 'Add all to cart';
    this.updateButtonStatus();
  }

  updateButtonStatus() {
    const bundleItems = document.querySelectorAll('[data-product-bundle-variant][data-variant-id]');
    const sectionId = this.dataset.sectionId;
    const bundleBtnAddCart = document.querySelectorAll(`#product-bundle-${sectionId} product-form-bundle button`);
    bundleBtnAddCart.forEach((button) => {
      if (button.classList.contains('disabled')) {
        button.classList.remove('disabled');
      }
    })
    let itemCount = 0;
    if (bundleItems.length > 0) {
      itemCount = bundleItems.length;
    }

    if (itemCount >= this.minimum) {
      this.classList.remove('disabled');
    } else {
      this.classList.add('disabled');
    }
  }
}

customElements.define('button-submit-bundle', ButtonSubmitBundle);

class ProgressBundleBar extends HTMLElement {
  constructor() {
    super();
    this.minimum = parseInt(this.dataset.minimum) || 1;
    this.updateBundleProgress();
    
    document.addEventListener('bundle:item-changed', () => this.updateBundleProgress());
  }
  
  updateBundleProgress() {
    const bundleItems = Array.from(this.closest('sticky-element').querySelectorAll('[data-product-bundle-variant][data-variant-id]'));
    const itemCount = bundleItems.length;
    
    let progressPercentage;
    if (itemCount >= this.minimum) {
      progressPercentage = 100;
    } else {
      progressPercentage = (itemCount / this.minimum) * 100;
    }
    
    this.style.setProperty('--progress-width', `${progressPercentage}%`);
    
    if (progressPercentage >= 100) {
      this.classList.add('complete');
    } else {
      this.classList.remove('complete');
    }
  }
}

customElements.define('progress-bundle-bar', ProgressBundleBar);

if (!customElements.get('product-form-quick-edit')) {
  customElements.define(
    'product-form-quick-edit',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('loading');
        const cartRecommend = document.querySelector('.cart-recommend');
        if (cartRecommend && cartRecommend.classList.contains('open')) {
          cartRecommend.classList.remove('open');
        }
        const quick = document.getElementById('product-form-quick-edit');
        const id = quick.getAttribute('data-line');
        const quantity = 0;
        const config_change = fetchConfig('json');
        config_change.body = JSON.stringify({
          id,
          quantity,
        });
        fetch(`${routes?.cart_change_url}`, config_change)
          .then((response) => {
            return response.text();
          })
          .catch((e) => {
            throw e;
          })
          .finally(() => {
            this.addCartAdd();
          });
      }

      addCartAdd() {
        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes?.cart_add_url}`, config)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.submitButton.setAttribute('disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            fetch('/cart.json')
              .then((res) => res.json())
              .then((cart) => {
                if (cart.item_count != undefined) {
                  document.querySelectorAll('.cart-count').forEach((el) => {
                    if (el.classList.contains('cart-count-drawer')) {
                      el.innerHTML = `(${cart.item_count})`;
                    } else {
                      el.innerHTML =
                        cart.item_count > 100 ? '~' : cart.item_count;
                    }
                  });
                  if (document.querySelector('header-total-price')) {
                    document
                      .querySelector('header-total-price')
                      .updateTotal(cart);
                  }
                  const cart_free_ship = document.querySelector(
                    'free-ship-progress-bar'
                  );
                  if (cart_free_ship) {
                    cart_free_ship.init(cart.items_subtotal_price);
                  }
                }
              })
              .catch((error) => {
                throw error;
              });
            const parsedState = JSON.parse(state);
            if (!parsedState.errors) {
              this.cart.getSectionsToRender().forEach((section) => {
                const elementToReplace = document.getElementById(section.id);
                const html = new DOMParser().parseFromString(
                  parsedState.sections[section.id],
                  'text/html'
                );
                elementToReplace.innerHTML =
                  html.querySelector('#minicart-form').innerHTML;
              });
              if (this.cart && typeof this.cart.cartAction === 'function') {
                this.cart.cartAction();
              }
              document.querySelector('.tingle-modal__close').click();
            }else{
              this.submitButton.removeAttribute('disabled');
              this.submitButton.classList.remove('loading');
              this.submitButton.querySelector('span').classList.remove('hidden');
              this.updateMessageQuickErrors(parsedState.errors);
            }
          })
          .catch((e) => {
            throw e;
          })
          .finally(() => {
            BlsLazyloadImg.init();
            this.submitButton.removeAttribute('disabled');
            this.submitButton.querySelector('span').classList.remove('hidden');
            this.cart.open();
            const cartRecommend = document.querySelector('.cart-recommend');
            if (
              cartRecommend &&
              !cartRecommend.classList.contains('hidden-recommend')
            ) {
              if (cartRecommend.classList.contains('cart-recommend-custom')) {
                const cartUpsellItem =
                  document.querySelectorAll('.cart-upsell-item');
                const cartUpsellSlide = document.querySelectorAll(
                  '.swiper-cart-upsell .swiper-slide'
                );

                if (cartUpsellItem.length > 0) {
                  setTimeout(function () {
                    cartRecommend.classList.add('open');
                  }, 800);
                } else if (cartUpsellSlide.length === 0) {
                  cartRecommend.classList.remove('block');
                  cartRecommend.classList.add('hidden');
                }
              } else {
                setTimeout(function () {
                  cartRecommend.classList.add('open');
                }, 800);
              }
            }
          });
      }

      updateMessageQuickErrors(message) {
        this.querySelector('.cart-item__error-text').textContent = message;
      }
    }
  );
}

class ShowPassWord extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener('click', this.onClick.bind(this));
  }
  onClick() {
    var input = this.closest('.form-field').querySelector('input');
    if (input.type === 'password') {
      input.type = 'text';
      this.classList.add('text');
    } else {
      input.type = 'password';
      this.classList.remove('text');
    }
  }
}
customElements.define('show-pass-word', ShowPassWord);

class BeforeYouLeave extends HTMLElement {
  constructor() {
    super();
    this._initTimer = setTimeout(() => {
      this.init();
    }, 10000);
  }
  disconnectedCallback() {
    clearTimeout(this._initTimer);
    clearTimeout(this._popupTimer);
    if (this._bodyActivityHandler) {
      ['scroll', 'click', 'mousemove', 'keydown'].forEach((type) =>
        document.body.removeEventListener(type, this._bodyActivityHandler)
      );
    }
  }
  init() {
    const sectionId = this.dataset.sectionId;
    const before_you_leave = document.querySelector(`#${sectionId}`).innerHTML;
    document.querySelector('before-you-leave').innerHTML = before_you_leave;
    setTimeout(() => {
      this.initPopup();
      BlsLazyloadImg.init();
    }, 500);
  }
  initPopup() {
    const element = document.querySelector('before-you-leave');
    const delay = element?.dataset.timeDelay;
    var action = 0;
    if (element !== null) {
      this._popupTimer = setTimeout(() => {
        getTimeOut();
      }, (delay - 10) * 1000);

      // Store named handler so it can be removed later
      this._bodyActivityHandler = () => { setAction(); };

      ['scroll', 'click', 'mousemove', 'keydown'].forEach((type) =>
        document.body.addEventListener(type, this._bodyActivityHandler)
      );

      const closeBefore = document.querySelectorAll('.close-before');
      closeBefore.forEach((event) => {
        event.addEventListener('click', () => {
          clearTimeout(this._popupTimer);
          ['scroll', 'click', 'mousemove', 'keydown'].forEach((type) =>
            document.body.removeEventListener(type, this._bodyActivityHandler)
          );
          element.classList.remove('open');
          document.documentElement.classList.remove('open-byl');
          setTimeout(() => {
            document.documentElement.classList.remove('open-drawer');
            root.style.removeProperty('padding-right');
          }, 550);
        });
      });

      function getTimeOut() {
        action = action + 1;
        if (action >= 1) {
          document.documentElement.classList.add('open-drawer', 'open-byl');
          root.style.setProperty(
            'padding-right',
            getScrollBarWidth.init() + 'px'
          );
          element.classList.add('open');
          const cp = element.querySelectorAll('.discount');
          if (cp !== null) {
            cp.forEach((e) => {
              e.addEventListener('click', (el) => {
                el.preventDefault();
                navigator.clipboard.writeText(e?.dataset.code);
                e.classList.add('action-copy');
                setTimeout(() => {
                  e.classList.remove('action-copy');
                }, 1500);
              });
            });
          }
        }
      }
      function setAction() {
        action = action - 1;
      }
    }
  }
}
customElements.define('before-you-leave', BeforeYouLeave);

class MiniCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const wishlist_items = JSON.parse(
        localStorage.getItem('glozin__wishlist-items')
      );
      const productHandle = this.dataset.productHandle;
      let index = wishlist_items?.indexOf(productHandle);
      if (this.classList.contains('action-add-wishlist')) {
        if (index == -1 || index == undefined) {
          this.closest('.cart-item').querySelector(
            '.minicart__wishlist'
          ).style.display = 'block';
          this.closest('.cart-item').querySelector(
            '.minicart__product-info'
          ).style.display = 'none';
        } else {
          const cartItems = this.closest('cart-notification');
          cartItems.updateQuantity(this.dataset.index, 0);
        }
      } else {
        const cartItems = this.closest('cart-notification');
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define('mini-cart-remove-button', MiniCartRemoveButton);

class MiniCartWishlistAction extends HTMLElement {
  constructor() {
    super();
    this.actionRemoveWishlist();
    this.actionAddWishlist();
    this.actionClose();
  }

  actionRemoveWishlist() {
    this.querySelector('.btn-minicart__remove-js').addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        this.eventRemove(target);
      }
    );
  }

  actionAddWishlist() {
    this.querySelector('.btn-minicart__add-wishlist-js').addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const localListProductIds = localStorage.getItem(
          'glozin__wishlist-items'
        );
        let listProductIds = [];
        let productId = target.dataset.productId;
        if (localListProductIds) {
          const parseLocalListProductIds = JSON.parse(localListProductIds);
          let isProductIdContained =
            parseLocalListProductIds.includes(productId);
          if (!isProductIdContained) {
            listProductIds.push(...parseLocalListProductIds, productId);
          } else {
            listProductIds.push(...parseLocalListProductIds);
          }
        } else {
          listProductIds.push(productId);
        }
        const stringifyListProductIds = JSON.stringify(listProductIds);
        localStorage.setItem('glozin__wishlist-items', stringifyListProductIds);
        this.eventRemove(target);
      }
    );
  }

  eventRemove(target) {
    const cartItems = document.querySelector('cart-notification');
    cartItems.updateQuantity(target.dataset.index, 0);
  }

  actionClose() {
    document.querySelectorAll('.cart-close-wishlist').forEach((items) => {
      items.addEventListener('click', (e) => {
        const target = e.currentTarget;
        e.preventDefault();
        target
          .closest('.cart-item')
          .querySelector('.minicart__wishlist').style.display = 'none';
        target
          .closest('.cart-item')
          .querySelector('.minicart__product-info').style.display = 'block';
      });
    });
  }
}
customElements.define('minicart-wishlist-action', MiniCartWishlistAction);

class CookieBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var _this = this;
    if (!getCookie('cookie_bar')) {
      this.classList.remove('hidden');
    }
    this.querySelectorAll('.cookie-dismiss').forEach((closeCookie) => {
      closeCookie.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          const target = e.currentTarget;
          _this.remove();
          if (target.id == 'cookie-refuse') {
            setCookie('cookie_bar', 'dismiss', 7);
          } else {
            setCookie('cookie_bar', 'dismiss', 30);
          }
        },
        false
      );
    });
  }
}
customElements.define('cookie-bar', CookieBar);

class TermsConditions extends PopupBase {
  constructor() {
    super();
    this.init();
  }
  init() {
    const terms = this.querySelector('a');
    if (terms) {
      terms.addEventListener('click', (e) => {
        e.preventDefault();
        const popup = document.querySelector('#popup-terms-conditions');
        if (popup) {
          const header = popup.getAttribute('data-text');
          this.initPopup(
            popup.querySelector('.terms-conditions-content').outerHTML,
            `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${header}</h3>`
          );
        }
      });
    }
    const conditions =
      this.querySelector('.conditions_form_minicart') ||
      this.querySelector('.conditions_form_product');
    const bpb = document.querySelector('.btn-checkout');
    const dynamicCheckout = this.closest('product-form')?.querySelector(
      '.btn-checkout-dynamic'
    );
    if (conditions) {
      if (getCookie('term_conditions')) {
        conditions.setAttribute('checked', '');
        if (bpb) {
          bpb.removeAttribute('disabled');
        }
        if (dynamicCheckout) {
          dynamicCheckout.classList.remove('disabled');
        }
      }
      conditions.addEventListener('change', (event) => {
        if (bpb) {
          if (event.currentTarget.checked) {
            bpb.removeAttribute('disabled');
            setCookie('term_conditions', 1, 1);
          } else {
            bpb.setAttribute('disabled', '');
            deleteCookie('term_conditions');
          }
        }
        if (dynamicCheckout) {
          if (event.currentTarget.checked) {
            dynamicCheckout.classList.remove('disabled');
            setCookie('term_conditions', 1, 1);
          } else {
            dynamicCheckout.classList.add('disabled');
            deleteCookie('term_conditions');
          }
        }
      });
    }
  }
}
customElements.define('terms-conditions', TermsConditions);

var BlsGlozinAdminLi = (function () {
  return {
    init: function () {
      this.BlsCheckLi();
    },
    BlsCheckLi: function () {
      const _this = this;
      if (typeof glozin_app === 'object') {
        if (glozin_app.mode === 'admin') {
          if (glozin_app.action === 'active') {
            if (_this.checkCookie(glozin_app.lic) === false) {
              let encrypted = '';
              if (glozin_app._e) {
                encrypted = glozin_app._e;
              }
              _this.BlsActive(encrypted);
            }
          } else {
            const url =
              'https://api.nextsky.co/glozin/api/remove-license/?code=' +
              glozin_app.lic +
              '&domain=' +
              glozin_app.shop;
            fetch(url)
              .then((response) => response.json())
              .then((responseText) => {
                if (responseText) {
                  const dateCreate = new Date(new Date().getTime() - 36e6);
                  _this.setCookie(glozin_app.lic, dateCreate);
                }
                _this.BlsRenderHtml(3);
              })
              .catch((e) => {
                console.warn(e);
              });
          }
        }
      } else {
        _this.BlsRenderHtml(0);
      }
    },
    BlsRenderHtml: function (cs) {
      const shop = window.location.hostname.replace(/\./g, '-');
      if (!document.querySelector('#' + 'bls__' + shop)) {
        const container = document.createElement('DIV');
        const wrapper = document.createElement('DIV');
        const title = document.createElement('h3');
        const introText = document.createElement('p');
        const messages = {
          1: 'This purchase code was activated for another domain!',
          2: 'This purchase code is invalid!',
          3: 'Purchase Code deleted successfully!',
          0: 'Welcome Tayler - Shopify Themes OS 2.0 🎉 '
        };
        title.textContent = messages[cs] || messages[0];
        title.setAttribute('class', `msg-${cs}`);
        introText.textContent = 'Follow these simple steps to use Glozin theme:';
        const steps = [
          {
            title: "Step 1: Add Glozin theme file to your 'Online store' > 'Theme'.",
            content: ""
          },
          {
            title: "Step 2: Insert purchase code",
            content: "Go to 'Theme setting' > 'Purchase code' to insert your purchase code."
          },
          {
            title: "Step 3: Activate purchase code",
            content: "Go to 'Theme setting' > 'Purchase code action' and select 'Active purchase code'."
          }
        ];
        const stepElements = steps.map((step, index) => {
          const stepEl = document.createElement('DIV');
          stepEl.setAttribute('class', `step-${index+1}`);
          const heading = document.createElement('h5');
          heading.textContent = step.title;
          stepEl.appendChild(heading);
          
          if (step.content) {
            const content = document.createElement('p');
            content.textContent = step.content;
            stepEl.appendChild(content);
          }
          return stepEl;
        });
        const purchaseLink = document.createElement('a');
        purchaseLink.setAttribute('target', '_blank');
        purchaseLink.setAttribute('class', 'popup-btn');
        purchaseLink.setAttribute('href', 'https://nextsky.gitbook.io/glozin-theme/get-started/purchase-code-and-activation');
        purchaseLink.textContent = '👉 Get Glozin purchase code';
        stepElements[1].appendChild(purchaseLink);
        wrapper.appendChild(title);
        wrapper.appendChild(introText);
        stepElements.forEach(step => wrapper.appendChild(step));
        container.setAttribute('id', 'bls__not-active');
        container.appendChild(wrapper);
        setInterval(() => {
          if (document.getElementById('bls__not-active')) {
            document
              .getElementById('bls__not-active')
              .setAttribute('style', 'display: block !important;');
          } else {
            document.querySelector('body').appendChild(container);
          }
        }, 1000);
      } else {
        document.querySelector('#' + 'bls__' + shop).remove();
      }
    },
    BlsActive: function (encrypted) {
      const _this = this;
      const salt = glozin_app._s || glozin_app.shop + 'GlzSalt25';
      const url =
        'https://api.nextsky.co/glozin/api/check-license/?code=' +
        glozin_app.lic +
        '&domain=' +
        glozin_app.shop + 
        '&e=' + 
        encodeURIComponent(encrypted) +
        '&s=' +
        encodeURIComponent(salt);
      fetch(url)
        .then((response) => response.json())
        .then((responseText) => {
          if (responseText.d === false) {
            _this.BlsRenderHtml(responseText.s);
          } else if (responseText.d === true) {
            const dateCheck = new Date(new Date().getTime() + 36e6);
            _this.setCookie(glozin_app.lic, dateCheck);
          } else if (responseText.d === 'err') {
            console.warn(
              responseText.err
                ? responseText.err.message
                : "Please contact to server's adminstrator!!!"
            );
          }
        })
        .catch((e) => {
          console.warn(e);
        });
    },
    setCookie: function (cvalue, d) {
      const v = btoa(cvalue);
      document.cookie =
        'UHVyY2hhc2VDb2Rl' + '=' + v + ';expires=' + d + ';path=/';
    },
    checkCookie: function (val) {
      const v = atob(getCookie('UHVyY2hhc2VDb2Rl'));
      if (val.length !== 0 && v == val) {
        return true;
      } else {
        return false;
      }
    },
  };
})();
//BlsGlozinAdminLi.init();

class QuickView extends PopupBase {
  constructor() {
    super();
    this.html = null;
  }

  //Tayler modified this onThisClick function.... 20250805
  onThisClick() {
    this.classList.add('loading');
    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        this.html = parser
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-product-quickview .product-quickview__content'
          );
        if (!this.html) return;
        
        // Load scripts in the HTML content
        this.loadScripts(this.html);
        this.html.classList.remove('hidden');
        this.initPopup(this.html);
        // [DTC-819] 注入内容不在 DOMContentLoaded 一次性精修覆盖内，需按真实 IP 单独精修购买态（fetch 结果有缓存，重复打开无额外请求）
        if (typeof refineRegionByRealIP === 'function') refineRegionByRealIP(this.html);
      })
      .finally(() => {
        Shopify.PaymentButton.init();
        if (!document.querySelector('div[data-animation="slide_in"')) {
          BlsLazyloadImg.init();
        }
        this.classList.remove('loading');
      })
      .catch((e) => {
        this.classList.remove('loading');
        console.error(e);
      });
  }

  loadScripts(html) {
    const scripts = html.querySelectorAll('script');
    scripts.forEach((script) => {
      const newScript = document.createElement('script');
      newScript.src = script.src;
      newScript.textContent = script.textContent;
      document.body.appendChild(newScript).parentNode.removeChild(newScript);
    });
  }
}

class ButtonQuickView extends QuickView {
  constructor() {
    super();
    this.url = this.dataset.url;
    this.init();
  }

  init() {
    this.addEventListener('click', this.onThisClick.bind(this));
  }
}
customElements.define('button-quickview', ButtonQuickView);

class ButtonSelectOptions extends QuickView {
  constructor() {
    super();
    this.url = this.dataset.url;
    this.init();
  }

  init() {
    this.addEventListener('click', this.onThisClick.bind(this));
  }
}
customElements.define('select-option', ButtonSelectOptions);

class ButtonWishlist extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.action = this.dataset.action || 'remove';
    this.addTooltip = this.dataset.tooltipAdd || 'Add to wishlist';
    this.removeTooltip = this.dataset.tooltipRemove || 'Remove from wishlist';
    this.redirectTooltip = this.dataset.tooltipRedirect || 'Browse wishlist';
    this.tooltipDiv = this.querySelector('.tooltip-content');
    this.init();
  }

  init() {
    this.initializeWishlistStatus();
    this.addEventListener('click', this.onThisClick.bind(this));
  }

  initializeWishlistStatus() {
    const localListProductIds = localStorage.getItem('glozin__wishlist-items');
    if (!localListProductIds) return;
    const parseLocalListProductIds = JSON.parse(localListProductIds);
    const isProductIdContained = parseLocalListProductIds.includes(
      this.productId
    );
    if (isProductIdContained) {
      this.classList.add('active');
      if (this.tooltipDiv) {
        if (this.action === 'remove') {
          this.tooltipDiv.textContent = this.removeTooltip;
        } else {
          this.tooltipDiv.textContent = this.redirectTooltip;
        }
      }
    }
  }

  actionWhenClicked(allThisProductIds, isAdd) {
    allThisProductIds.forEach((_this) => {
      if (isAdd === true) {
        _this.classList.add('active');
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          if (this.action === 'remove') {
            tooltipDiv.textContent = this.removeTooltip;
          } else {
            tooltipDiv.textContent = this.redirectTooltip;
          }
        }
      } else {
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          tooltipDiv.textContent = this.addTooltip;
        }
        _this.classList.remove('active');
      }
    });
  }

  onThisClick() {
    const localListProductIds = localStorage.getItem('glozin__wishlist-items');
    const allThisProductIds = document.querySelectorAll(
      `button-wishlist[data-product-id="${this.productId}"]`
    );
    let listProductIds = [];
    if (!this.productId) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // wishlist localstorage exists
      const parseLocalListProductIds = JSON.parse(localListProductIds);
      let isProductIdContained = parseLocalListProductIds.includes(
        this.productId
      );
      if (!isProductIdContained) {
        // case item is not in wishlist
        listProductIds.push(...parseLocalListProductIds, this.productId);
        this.actionWhenClicked(allThisProductIds, true);
      } else {
        // case item is in wishlist
        if (this.action) {
          if (this.action === 'remove') {
            const indexOfProductId = parseLocalListProductIds.indexOf(
              this.productId
            );
            parseLocalListProductIds.splice(indexOfProductId, 1);
            listProductIds.push(...parseLocalListProductIds);
            if (this.closest('.wishlist-page-main')) {
              this.closest('.wishlist-list').remove();
              const product = document.querySelectorAll(
                `.wishlist-page-section .product-item__action button-wishlist`
              );
              if (product.length < 1) {
                document
                  .querySelector('.wishlist-no-product-js')
                  .classList.remove('hidden');
              }
            } else {
              this.actionWhenClicked(allThisProductIds, false);
            }
          } else {
            listProductIds.push(...parseLocalListProductIds);
            window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/wishlist`;
          }
        } else {
          listProductIds.push(...parseLocalListProductIds);
        }
      }
    } else {
      // wishlist localstorage not exists ==> create new local storage
      listProductIds.push(this.productId);
      this.actionWhenClicked(allThisProductIds, true);
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem('glozin__wishlist-items', stringifyListProductIds);
    wishlistHeader.init();
  }
}
customElements.define('button-wishlist', ButtonWishlist);

class ButtonCompare extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.action = this.dataset.action || 'remove';
    this.addTooltip = this.dataset.tooltipAdd || 'Compare';
    this.removeTooltip = this.dataset.tooltipRemove || 'Remove from compare';
    this.redirectTooltip = this.dataset.tooltipRedirect || 'Browse compare';
    this.tooltipDiv = this.querySelector('.tooltip-content');
    this.action = this.dataset.action || 'remove';
    this.init();
  }

  init() {
    this.initializeCompareStatus();
    this.addEventListener('click', this.onThisClick.bind(this));
  }

  initializeCompareStatus() {
    const localListProductIds = localStorage.getItem('glozin__compare-items');
    if (!localListProductIds) return;
    const parseLocalListProductIds = JSON.parse(localListProductIds);
    const isProductIdContained = parseLocalListProductIds.includes(
      this.productId
    );
    if (isProductIdContained) {
      this.classList.add('active');
      if (this.tooltipDiv) {
        if (this.action === 'remove') {
          this.tooltipDiv.textContent = this.removeTooltip;
        } else {
          this.tooltipDiv.textContent = this.redirectTooltip;
        }
      }
    }
  }

  actionWhenClicked(allThisProductIds, isAdd) {
    allThisProductIds.forEach((_this) => {
      if (isAdd === true) {
        _this.classList.add('active');
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          if (this.action === 'remove') {
            tooltipDiv.textContent = this.removeTooltip;
          } else {
            tooltipDiv.textContent = this.redirectTooltip;
          }
        }
      } else {
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          tooltipDiv.textContent = this.addTooltip;
        }
        _this.classList.remove('active');
      }
    });
  }

  onThisClick() {
    const localListProductIds = localStorage.getItem('glozin__compare-items');
    const allThisProductIds = document.querySelectorAll(
      `button-compare[data-product-id="${this.productId}"]`
    );
    let listProductIds = [];
    if (!this.productId) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // compare localstorage exists
      const parseLocalListProductIds = JSON.parse(localListProductIds);
      let isProductIdContained = parseLocalListProductIds.includes(
        this.productId
      );
      if (!isProductIdContained) {
        // case item is not in compare
        listProductIds.push(...parseLocalListProductIds, this.productId);
        this.actionWhenClicked(allThisProductIds, true);
      } else {
        // case item is in compare
        if (this.action) {
          if (this.action === 'remove') {
            const indexOfProductId = parseLocalListProductIds.indexOf(
              this.productId
            );
            parseLocalListProductIds.splice(indexOfProductId, 1);
            listProductIds.push(...parseLocalListProductIds);
            this.actionWhenClicked(allThisProductIds, false);
          } else {
            listProductIds.push(...parseLocalListProductIds);
            window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/compare`;
          }
        } else {
          listProductIds.push(...parseLocalListProductIds);
        }
      }
    } else {
      // compare localstorage not exists ==> create new local storage
      listProductIds.push(this.productId);
      this.actionWhenClicked(allThisProductIds, true);
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem('glozin__compare-items', stringifyListProductIds);
  }
}
customElements.define('button-compare', ButtonCompare);

class SwatchFunctions extends SwatchInit {
  constructor() {
    super();
    this.init();
  }

  showColorSwatch() {
    const _this = this;
    if (_this.show_color_swatch != null) {
      _this.show_color_swatch.addEventListener('click', (e) => {
        e.currentTarget.classList.add('hidden');
        _this
          .querySelectorAll('.product__color-swatches--js.hidden')
          .forEach((btn) => {
            btn.classList.remove('hidden');

            setTimeout(() => {
              btn.classList.remove('opacity-0');
            }, 100);
          });
      });
    }
  }

  init() {
    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      this.checkSwatches(btn);
    });
    this.initAction();
    this.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.equalizeSpanWidths();
  }

  equalizeSpanWidths() {
    requestAnimationFrame(() => {
      const items = this.querySelectorAll('.product__color-swatches--js > span');
      if (items.length < 2) return;
      let maxWidth = 0;
      items.forEach((item) => {
        item.style.minWidth = '';
        const width = item.getBoundingClientRect().width;
        if (width > maxWidth) maxWidth = width;
      });
      items.forEach((item) => {
        item.style.minWidth = Math.ceil(maxWidth) + 'px';
      });
    });
  }

  initAction() {
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.productTarget = this.closest('.product__item-js');
    const target = e.target;
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector('.productVariantsQty').textContent
    );
    this.groupFunctionsInit();
    if (!this.currentVariant) {
      this.groupFunctionsUnavailable(target);
    } else {
      this.groupFunctionsAvailable(variantQtyData, target);
    }
  }
  groupFunctionsInit() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    //this.updateMediaSticky(); //Tayler disabled it.... 20250807
  }
  groupFunctionsUnavailable(target) {
    this.toggleAddButton(true, '', true);
    this.setUnavailable(target);
  }
  groupFunctionsAvailable(variantQtyData, target) {
    this.updateURL();
    this.updateVariantInput();
    this.updatePrice(this.productTarget);
    this.renderProductInfor(this.productTarget, variantQtyData, target);
    this.updateShareUrl();
    this.setAvailable();
  }
  updatePrice(productTarget) {
    if (!this.currentVariant) return;
    if (!productTarget) return;
    const p = document.getElementById(`price-${this.dataset.section}`);
    if (p) p.classList.remove('visibility-hidden');
    const compare_at_price = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    const unit_price = this.currentVariant.unit_price;
    const unit_price_measurement = this.currentVariant.unit_price_measurement;
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      themeGlobalVariables.settings.money_format
    );
    if (unit_price && unit_price_measurement) {
      const price_num = Shopify.formatMoney(
        unit_price,
        themeGlobalVariables.settings.money_format
      );
      const price_unit =
        unit_price_measurement.reference_value != 1
          ? unit_price_measurement.reference_value
          : unit_price_measurement.reference_unit;
      if (productTarget.querySelector('.unit-price .number')) {
        productTarget.querySelector('.unit-price .number').innerHTML =
          price_num;
      }
      if (productTarget.querySelector('.unit-price .unit')) {
        productTarget.querySelector('.unit-price .unit').innerHTML = price_unit;
      }
    }
    if (productTarget.querySelector('.price-regular .price')) {
      productTarget.querySelector('.price-regular .price').innerHTML =
        price_format;
    }
    const bls__price = productTarget.querySelector('.card-product-price');
    if (bls__price) {
      if (!bls__price.querySelector('.compare-price')) {
        var ps = document.createElement('div');
        var sp = document.createElement('span');
        var cp = document.createElement('s');
        cp.classList.add('price-item', 'compare-price');
        sp.appendChild(cp);
        ps.appendChild(sp);
        ps.classList.add('price-regular');
        if (productTarget.querySelector('.card-product-price')) {
          productTarget.querySelector('.card-product-price').appendChild(ps);
        }
      }
      const cpp = bls__price.querySelector('.compare-price');

      if (cpp) {
        if (compare_at_price && compare_at_price > price) {
          const compare_format = Shopify.formatMoney(
            compare_at_price,
            themeGlobalVariables.settings.money_format
          );
          cpp.innerHTML = compare_format;
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.add('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price
              .querySelector('.price-regular .price')
              .classList.add('price--special');
          }
        } else {
          cpp.innerHTML = '';
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.remove('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price.querySelector('.price-regular .price').innerHTML =
              price_format;
            bls__price
              .querySelector('.price-regular .price')
              .classList.remove('price--special');
          }
        }
        if (!this.currentVariant.available) {
          bls__price.classList.add('price--sold-out');
        }
      }
    }
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
  setUnavailable(target) {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (target) {
      const fieldset = target.closest('fieldset');
      const val = target.value;
      const optionSelected = fieldset.querySelector('.option_value');
      optionSelected.textContent = val;
    }
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  setAvailable() {
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (price && price.classList.contains('hidden'))
      price.classList.remove('hidden');
    if (inventory && inventory.classList.contains('hidden'))
      inventory.classList.remove('hidden');
    if (sku && sku.classList.contains('hidden')) sku.classList.remove('hidden');
    if (pricePerItem && pricePerItem.classList.contains('hidden'))
      pricePerItem.classList.remove('hidden');
    if (volumeNote && volumeNote.classList.contains('hidden'))
      volumeNote.classList.remove('hidden');
    if (volumeTable && volumeTable.classList.contains('hidden'))
      volumeTable.classList.remove('hidden');
    if (qtyRules && qtyRules.classList.contains('hidden'))
      qtyRules.classList.remove('hidden');
  }
  updateMedia(variantGroup = false) {
    if (!this.productTarget) return;
    const mediaGalleries = this.productTarget.querySelector('media-gallery');
    const layout = mediaGalleries?.dataset.layout;
    if (!layout) return;
    if (layout === 'thumbnail') {
      const swiper = mediaGalleries.querySelector('slide-with-thumbs');
      if (!swiper) return;
      const slide_items = swiper.querySelectorAll(
        '.swiper-wrapper-preview .media-gallery__image.swiper-slide'
      );

      if (slide_items.length == 0) return;

      if (!this.currentVariant?.featured_media) return;

      const targetIndex = Array.from(slide_items).findIndex(e => {
        const mediaId = e.getAttribute('data-media-id');
        return mediaId && mediaId === `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      });

      if (targetIndex !== -1) {
        const e = slide_items[targetIndex];
        const position = e.getAttribute('data-position');
        const gotoIndex = !variantGroup ? position - 1 : targetIndex;

        if (typeof swiper.functionGoto === 'function') {
          swiper.functionGoto(gotoIndex);
        } else {
          customElements.whenDefined('slide-with-thumbs').then(() => {
            if (typeof swiper.functionGoto === 'function') {
              swiper.functionGoto(gotoIndex);
            }
          });
        }
      }
    } else {
      // mediaGalleries.setActiveMedia(
      //   `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      //   true
      // );
      const mediaElement = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
      if (mediaElement) {
        mediaElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
  updateMediaSticky() {
    if (!this.productTarget) return;
    if (!this.currentVariant) return;
    const stickyAddCart = this.productTarget.querySelector('sticky-add-cart');
    if (!stickyAddCart) return;
    if (!this.currentVariant.featured_media) return;
    const imgQuery = stickyAddCart.querySelector('img');
    imgQuery.src = this.currentVariant.featured_media.preview_image.src;
    imgQuery.removeAttribute('srcset');
    imgQuery.removeAttribute('sizes');
  }
  renderProductInfor(productTarget, variantQtyData, target) {
    if (!this.currentVariant) return;
    if (!productTarget) return;
    let qty = 0;
    let percent = 0;
    let sale = false;
    let soldOut = false;
    let pre_order = false;
    let av = this.currentVariant.available;
    let sku = this.currentVariant.sku;
    let im = this.currentVariant.inventory_management;
    const compare_at_price = this.currentVariant.compare_at_price;

    const price = this.currentVariant.price;
    let avaiable = productTarget.querySelector('.available-value');
    let sku_area = productTarget.querySelector('.product__sku');
    // Update option labels
    const productDetailPicker = productTarget.querySelector(
      '.product-detail__variant-picker'
    );
    if (productDetailPicker) {
      const type = productDetailPicker.dataset.type || 'swatches';

      const updateOptionValues = (selector) => {
        const optionElements = productTarget.querySelectorAll(selector);
        optionElements.forEach((element, index) => {
          const optionValue = this.currentVariant[`option${index + 1}`];
          if (optionValue) {
            element.innerHTML = optionValue;
          }
        });
      };

      if (type === 'swatches') {
        updateOptionValues('.option_value');
      } else {
        updateOptionValues('.option_drop_value .option_value');
        updateOptionValues('swatch-dropdown-select-value .option_value');

        const closestSwatchDropdown = target.closest('swatch-dropdown');
        if (
          closestSwatchDropdown &&
          closestSwatchDropdown.classList.contains('active')
        ) {
          closestSwatchDropdown.classList.remove('active');
        }
      }
    }

    if (sku_area) sku_area.innerHTML = sku ? sku : 'N/A';
    variantQtyData.find((variantQty) => {
      if (variantQty.id === this.currentVariant.id) {
        qty = Number(variantQty.qty) || 0;
        av = variantQty.available;
        im = variantQty.mamagement === '' ? null : variantQty.mamagement;
      }
    });

    const countdown = document.querySelector('stock-countdown');
    if (countdown) {
      const itemsLeft = countdown.dataset.itemsLeft;
      const message = countdown.dataset.message;
      if (itemsLeft >= qty && message && qty >= 1) {
        countdown.classList.add('block');
        countdown.classList.remove('hidden');
        const qt = countdown.querySelector('span.count');
        const progressbar = countdown.querySelector('.progressbar-stock');
        let widthProgress;
        if ((qty / itemsLeft) * 100 > 100) {
          widthProgress = 100;
        } else {
          widthProgress = (qty / itemsLeft) * 100;
        }
        progressbar.style.setProperty('--percent', `100%`);

        setTimeout(() => {
          progressbar.style.setProperty('--percent', `${widthProgress}%`);
        }, 850);
        if (qt) {
          qt.innerHTML = qty;
        }
      } else {
        countdown.classList.remove('block');
        countdown.classList.add('hidden');
      }
    }

    const typePercent = productTarget.querySelector(
      '.product__badges-type-percent'
    );
    if (compare_at_price && compare_at_price > price) {
      sale = true;
      if (typePercent) {
        percent = ((compare_at_price - price) / compare_at_price) * 100;
      } else {
        percent = compare_at_price - price;
      }
    }
    if (im === null || im === '' || im === undefined) {
      soldOut = false;
      pre_order = false;
      if (avaiable) {
        avaiable.innerHTML = window.variantStrings.inStock;
      }
    } else {
      if (av) {
        const preOrderEnabled = !!productTarget.querySelector(
          'product-form[data-pre-order-enabled="true"]'
        );
        if (qty < 1 && preOrderEnabled) {
          pre_order = true;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.preOrder;
          }
        } else {
          pre_order = false;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.inStock;
          }
        }
      } else {
        soldOut = true;
        if (avaiable) {
          avaiable.innerHTML = window.variantStrings.outStock;
        }
      }
    }
    this.renderLabel(sale, pre_order, soldOut, percent, productTarget);
    this.renderBtnStatus(productTarget, im, av, qty, pre_order);
  }
  //Tayler alterred the function...20151014
  /*
  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    const label = productTarget.querySelector('.product__badges');
    const sale_badge = productTarget.querySelector('.sale_badge');
    const productBadgesScrolling = productTarget.querySelector(
      '.product__badges-sale-scrolling'
    );
    if (sale || pre_order || soldOut) {
      if (!label) {
        var element = document.createElement('div');
        element.classList.add(
          'product__badges',
          'fs-small',
          'flex',
          'flex-wrap',
          'gap-5',
          'uppercase'
        );
        if (sale_badge) {
          sale_badge.appendChild(element);
        }
      }
    }

    if (label) {
      const saleColor = label.dataset.saleColor;
      const soldOutColor = label.dataset.soldOutColor;
      const preOrderColor = label.dataset.preOrderColor;
      const saleBg = label.dataset.saleBg;
      const soldOutBg = label.dataset.soldOutBg;
      const preOrderBg = label.dataset.preOrderBg;
      const show_sale = label?.dataset.showSale === 'true';
      const show_pre_order = label?.dataset.showPreorder === 'true';
      const show_sold_out = label?.dataset.showSoldOut === 'true';
      const prd = Shopify.formatMoney(
        percent,
        themeGlobalVariables.settings.money_format
      );
      const dsale = label.querySelector('.product__badges-sale');
      const dsoldout = label.querySelector('.product__badges-sold-out');
      const dpreorder = label.querySelector('.product__badges-pre-order');
      const typePrice = label.querySelector('.product__badges-type-price');
      const typePercent = label.querySelector('.product__badges-type-percent');
      if (sale && show_sale) {
        if (!dsale) {
          var elementsale = document.createElement('div');
          elementsale.classList.add(
            'product__badges-sale',
            'product__badges-inner',
            'px-15',
            'align-self-start',
            'sale',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementsale.style.setProperty('--badges-color', saleColor);
          elementsale.style.setProperty('--badges-bg', saleBg);

          if (dsoldout) {
            label.insertBefore(elementsale, dsoldout);
          } else if (dpreorder) {
            label.insertBefore(elementsale, dpreorder);
          } else {
            label.appendChild(elementsale);
          }
        } else {
          if (typePrice) {
            dsale.innerHTML = `${
              window.variantStrings.save ? window.variantStrings.save : 'Save'
            } ${prd}`;
          } else if (typePercent) {
            dsale.innerHTML = -percent.toFixed(0) + '%';
          }
        }
      } else {
        dsale?.remove();
      }
      if (pre_order && show_pre_order) {
        if (!dpreorder) {
          var elementpo = document.createElement('div');
          elementpo.classList.add(
            'product__badges-pre-order',
            'product__badges-inner',
            'py-8',
            'px-15',
            'align-self-start',
            'pre-order',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementpo.style.setProperty('--badges-color', preOrderColor);
          elementpo.style.setProperty('--badges-bg', preOrderBg);
          elementpo.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : 'Pre-order';
          label.appendChild(elementpo);
        } else {
          dpreorder.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : 'Pre-order';
        }
      } else {
        dpreorder?.remove();
      }
      if (soldOut && show_sold_out) {
        if (!dsoldout) {
          var elementso = document.createElement('div');
          elementso.classList.add(
            'product__badges-sold-out',
            'product__badges-inner',
            'py-8',
            'px-15',
            'align-self-start',
            'sold-out',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementso.style.setProperty('--badges-color', soldOutColor);
          elementso.style.setProperty('--badges-bg', soldOutBg);
          elementso.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : 'Sold out';
          label.appendChild(elementso);
        } else {
          dsoldout.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : 'Sold out';
        }
      } else {
        dsoldout?.remove();
      }
    }

    if (productBadgesScrolling && sale) {
      const dataBadgesScrolling =
        productBadgesScrolling?.dataset.textProductScrolling;
      const allProductBadgesScrolling = productBadgesScrolling.querySelectorAll(
        '.content-badges-scrolling'
      );
      allProductBadgesScrolling.forEach((content) => {
        content.innerText = dataBadgesScrolling.replace(
          '[percent_sale]',
          percent.toFixed(0) + '%'
        );
      });
    }
  }*/

  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    const label = productTarget.querySelector('.product__badges');
    if (!label) return;

    const dsale = label.querySelector('.product__badges-sale');
    const dsoldout = label.querySelector('.product__badges-sold-out');
    const dpreorder = label.querySelector('.product__badges-pre-order');

    const show_sale = label.dataset.showSale === 'true';
    const show_sold_out = label.dataset.showSoldOut === 'true';
    const show_pre_order = label.dataset.showPreorder === 'true';

    // 1. 处理 Sale 徽章
    if (sale && show_sale && dsale) {
      const prd = Shopify.formatMoney(percent, window.cartStrings?.money_format);
      
      if (dsale.classList.contains('product__badges-type-percent')) {
        dsale.innerHTML = `-${percent.toFixed(0)}%`;
      } else if (dsale.classList.contains('product__badges-type-price')) {
        dsale.innerHTML = `${window.variantStrings.save ? window.variantStrings.save : 'Save'} ${prd}`;
      } else {
        dsale.innerHTML = window.variantStrings.sale_label || 'Sale';
      }
      dsale.classList.remove('hidden-important');
    } else if (dsale) {
      dsale.classList.add('hidden-important');
    }

    // 2. 处理 Sold Out 和 Pre-order 徽章 (它们是互斥的)
    // [DTC-768] 非售卖区 IP（data-region-out，服务端初始+真实 IP 精修写回）不展示售罄徽章，变体切换不得复显
    const regionOut = label.dataset.regionOut === 'true';
    if (soldOut && show_sold_out && dsoldout && !regionOut) {
      dsoldout.classList.remove('hidden-important');
      if (dpreorder) dpreorder.classList.add('hidden-important'); // 如果售罄，则强制隐藏预购
    } else {
      if (dsoldout) dsoldout.classList.add('hidden-important');

      // 仅在未售罄时检查预购
      if (pre_order && show_pre_order && dpreorder) {
        dpreorder.classList.remove('hidden-important');
      } else if (dpreorder) {
        dpreorder.classList.add('hidden-important');
      }
    }
    
    // 3. (可选) 处理滚动文本
    const productBadgesScrolling = productTarget.querySelector('.product__badges-sale-scrolling');
    if (productBadgesScrolling) {
      if (sale) {
        const dataBadgesScrolling = productBadgesScrolling.dataset.textProductScrolling;
        const allProductBadgesScrolling = productBadgesScrolling.querySelectorAll('.content-badges-scrolling');
        allProductBadgesScrolling.forEach((content) => {
          content.innerText = dataBadgesScrolling.replace('[percent_sale]', `${percent.toFixed(0)}%`);
        });
      }
    }
  }

  renderBtnStatus(productTarget, im, av, qty, pre_order = false) {
    if (!productTarget) return;
    let btns_add_cart = productTarget.querySelectorAll(
      '.product_submit_button'
    );
    const productForms = productTarget.querySelectorAll('product-form');
    productForms.forEach((productForm) => {
      productForm.dataset.available = av ? 'true' : 'false';
      productForm.dataset.preOrder = pre_order ? 'true' : 'false';
    });
    btns_add_cart.forEach((btn_add_cart) => {
      if (btn_add_cart.querySelector('.btn-label')) {
      	//Sharon modified here.... 20260421
        if (av) {
          // DTC-410 (redo): pre-order overrides Add to Cart text when applicable
          btn_add_cart.querySelector('.btn-label').innerHTML = pre_order
            ? window.variantStrings.preOrder
            : window.variantStrings.addToCart;
          btn_add_cart.disabled = false;
        } else {
          btn_add_cart.querySelector('.btn-label').innerHTML =
            window.variantStrings.soldOut;
          btn_add_cart.disabled = true;
        }
      }
    });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('option-disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              '[value]',
              value
            );
      }
    });
  }
  updateOptions() {
    this.options = [];
    Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        let array = element.value.split(' / ');
        array.forEach((item) => this.options.push(item));
      }
      if (element.tagName === 'FIELDSET') {
        this.options.push(
          Array.from(element.querySelectorAll('input')).find(
            (radio) => radio.checked
          )?.value
        );
      }
    });
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', url.toString());
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #sticky-addcart-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateShareUrl() {
    const copyButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!copyButton || !copyButton.updateUrl) return;
    copyButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    const copyParent = copyButton.closest('.share__content');
    if (!copyParent) return;
    const copySpan = copyParent.querySelector('.copy__url');
    if (!copySpan) return;
    copySpan.innerHTML = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
//Function click dropdown variant
class SwatchDropdownSelectValue extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }

  activeFilterSort() {
    // Remove active class from all elements except the clicked one
    document.querySelectorAll('.select-custom.active').forEach((element) => {
      if (element !== this.closest('.select-custom')) {
        element.classList.remove('active');
      }
    });

    // Toggle active class on the clicked element
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define(
  'swatch-dropdown-select-value',
  SwatchDropdownSelectValue
);

// Function to remove active class when clicking outside
function handleClickOutside(event) {
  if (!event.target.closest('.select-custom')) {
    document.querySelectorAll('.select-custom.active').forEach((element) => {
      element.classList.remove('active');
    });
  }
}

// Add event listener to the document
document.addEventListener('click', handleClickOutside);
// End function click dropdown variant

class VariantRadios extends SwatchFunctions {
  constructor() {
    super();
    this.show_color_swatch = this.querySelector('.show_color_swatch');
    this.showColorSwatch();
  }

  init() {
    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      this.checkSwatches(btn);
      this.variantHover(btn);
      btn.addEventListener('click', this.onVariantChange.bind(this), false);
    });
  }

  variantHover(e) {
    const productTarget = e.closest('.product-item');
    if (!productTarget) return;

    const swiperElement = e.closest('.swiper');
    if (!swiperElement) return;

    let timeout;

    const handleMouseOut = () => {
      swiperElement.classList.remove('show-tooltip');
    };

    const handleMouseOver = () => {
      swiperElement.classList.add('show-tooltip');
    };

    e.addEventListener('mouseout', handleMouseOut, false);
    e.addEventListener('mouseover', handleMouseOver, false);
    e.addEventListener('mouseenter', handleMouseOver, false);
    e.addEventListener('mouseleave', handleMouseOut, false);
  }
  onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    this.productTarget = this.closest('.product__item-js');
    this.position_swatch = target.dataset.position;
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector('.productItemVariantsQty').textContent
    );
    if (!target.classList.contains('active')) {
      const activeSwatches = target
        .closest('.product__color-swatches')
        .querySelectorAll('.product__color-swatches--js');
      activeSwatches.forEach((el) => {
        el.classList.remove('active');
      });
      target.classList.toggle('active');
      this.groupFunctionsInit(this.getVariantData());
      if (this.currentVariant) {
        this.groupFunctionsAvailable(variantQtyData);
      }
    }
  }
  groupFunctionsInit(variantData) {
    this.updateOptions();
    this.updateMasterId(variantData);
  }
  groupFunctionsAvailable(variantQtyData) {
    this.updatePrice();
    this.updateMedia();
    this.renderProductInfor(variantQtyData);
    this.updateSelectOptionUrl();
  }
  updateSelectOptionUrl() {
    if (!this.currentVariant || !this.productTarget) return;
    const selectOption = this.productTarget.querySelector('select-option');
    if (!selectOption) return;
    const baseUrl = (selectOption.dataset.url || '').split('&variant=')[0];
    const newUrl = baseUrl + '&variant=' + this.currentVariant.id;
    selectOption.dataset.url = newUrl;
    selectOption.url = newUrl;
  }
  updatePrice() {
    if (!this.currentVariant) return;
    if (!this.productTarget) return;
    const p = document.getElementById(`price-${this.dataset.section}`);
    if (p) p.classList.remove('visibility-hidden');
    const compare_at_price = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    const unit_price = this.currentVariant.unit_price;
    const unit_price_measurement = this.currentVariant.unit_price_measurement;
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      themeGlobalVariables.settings.money_format
    );
    if (unit_price && unit_price_measurement) {
      const price_num = Shopify.formatMoney(
        unit_price,
        themeGlobalVariables.settings.money_format
      );
      const price_unit =
        unit_price_measurement.reference_value != 1
          ? unit_price_measurement.reference_value
          : unit_price_measurement.reference_unit;
      if (this.productTarget.querySelector('.unit-price .number')) {
        this.productTarget.querySelector('.unit-price .number').innerHTML =
          price_num;
      }
      if (this.productTarget.querySelector('.unit-price .unit')) {
        this.productTarget.querySelector('.unit-price .unit').innerHTML =
          price_unit;
      }
    }
    if (this.productTarget.querySelector('.price-regular .price')) {
      this.productTarget.querySelector('.price-regular .price').innerHTML =
        price_format;
    }
    const bls__price = this.productTarget.querySelector('.card-product-price');
    if (bls__price) {
      if (!bls__price.querySelector('.compare-price')) {
        var ps = document.createElement('div');
        var sp = document.createElement('span');
        var cp = document.createElement('s');
        cp.classList.add('price-item', 'dark-gray', 'compare-price');
        sp.appendChild(cp);
        ps.appendChild(sp);
        ps.classList.add('price-sale');
        if (this.productTarget.querySelector('.card-product-price')) {
          this.productTarget
            .querySelector('.card-product-price')
            .appendChild(ps);
        }
      }
      const cpp = bls__price.querySelector('.compare-price');
      if (cpp) {
        if (compare_at_price && compare_at_price > price) {
          const compare_format = Shopify.formatMoney(
            compare_at_price,
            themeGlobalVariables.settings.money_format
          );
          cpp.innerHTML = compare_format;
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.add('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price
              .querySelector('.price-regular .price')
              .classList.add('price--special');
          }
        } else {
          cpp.innerHTML = '';
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.remove('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price
              .querySelector('.price-regular .price')
              .classList.remove('price--special');
            bls__price.querySelector('.price-regular .price').innerHTML =
              price_format;
          }
        }
        if (!this.currentVariant.available) {
          bls__price.classList.add('price--sold-out');
        }
      }
    }
  }
  renderProductInfor(variantQtyData) {
    if (!this.currentVariant) return;
    if (!this.productTarget) return;
    let qty = 0;
    let percent = 0;
    let sale = false;
    let soldOut = false;
    let pre_order = false;
    let av = false;
    let im = false;
    const compare_at_price = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    const productTarget = this.productTarget;
    const productBadgesScrolling = productTarget.querySelector(
      '.product__badges-sale-scrolling'
    );
    const typePercent = productTarget.querySelector(
      '.product__badges-type-percent'
    );
    const vqd = variantQtyData.reduce((acc, item) => {
      const existingItem = acc.find((i) => i.option === item.option);
      if (existingItem) {
        existingItem.qty += item.qty;
        if (item.available === true) {
          existingItem.available = true;
        }
        if (item.mamagement === '') {
          existingItem.mamagement = '';
        }
      } else {
        acc.push(item);
      }
      return acc;
    }, []);
    vqd.find((variantQty) => {
      if (variantQty.option === this.currentVariant.option1) {
        qty = variantQty.qty;
        av = variantQty.available;
        im = variantQty.mamagement;
      }
    });
    if (compare_at_price && compare_at_price > price) {
      sale = true;
      if (productBadgesScrolling || typePercent) {
        percent = ((compare_at_price - price) / compare_at_price) * 100;
      } else {
        percent = compare_at_price - price;
      }
    }
    if (im === '') {
      soldOut = false;
      pre_order = false;
    } else {
      //Sharon modified here.... 20260421
      if (!av) {
        soldOut = true;
      }
    }
    this.renderLabel(sale, pre_order, soldOut, percent, this.productTarget);
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
  updateOptions() {
    this.options = Array.from(
      this.productTarget.querySelectorAll(
        '.product__color-swatches--js.active'
      ),
      (select) => select.getAttribute('data-value')
    );

    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  async updateMedia() {
    if (!this.currentVariant) return;
    if (
      !this.productTarget
        .querySelector('.product__media img')
        .classList.contains('hidden')
    ) {
      const productItem = this.productTarget
        .querySelector('.product__media img')
        .closest('.product-item');
      if (
        productItem.querySelector('video') ||
        productItem.querySelector('iframe')
      ) {
        this.productTarget
          .querySelector('.product__media img')
          .classList.add('hidden');
        productItem.querySelector('video')?.classList.remove('hidden');
        productItem.querySelector('iframe')?.classList.remove('hidden');
      }
    }
    if (!this.currentVariant.featured_media) return;
    if (this.productTarget.querySelector('.product__media img')) {
      this.productTarget
        .querySelector('.product__media img')
        .removeAttribute('srcset');
    }
    if (
      this.productTarget
        .querySelector('.product__media img')
        .classList.contains('hidden')
    ) {
      this.productTarget
        .querySelector('.product__media img')
        .classList.remove('hidden');
      const productItem = this.productTarget
        .querySelector('.product__media img')
        .closest('.product-item');
      if (
        productItem.querySelector('video') ||
        productItem.querySelector('iframe')
      ) {
        productItem.querySelector('video')?.classList.add('hidden');
        productItem.querySelector('iframe')?.classList.add('hidden');
      }
    }
    if (this.productTarget.querySelector('.product__media img')) {
      await motion.animate(
        this.productTarget.querySelector('.product__media img'),
        { opacity: [1, 0] },
        { duration: 0.1, easing: 'ease-in' }
      );
      this.productTarget
        .querySelector('.product__media img')
        .setAttribute(
          'src',
          this.currentVariant.featured_media.preview_image.src
        );
      await new Promise((resolve) => {
        this.productTarget.querySelector('.product__media img').onload = () => {
          resolve();
        };
      });
      motion.animate(
        this.productTarget.querySelector('.product__media img'),
        { opacity: [0, 1] },
        { duration: 0.1, easing: 'ease-in' }
      );
    }
  }
}
customElements.define('variant-radios', VariantRadios);

class VariantRadiosDetail extends SwatchFunctions {
  constructor() {
    super();
  }
  groupFunctionsAvailable(variantQtyData, target) {
    this.updateURL();
    this.updateVariantInput();
    this.updatePrice(this.productTarget);
    this.renderProductInfor(this.productTarget, variantQtyData, target);
    if (this.closest('.product-quickview__content')) {
      this.updateMediaQuickView();
    } else {
      this.updateMedia();
    }
    this.updateShareUrl();
    this.mapStickyDropdown();
    this.setAvailable();
  }
  updateMediaQuickView() {
    if (!this.currentVariant) return;
    const container = this.closest('.product__item-js');
    if (!container) return;
    const productHandle = container.dataset.productHandle || this.dataset.productHandle;
    const mediaContainer = container.querySelector('media-gallery');
    if (!productHandle || !mediaContainer) return;
    if (this._qvAbort) this._qvAbort.abort();
    this._qvAbort = new AbortController();
    const productUrl = container.dataset.productUrl || `/products/${productHandle}`;
    const url = `${productUrl}?section_id=product-quickview&variant=${this.currentVariant.id}`;
    mediaContainer.classList.add('skeleton-loading', 'opacity-50');
    fetch(url, { signal: this._qvAbort.signal })
      .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newMedia = html.querySelector('.product__item-js media-gallery');
        if (newMedia) {
          mediaContainer.innerHTML = newMedia.innerHTML;
          const swt = mediaContainer.querySelector('slide-with-thumbs');
          if (swt && typeof swt.init === 'function') {
            if (swt.globalSlide) swt.globalSlide.destroy(true, true);
            if (swt.thumbnailSlide) swt.thumbnailSlide.destroy(true, true);
            swt.init();
          }
          BlsLazyloadImg.init();
        }
      })
      .catch(e => { if (e.name !== 'AbortError') console.error(e); })
      .finally(() => mediaContainer.classList.remove('skeleton-loading', 'opacity-50'));
  }
  mapStickyDropdown() {
    if (!this.currentVariant || !this.productTarget) return;

    const stickyAddCart = this.productTarget.querySelector('sticky-add-cart');
    if (!stickyAddCart) return;

    const select = stickyAddCart.querySelector('select');
    const detailRadio = this.productTarget.querySelector(
      'variant-radios-detail, variant-group-detail'
    );
    if (!select && detailRadio) return;

    for (let i = 0; i < select.options.length; i++) {
      if (select.options[i].value === this.currentVariant.title) {
        select.options[i].selected = true;

        detailRadio.querySelectorAll('fieldset').forEach((fieldset, index) => {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.removeAttribute('checked');
            if (input.value === this.currentVariant[`option${index + 1}`]) {
              input.checked = true;
            }
          });
        });
        break;
      }
    }
  }
}
customElements.define('variant-radios-detail', VariantRadiosDetail);

class VariantRadiosSingle extends SwatchFunctions {
  constructor() {
    super();
  }
  groupFunctionsAvailable(variantQtyData) {
    this.updateVariantInput();
    this.updatePrice(this.productTarget);
    this.renderProductInfor(this.productTarget, variantQtyData);
    this.updateMedia();
  }
}
customElements.define('variant-radios-single', VariantRadiosSingle);

//Tayler supercharged the performance.... 20250805
class VariantGroupDetail extends VariantRadiosDetail {
  constructor() {
    super();
    // 构造函数是添加事件监听的最佳位置
    this._attachPreloadEvents();
  }

  // --- 新增的方法 ---
  _attachPreloadEvents() {
    this.preloadedImages = new Set(); // 用一个 Set 来防止重复预加载同一张图片
    const swatches = this.querySelectorAll("[data-preload-src]");

    swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', (event) => {
        const target = event.currentTarget;
        const imageUrlToPreload = target.dataset.preloadSrc;

        if (imageUrlToPreload && !this.preloadedImages.has(imageUrlToPreload)) {
          // 创建一个内存中的 Image 对象来触发浏览器下载
          const img = new Image();
          img.src = imageUrlToPreload;
          
          this.preloadedImages.add(imageUrlToPreload);
          //console.log('Preloading image:', imageUrlToPreload); // 调试日志
        }
      });
    });
  }

  onVariantChange(e) {
    this.productTarget = this.closest('.product__item-js');
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector('.productVariantsQty').textContent
    );
    this.groupFunctionsInit();

    if (!this.currentVariant) {
      this.groupFunctionsUnavailable(e.target);
      this.checkColorGroup(e);
    } else {
      if (this.closest('.product-quickview__content')) {
        this.updateMediaQuickView();
      } else {
        this.checkColorGroup(e);
      }
      this.updateURL();
      this.updateVariantInput();
      this.updatePrice(this.productTarget);
      this.renderProductInfor(this.productTarget, variantQtyData, e.target);
      this.updateShareUrl();
      this.mapStickyDropdown();
      this.setAvailable();
    }
  }

  checkColorGroup(e) {
    const colorString = this.productTarget.dataset.colorTrigger;
    if (colorString) {
      const colorArray = colorString.split(',');
      const colorSelector = this.productTarget.querySelector(
        `[data-value='${CSS.escape(e.target.value)}']`
      );
      const dataName = colorSelector?.dataset.name;
      const isColorInput = colorArray.includes(
        dataName ? dataName : e.target.name
      );
      if (isColorInput) {
        const dataValue = colorSelector?.dataset.colorValue;
        this.updateMediaGroup(dataValue ? dataValue : e.target.value);
      } else {
        this.updateMedia();
      }
    }
  }

  /*updateMediaGroup(altValue) {
    const productHandle = this.dataset.productHandle;
    const desktopLayout = this.productTarget.dataset.desktopLayout;
    const mobileLayout = this.productTarget.dataset.mobileLayout;
    const zoom = this.productTarget.dataset.zoom;
    const sectionId = this.productTarget.dataset.section;
    const zoomAction = this.productTarget.querySelector('zoom-action');
    const elementFeatureProduct = this.productTarget.dataset.typeElement;
    if (!productHandle || !sectionId || !desktopLayout) return;
    if (
      desktopLayout !== 'grid_1_column' &&
      desktopLayout !== 'grid_2_column' &&
      desktopLayout !== 'stack'
    ) {
      fetch(`/products/${productHandle}?section_id=media-gallery-slide`)
        .then((response) => response.text())
        .then((text) => {
          const html = parser.parseFromString(text, 'text/html');
          if (!html) return;
          let parentDiv = html.querySelector('slide-with-thumbs');
          parentDiv.classList.add(desktopLayout);
          if (desktopLayout === 'thumbnail_left') {
            parentDiv.classList.add(
              'flex-md',
              'gap-10',
              'overflow-hidden',
              'justify-content-right'
            );
          }
          parentDiv.dataset.thumbDirection =
            desktopLayout === 'thumbnail_left' ? 'vertical' : 'horizontal';
          let parentContainer = parentDiv.querySelector(
            '.media-main-swiper .swiper-wrapper'
          );
          let wrapperFeatureProduct =
            this.productTarget.querySelector('slide-with-thumbs');
          let slidePreviewFeatureProduct = wrapperFeatureProduct.querySelector(
            '.media-main-swiper .swiper-wrapper'
          );
          if (zoom === 'no_zoom') {
            const noZoomItems = html.querySelectorAll(
              'div.media-gallery__image[data-pane-container]'
            );
            noZoomItems.forEach((item) => {
              if (
                (item.dataset.alt && item.dataset.alt == altValue) ||
                !this.getAllButtonValue().includes(item.dataset.alt)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                parentContainer.innerHTML += item.outerHTML;
              }
              if (elementFeatureProduct) {
                slidePreviewFeatureProduct.innerHTML =
                  parentContainer.innerHTML;
                wrapperFeatureProduct.updateSlide();
              }
            });
          } else if (zoom !== 'open_lightbox') {
            const driftZoomItems = html.querySelectorAll(
              'div.media-gallery__image[data-pane-container]'
            );
            driftZoomItems.forEach((item) => {
              if (
                (item.dataset.alt && item.dataset.alt == altValue) ||
                !this.getAllButtonValue().includes(item.dataset.alt)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                parentDiv.querySelector('.swiper-wrapper').innerHTML +=
                  item.outerHTML;
              }
            });
          } else {
            const zoomItems = html.querySelectorAll('a.media-gallery__image');
            zoomItems.forEach((item) => {
              if (
                (item.dataset.alt && item.dataset.alt == altValue) ||
                !this.getAllButtonValue().includes(item.dataset.alt)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                parentContainer.innerHTML += item.outerHTML;
              }
            });
          }
          if (desktopLayout !== 'hidden_thumbnail') {
            let thumbHtml = html.querySelector(
              '.media-gallery__append .media-thumb-swiper'
            );
            let thumbHtmlWrapper = thumbHtml.querySelector('.swiper-wrapper');
            let thumbHtmlFeatureProduct = wrapperFeatureProduct.querySelector(
              '.media-thumb-swiper .swiper-wrapper'
            );
            if (!thumbHtml || !thumbHtmlFeatureProduct) return;
            if (mobileLayout !== 'show_thumbnails') {
              thumbHtml
                .querySelector('.thumbnail-slide')
                .classList.add('thumbnail-slide__mobile--hidden');
              parentDiv.innerHTML +=
                html.querySelector('.swiper-pagination').outerHTML;
            }
            if (desktopLayout === 'thumbnail_bottom') {
              thumbHtml
                .querySelector('.thumbnail-slide')
                .classList.add('mt-10', 'thumb-bottom');
              thumbHtml
                .querySelector('.thumbnail-slide')
                .setAttribute('style', '--gap: 15px');
            }
            if (desktopLayout === 'thumbnail_left') {
              thumbHtml.classList.add('mt-10');
              if (
                thumbHtml
                  .querySelector('.thumbnail-slide')
                  ?.classList.contains('swiper-horizontal')
              ) {
                thumbHtml
                  .querySelector('.thumbnail-slide')
                  ?.classList.remove('swiper-horizontal');
                thumbHtml
                  .querySelector('.thumbnail-slide')
                  ?.classList.add('swiper-vertical');
              }
            }
            const noZoomItems = html.querySelectorAll(
              'div.media-gallery__image:not([data-pane-container])'
            );
            noZoomItems.forEach((item) => {
              if (
                (item.dataset.alt && item.dataset.alt == altValue) ||
                !this.getAllButtonValue().includes(item.dataset.alt)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                thumbHtmlWrapper.innerHTML += item.outerHTML;
              }
            });
            parentDiv.innerHTML += thumbHtml.outerHTML;
            if (elementFeatureProduct) {
              thumbHtmlFeatureProduct.innerHTML = thumbHtmlWrapper.innerHTML;
              wrapperFeatureProduct.updateThumbSlide();
            }
          } else {
            parentDiv.innerHTML +=
              html.querySelector('.swiper-pagination').outerHTML;
          }
          if (!zoomAction) return;
          zoomAction.innerHTML = parentDiv.outerHTML;
          zoomAction.drift = null;
        })
        .finally(() => {
          this.updateMedia(true);
          BlsLazyloadImg.init();
          if (!zoomAction) return;
          if (zoom !== 'open_lightbox' && zoom !== 'no_zoom') {
            zoomAction.initDrift();
          }
          if (zoom === 'open_lightbox' && zoom !== 'no_zoom') {
            zoomAction.initLightBox();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`/products/${productHandle}?section_id=media-gallery-grid`)
        .then((response) => response.text())
        .then((text) => {
          const html = parser.parseFromString(text, 'text/html');
          if (!html) return;
          let parentDiv = document.createElement('div');
          if (desktopLayout === 'stack') {
            parentDiv.classList.add('stacked', 'grid', 'gap-10', 'grid_scroll', 'grid-cols');
          }
          if (
            desktopLayout === 'grid_1_column' ||
            desktopLayout === 'grid_2_column'
          ) {
            parentDiv.classList.add('grid-cols', 'grid', 'gap', 'grid_scroll');
          }
          if (
            desktopLayout === 'stack' ||
            desktopLayout === 'grid_1_column' ||
            desktopLayout === 'grid_2_column'
          ) {
            parentDiv.id = `GalleryViewer-${sectionId}`;
          }
          if (desktopLayout === 'grid_1_column') {
            parentDiv.setAttribute(
              'style',
              '--col-number: 1;--col-desktop: 1;--col-tablet: 1;--col-gap: 10px;'
            );
          }
          if (desktopLayout === 'grid_2_column' || desktopLayout === 'stack') {
            if (window.innerWidth > 768) {
              parentDiv.setAttribute(
                'style',
                '--col-number: 2;--col-tablet: 2;--col-gap: 10px;'
              );
            } else {
              parentDiv.setAttribute(
                'style',
                '--col-number: 1.2;--col-tablet: 2;--col-gap: 10px;'
              );
            }
          }
          if (zoom === 'no_zoom') {
            const noZoomItems = html.querySelectorAll(
              'div.media-gallery__image:not([data-pane-container])'
            );
            noZoomItems.forEach((item) => {
              if (
                (item.dataset.alt && item.dataset.alt == altValue) ||
                !this.getAllButtonValue().includes(item.dataset.alt)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                parentDiv.innerHTML += item.outerHTML;
              }
            });
            if (elementFeatureProduct) {
              const wrapperGrid = this.productTarget.querySelector(
                `#GalleryViewer-${sectionId}`
              );
              wrapperGrid.innerHTML = parentDiv.innerHTML;
            }
          } else if (zoom !== 'open_lightbox') {
            const driftZoomItems = html.querySelectorAll(
              'div.media-gallery__image[data-pane-container]'
            );
            driftZoomItems.forEach((item) => {
              if (
                (item.dataset.alt && item.dataset.alt == altValue) ||
                !this.getAllButtonValue().includes(item.dataset.alt)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                parentDiv.innerHTML += item.outerHTML;
              }
            });
          } else {
            const zoomItems = html.querySelectorAll('a.media-gallery__image');
            zoomItems.forEach((item) => {
              if (
                (item.dataset.alt && item.dataset.alt == altValue) ||
                !this.getAllButtonValue().includes(item.dataset.alt)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                parentDiv.innerHTML += item.outerHTML;
              }
            });
          }
          if (!zoomAction) return;
          zoomAction.innerHTML = parentDiv.outerHTML;
          zoomAction.drift = null;
        })
        .finally(() => {
          this.updateMedia(true);
          BlsLazyloadImg.init();
          if (!zoomAction) return;
          if (zoom !== 'open_lightbox' && zoom !== 'no_zoom') {
            zoomAction.initDrift();
          }
          if (zoom === 'open_lightbox' && zoom !== 'no_zoom') {
            zoomAction.initLightBox();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }*/

  //Tayler changed updateMediaGroup.... 20250807
  updateMediaGroup(altValue) {
    //console.log('Executing FINAL UNIVERSAL updateMediaGroup. Current Variant:', this.currentVariant);

    if (!this.currentVariant) {
      console.error('updateMediaGroup called but this.currentVariant is not set.');
      return;
    }

    const isQuickView = this.closest('.product-quickview__content') !== null;
    const container = this.closest('.product__item-js');

    if (!container) {
      console.error('Could not find parent .product__item-js container.');
      return;
    }

    const productHandle = container.querySelector('[data-product-handle]')?.dataset.productHandle || this.dataset.productHandle;
    const sectionId = container.dataset.section;
    const mediaContainer = container.querySelector('media-gallery');

    if (!productHandle || !sectionId || !mediaContainer) {
      console.error('Missing required data attributes from .product__item-js container.');
      return;
    }
    
    mediaContainer.classList.add('skeleton-loading', 'opacity-50');

    let url;
    if (isQuickView) {
      const productUrl = container.dataset.productUrl || `/products/${productHandle}`;
      url = `${productUrl}?section_id=product-quickview&variant=${this.currentVariant.id}`;
      //console.log('QuickView Context: Fetching from:', url);
    } else {
      url = `/products/${productHandle}?section_id=${sectionId}&variant=${this.currentVariant.id}`;
      //console.log('Main Product Context: Fetching from:', url);
    }
    
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`Network response was not ok, status: ${response.status}`);
        return response.text();
      })
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');

        const newMediaContent = html.querySelector('.product__item-js media-gallery');

        if (newMediaContent) {
          mediaContainer.innerHTML = newMediaContent.innerHTML;
          
          const imageZoom = container.dataset.zoom;
          // Re-initialize components
          const zoomActionContainer = mediaContainer.querySelector('zoom-action');
          if (zoomActionContainer && typeof zoomActionContainer.initDrift === 'function') {
            zoomActionContainer.drift = null;
            if (imageZoom !== 'open_lightbox' && imageZoom !== 'no_zoom') zoomActionContainer.initDrift();
            if (imageZoom === 'open_lightbox') zoomActionContainer.initLightBox();
          }

          const slideWithThumbs = mediaContainer.querySelector('slide-with-thumbs');
          if (slideWithThumbs && typeof slideWithThumbs.init === 'function') {
            if (slideWithThumbs.globalSlide) slideWithThumbs.globalSlide.destroy(true, true);
            if (slideWithThumbs.thumbnailSlide) slideWithThumbs.thumbnailSlide.destroy(true, true);
            slideWithThumbs.init();
          }

          BlsLazyloadImg.init();
        } else {
          console.warn('Could not find media-gallery in the AJAX response. The response HTML was:', text);
        }
      })
      .catch(e => {
        console.error('Error processing variant media response:', e);
      })
      .finally(() => {
        mediaContainer.classList.remove('skeleton-loading', 'opacity-50');
      });
  }

  getAllButtonValue() {
    const buttonArray = [];
    this.querySelectorAll(
      '.product__color-swatches--js, .product-sticky-js'
    ).forEach((btn) => {
      if (
        btn.classList.contains('product__color-swatches--js') &&
        btn.dataset.value
      ) {
        buttonArray.push(btn.dataset.value);
      } else if (
        btn.classList.contains('product-sticky-js') &&
        btn.dataset.colorValue
      ) {
        buttonArray.push(btn.dataset.colorValue);
      }
    });
    return buttonArray;
  }
}
customElements.define('variant-group-detail', VariantGroupDetail);

class VariantRadiosSticky extends VariantRadiosDetail {
  constructor() {
    super();
  }
}
customElements.define('variant-radios-sticky', VariantRadiosSticky);

class VariantGroupSticky extends VariantGroupDetail {
  constructor() {
    super();
  }
}
customElements.define('variant-group-sticky', VariantGroupSticky);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.timeoutMessage = this.dataset.timeoutMessage;
    this.format = this.dataset.format || 'dd:hh:mm:ss';
    this.interval = null;
    this.init();
  }
  init() {
    const cddl = this.dataset?.endtime;

    const minutesLeft = this.dataset.minutesLeft;
    const countdownAppend = this.querySelector('.countdown-inner');
    if (countdownAppend) {
      countdownAppend.innerHTML = this.appendChildHtml(minutesLeft).innerHTML;
    } else {
      this.innerHTML = this.appendChildHtml(minutesLeft).innerHTML;
    }

    if (cddl) {
      let isoDate = '';
      if (this.isISODate(cddl)) {
        isoDate = cddl;
        this.mainFunction(isoDate, minutesLeft);
      } else {
        if (this.isValidDateTime(cddl)) {
          isoDate = new Date(cddl).toISOString();
          this.mainFunction(isoDate, minutesLeft);
        } else if (this.isValidDate(cddl)) {
          const dateParts = cddl.split('-');
          isoDate =
            dateParts[2] +
            '-' +
            dateParts[0].padStart(2, '0') +
            '-' +
            dateParts[1].padStart(2, '0') +
            'T00:00:00Z';
          this.mainFunction(isoDate, minutesLeft);
        } else {
          this.mainFunction(isoDate, minutesLeft);
        }
      }
    } else {
      let isoDate = '';
      this.mainFunction(isoDate, minutesLeft);
    }
  }

  mainFunction(isoDate, minutesLeft) {
    let timeLeft = {};
    const calculateTimeLeft = (difference) => {
      let timeLeft = {};

      if (this.format.includes('dd')) {
        timeLeft.days_timer = Math.floor(difference / (1000 * 60 * 60 * 24));
      }

      if (this.format.includes('hh')) {
        if (this.format.includes('dd')) {
          timeLeft.hours_timer = Math.floor(
            (difference / (1000 * 60 * 60)) % 24
          );
        } else {
          timeLeft.hours_timer = Math.floor(difference / (1000 * 60 * 60));
        }
      }

      if (this.format.includes('mm')) {
        if (this.format === 'mm:ss') {
          timeLeft.minutes_timer = Math.floor(difference / 1000 / 60);
        } else {
          timeLeft.minutes_timer = Math.floor((difference / 1000 / 60) % 60);
        }
      }

      if (this.format.includes('ss')) {
        timeLeft.seconds_timer = Math.floor((difference / 1000) % 60);
      }

      return timeLeft;
    };

    if (Date.parse(isoDate) || minutesLeft) {
      let deadline = new Date(isoDate);
      if (minutesLeft) {
        deadline = new Date(Date.now() + parseInt(minutesLeft) * 60000);
      }
      const updateCountdown = () => {
        const now = new Date();
        const difference = deadline - now;
        if (difference > 0) {
          timeLeft = calculateTimeLeft(difference);
        } else {
          timeLeft = calculateTimeLeft(0);
        }

        if (
          timeLeft.days_timer > 0 ||
          timeLeft.hours_timer > 0 ||
          timeLeft.minutes_timer > 0 ||
          timeLeft.seconds_timer > 0 ||
          !this.timeoutMessage
        ) {
          Object.entries(timeLeft).forEach(([key, value]) => {
            if (this.querySelector('.' + key)) {
              this.querySelector('.' + key).innerHTML = value
                .toString()
                .padStart(2, '0');
            }
          });
        } else if (this.timeoutMessage) {
          this.innerHTML = this.timeoutMessage;
          clearInterval(this.interval);
        } else {
          clearInterval(this.interval);
        }
        this.classList.remove('hidden');
        const badgesCountdown = this.closest('.product__badges-sale-countdown');
        if (badgesCountdown) {
          badgesCountdown.classList.remove('hidden');
          badgesCountdown.classList.add('inline-flex');
        }
      };
      this.interval = setInterval(updateCountdown, 1000);
      // Chạy ngay lập tức để tránh bị trễ
      updateCountdown();
    } else {
      timeLeft = calculateTimeLeft(0);
      Object.entries(timeLeft).forEach(([key, value]) => {
        if (this.querySelector('.' + key)) {
          this.querySelector('.' + key).innerHTML = value
            .toString()
            .padStart(2, '0');
        }
      });
    }
  }

  appendChildHtml(minutesLeft) {
    const days = this.dataset?.days;
    const hours = this.dataset?.hours;
    const mins = this.dataset?.mins;
    const secs = this.dataset?.secs;
    const container = document.createElement('div');
    container.innerHTML = `${
      !minutesLeft
        ? `${
            this.format.includes('dd')
              ? `<div class="countdown--container"><span class="days_timer count-timer"></span><span class="timer_announcementbar--text"> ${
                  days ? days : ''
                }</span></div>`
              : ''
          }${
            this.format.includes('hh')
              ? `<div class="countdown--container"><span class="hours_timer count-timer"></span><span class="timer_announcementbar--text"> ${
                  hours ? hours : ''
                }</span></div>`
              : ''
          }`
        : ''
    }<div class="countdown--container"><span class="minutes_timer count-timer"></span><span class="timer_announcementbar--text"> ${
      minutesLeft ? 'm' : mins ? mins : ''
    }</span></div><div class="countdown--container"><span class="seconds_timer count-timer"></span><span class="timer_announcementbar--text"> ${
      minutesLeft ? 's' : secs ? secs : ''
    }</span></div>`;
    return container;
  }
  isISODate(dateString) {
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
    return isoRegex.test(dateString);
  }
  isValidDateTime(dateString) {
    const dateTimeRegex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
    return dateTimeRegex.test(dateString);
  }
  isValidDate(dateString) {
    var regex = /^\d{2}-\d{2}-\d{4}$/;
    if (regex.test(dateString)) {
      return true;
    } else {
      return false;
    }
  }
  disconnectedCallback() {
    clearInterval(this.interval);
  }
}
customElements.define('countdown-timer', CountdownTimer);

// js for product form - not done yet - Tayler finished here... 2025.08.06
// js for product form - not done yet - Tayler finished here... 2025.08.25
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends PopupBase {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form
          .querySelector('[name=id]')
          ?.addEventListener('change', this.syncPreOrderState.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';

        // This line was moved from the original code for better structure.
        this.productItem =
          this.form.closest(".product-item") ||
          this.form.closest("sticky-add-cart");
        if (this.dataset.available !== 'false') {
          this.submitButton.removeAttribute('disabled');
        }
        this.syncPreOrderState();
        this.initializeAddons();
      }

      getCurrentVariantInventoryState() {
        const productTarget = this.closest('.product__item-js');
        const variantId = this.form.querySelector('[name=id]')?.value;
        if (!productTarget || !variantId) return null;

        let variant = null;
        let inventory = null;
        const productJson = productTarget.querySelector('.productJson');
        const variantsQtyJson = productTarget.querySelector('.productVariantsQty');

        if (productJson?.textContent) {
          try {
            const productData = JSON.parse(productJson.textContent);
            variant = productData?.variants?.find(
              (item) => `${item.id}` === `${variantId}`
            );
          } catch (error) {
            console.warn('Unable to parse product JSON for pre-order state.', error);
          }
        }

        if (variantsQtyJson?.textContent) {
          try {
            const variantsQtyData = JSON.parse(variantsQtyJson.textContent);
            inventory = variantsQtyData.find(
              (item) => `${item.id}` === `${variantId}`
            );
          } catch (error) {
            console.warn('Unable to parse inventory JSON for pre-order state.', error);
          }
        }

        if (!variant && !inventory) return null;

        const inventoryManagement = inventory?.mamagement ?? variant?.inventory_management;
        const inventoryQuantity = Number(
          inventory?.qty ?? variant?.inventory_quantity ?? 0
        );
        const isAvailable = inventory?.available ?? variant?.available;

        return {
          isAvailable,
          isPreOrder:
            inventoryManagement != null &&
            inventoryManagement !== '' &&
            inventoryQuantity < 1 &&
            isAvailable === true,
        };
      }

      syncPreOrderState() {
        if (this.form.querySelector('input[name="selling_plan"]')) return;
        if (this.dataset.preOrderEnabled !== 'true') return;

        const state = this.getCurrentVariantInventoryState();
        if (!state) return;

        const label = this.submitButton?.querySelector('.btn-label');

        this.dataset.available = state.isAvailable ? 'true' : 'false';
        this.dataset.preOrder = state.isPreOrder ? 'true' : 'false';

        if (label) {
          if (state.isPreOrder) {
            label.textContent = window.variantStrings?.preOrder || 'Pre-Order';
          } else {
            label.textContent = state.isAvailable
              ? window.variantStrings?.addToCart || 'Add To Cart'
              : window.variantStrings?.soldOut || 'Sold Out';
          }
        }
        if (this.submitButton) {
          this.submitButton.toggleAttribute('disabled', state.isAvailable !== true);
        }
      }

      initializeAddons() {
        this.productContainer = this.form.closest('.sec__featured-product');
        if (!this.productContainer) return;
        
        this.addonItems = this.productContainer.querySelectorAll('.product-addon__item');
        if (this.addonItems.length === 0) {
            this.isAddonsPage = false;
            // return; 
        } else {
          this.isAddonsPage = true;
        }

        this.variantRadios = this.productContainer.querySelector('variant-radios-detail, variant-group-detail');
        this.quantityInput = this.form.querySelector("quantity-input");
        
        // --- MODIFICATION 1: Select ALL price elements ---
        this.totalPriceElements = document.querySelectorAll('[data-bundle-total-price]');
        this.comparePriceElements = document.querySelectorAll('[data-bundle-compare-price]');
        
        if(this.variantRadios) {
          // ==================== Tayler fixed the total price bug.... 20251014 ====================
          if (typeof this.variantRadios.updateOptions === 'function') {
            this.variantRadios.updateOptions(); 
          }
          if (typeof this.variantRadios.updateMasterId === 'function') {
            this.variantRadios.updateMasterId();
          }
          // ========================================
          this.variantRadios.addEventListener('change', this.calculateTotals.bind(this));
        }
        if(this.quantityInput) {
          this.quantityInput.addEventListener("change", this.calculateTotals.bind(this));
        }
        
        this.addonItems.forEach(item => {
          const checkbox = item.querySelector('.product-addon__checkbox');
          const selector = item.querySelector('.product-addon__variant-selector');
          
          if(checkbox) checkbox.addEventListener('change', this.calculateTotals.bind(this));
          if(selector) selector.addEventListener('change', this.onAddonVariantChange.bind(this));
        });

        setTimeout(() => this.calculateTotals(), 100);
      }

      onAddonVariantChange(event) {
        const select = event.currentTarget;
        const selectedOption = select.options[select.selectedIndex];
        const parentItem = select.closest('.product-addon__item');
        const checkbox = parentItem.querySelector('.product-addon__checkbox');
        const priceDisplay = parentItem.querySelector('.product-addon__price');
        const imageElement = parentItem.querySelector('.product-addon__image img');

        checkbox.dataset.variantId = selectedOption.value;
        checkbox.dataset.price = selectedOption.dataset.price;
        checkbox.dataset.compareAtPrice = selectedOption.dataset.compareAtPrice;

        const newImageUrl = selectedOption.dataset.imageSrc;
        if (imageElement && newImageUrl) {
          imageElement.src = newImageUrl;
        }

        const price = parseFloat(selectedOption.dataset.price);
        const comparePrice = parseFloat(selectedOption.dataset.compareAtPrice);
        let priceHTML = `<span class='price-item price-item--regular'>${Shopify.formatMoney(price, window.cartStrings?.money_format)}</span>`;
        if (comparePrice > price) {
            priceHTML += `<s class='price-item price-item--compare ml-5'>${Shopify.formatMoney(comparePrice, window.cartStrings?.money_format)}</s>`;
        }
        priceDisplay.innerHTML = priceHTML;

        this.calculateTotals();
      }

      calculateTotals() {
        // if (!this.isAddonsPage) return;

        let totalPrice = 0;
        let totalComparePrice = 0;
        let quantity = Number(this.quantityInput?.input?.value) || 1;

        const mainVariant = this.variantRadios?.currentVariant;
        if (mainVariant) {
          totalPrice += mainVariant.price * quantity;
          totalComparePrice += (mainVariant.compare_at_price || mainVariant.price) * quantity;
        } else {
            const initialProductData = JSON.parse(this.productContainer.querySelector('[data-product-json]')?.textContent || '{}');
            if(initialProductData.price) {
                totalPrice += initialProductData.price * quantity;
                totalComparePrice += (initialProductData.compare_at_price || initialProductData.price) * quantity;
            }
        }

        this.addonItems.forEach(item => {
            const checkbox = item.querySelector('.product-addon__checkbox');
            if (checkbox && checkbox.checked) {
                totalPrice += parseFloat(checkbox.dataset.price);
                totalComparePrice += parseFloat(checkbox.dataset.compareAtPrice);
            }
        });

        this.updatePriceDisplay(totalPrice, totalComparePrice);
      }

      // --- MODIFICATION 2: Update all price elements ---
      updatePriceDisplay(price, comparePrice) {
        this.totalPriceElements.forEach(el => {
            el.innerHTML = Shopify.formatMoney(price, window.cartStrings?.money_format);
        });
        
        this.comparePriceElements.forEach(el => {
            if (comparePrice > price) {
                el.innerHTML = Shopify.formatMoney(comparePrice, window.cartStrings?.money_format);
                el.style.display = '';
            } else {
                el.style.display = 'none';
            }
        });
      }
      
      onSubmitHandler(evt) {
        evt.preventDefault();
        // Tayler modified it.... 20260519 
        // Re-query in case region-aware sync swapped the button's type attribute after constructor ran
        if (!this.submitButton) this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const popup = document.getElementById('ai-plan-recommendation');
        const isUnlimitedPlan = this.form.dataset.unlimitedPlan === 'true';
        if (isUnlimitedPlan) {
          if (popup) {
            const formData = new FormData(this.form)
            const variantId = formData.get('id');
            popup.addProduct(variantId)
            popup.open(null, true)
            return
          }
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const cartRecommend = document.querySelector(".cart-recommend");
        if (cartRecommend && cartRecommend.classList.contains("open")) {
          cartRecommend.classList.remove("open");
        }

        // Tayler modified 20260228 for 架构优化：统一使用 application/json，废弃 FormData，确保 API 数据通道一致
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        };

        //Tayler added it .... 20260306 for QuickView bug
        const formData = new FormData(this.form);
        let mainVariantId = formData.get('id');
        let mainQuantity = parseInt(formData.get('quantity') || 1);
        const sellingPlan = formData.get('selling_plan');

        const localContainer = this.closest('.product-quickview__content, .sec__featured-product, .product-item, .product__item-js');
        if (localContainer) {
          const explicitIdInput = localContainer.querySelector('input[name="id"]');
          if (explicitIdInput && explicitIdInput.value) {
            mainVariantId = explicitIdInput.value;
          }
          
          const explicitQtyInput = localContainer.querySelector('input[name="quantity"]');
          if (explicitQtyInput && explicitQtyInput.value) {
            mainQuantity = parseInt(explicitQtyInput.value || 1);
          }
        }

        // 1. Collect product properties (customization fields) first
        const properties = {};
        const productInfo = this.form.closest('.product-detail__information');
        if (productInfo) {
          productInfo.querySelectorAll('product-property input[name^="properties"]').forEach((property) => {
              if (property.type !== 'file' && property.value) {
                  const name = property.name.match(/properties\[(.*)\]/)[1];
                  if (name) {
                      properties[name] = property.value;
                  }
              }
          });
        }

        // 2. 构建核心 Items 数组
        const items = [];
        const mainProductItem = { 
          id: mainVariantId, 
          quantity: mainQuantity 
        };
        
        if (Object.keys(properties).length > 0) mainProductItem.properties = properties;
        if (sellingPlan) mainProductItem.selling_plan = sellingPlan;
        
        items.push(mainProductItem);

        // 3. 注入 Addons (如果存在)
        if (this.isAddonsPage) {
          this.addonItems.forEach(item => {
            const checkbox = item.querySelector(".product-addon__checkbox");
            if(checkbox && checkbox.checked){
                items.push({ id: checkbox.dataset.variantId, quantity: 1 });
            }
          });
        }

        // 4. 构建 Shopify Section Rendering 载荷
        const requestBody = {
          items: items
        };

        const is_cart_page = document.body.classList.contains('template-cart');
        
        // Tayler fixed the bug .... 20260304 for 仅在 Ajax 购物车存在，或当前在购物车页面时，才向后端请求 sections 渲染
        if (this.cart) {
          requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement); // 同步补回原有的焦点管理
        }
        
        if (is_cart_page) {
          requestBody.sections = this.getMainCartSectionRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
        }

        config.body = JSON.stringify(requestBody);

        // 5. 优化网络瀑布流：仅在真正包含订阅计划时触发，并使用安全的 line item key 删除
        let preTask = Promise.resolve();
        if (sellingPlan) {
          preTask = fetch('/cart.json')
            .then(res => res.json())
            .then(cart => {
              const updates = {};
              let hasUpdates = false;
              // 寻找并标记需要删除的其他冲突订阅商品
              cart.items.forEach(item => {
                if (item.selling_plan_allocation && String(item.variant_id) !== String(mainVariantId)) {
                  updates[item.key] = 0; // 架构修复：必须使用 item.key (Line Item Key) 而不是 item.id 删除，避免误删同款普通商品
                  hasUpdates = true;
                }
              });
              
              if (hasUpdates) {
                return fetch("/cart/update.js", {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates })
                });
              }
            })
            .catch(e => console.error('Failed to sync selling plans:', e));
        }
        // Tayler modified 20260228 for 架构优化 end

        // --- END OF CORRECTIONS ---
        preTask.then(() => fetch(`${routes.cart_add_url}`, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const productVariantId = this.isAddonsPage ? requestBody.items[0]?.id : new FormData(this.form).get('id');
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              if (this.productItem) {
                this.handleErrorMessagePopup(response.description);
              }
              return;
            } else if (response.sections) {
              if (!response.id && !response.items) {
                this.handleErrorMessagePopup(window.cartStrings.error);
                return;
              }
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            fetch('/cart.json')
              .then((res) => res.json())
              .then((cart) => {
                if (cart.item_count != undefined) {
                  document.querySelectorAll('.cart-count').forEach((el) => {
                    if (el.classList.contains('cart-count-drawer')) {
                      el.innerHTML = `(${cart.item_count})`;
                    } else {
                      el.innerHTML =
                        cart.item_count > 100 ? '~' : cart.item_count;
                    }
                  });
                  if (document.querySelector('header-total-price')) {
                    document
                      .querySelector('header-total-price')
                      .updateTotal(cart);
                  }
                  const cart_free_ship = document.querySelector(
                    'free-ship-progress-bar'
                  );
                  if (cart_free_ship) {
                    cart_free_ship.init(cart.items_subtotal_price);
                  }
                }
              })
              .catch((error) => {
                throw error;
              });

            // This part also needs adjustment
            //const productVariantIdForEvent = this.isAddonsPage ? JSON.parse(finalBody).items[0].id : new FormData(this.form).get('id');
            // 架构修复：由于已统一为 JSON Payload，直接从内存变量获取
            const productVariantIdForEvent = mainVariantId;
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: productVariantIdForEvent,
              cartData: response,
            });
            // The rest of your original logic for UI updates
            const modalQuickview = document.querySelector(
              '.tingle-modal--visible.tingle-modal.quickview .tingle-modal__close'
            );
            const modalShopableVideo = document.querySelector(
              '.tingle-modal--visible.tingle-modal.shopable-video'
            );
            let time = 0;
            if (modalQuickview || modalShopableVideo) {
              if (
                document.documentElement
                  .querySelector('body')
                  .classList.contains('tingle-enabled')
              ) {
                document.documentElement
                  .querySelector('body')
                  .classList.remove('tingle-enabled');
              }
              if (modalShopableVideo) {
                modalShopableVideo.remove();
              }
              if (modalQuickview) {
                time += 250;
                modalQuickview.click();
              }
            }
            const is_cart_page =
              document.body.classList.contains('template-cart');
            if (!is_cart_page) {
              // Tayler fixed bug .... by adding && this.cart 20251124
              if (!response.errors && this.cart) {
                this.cart.getSectionsToRender().forEach((section) => {
                  const elementToReplace = document.getElementById(section.id);
                  const html = new DOMParser().parseFromString(
                    response.sections[section.id],
                    'text/html'
                  );
                  if (elementToReplace) {
                    elementToReplace.innerHTML = html.querySelector('#minicart-form').innerHTML;
                    // Tinsley add
                    html.querySelectorAll('script[src]').forEach((scriptTag) => {
                      const src = scriptTag.getAttribute('src');
                      if (src) {
                        const script = document.createElement('script');
                        script.src = src;
                        if (scriptTag.defer) script.defer = true;
                        if (scriptTag.async) script.async = true;
                        document.body.appendChild(script);
                      }
                    });
                  }
                });
                this.cart.cartAction();
                if (this.cart && this.cart.classList.contains('is-empty')) {
                  this.cart.classList.remove('is-empty');
                }

                setTimeout(() => {
                  this.cart.open();
                  const cartRecommend =
                    document.querySelector('.cart-recommend');
                  if (
                    cartRecommend &&
                    !cartRecommend.classList.contains('hidden-recommend')
                  ) {
                    if (
                      cartRecommend.classList.contains('cart-recommend-custom')
                    ) {
                      const cartUpsellItem =
                        document.querySelectorAll('.cart-upsell-item');
                      const cartUpsellSlide = document.querySelectorAll(
                        '.swiper-cart-upsell .swiper-slide'
                      );
                      if (cartUpsellItem.length > 0) {
                        setTimeout(function () {
                          cartRecommend.classList.add('open');
                        }, 800);
                      } else if (cartUpsellSlide.length === 0) {
                        cartRecommend.classList.remove('block');
                        cartRecommend.classList.add('hidden');
                      }
                    } else {
                      setTimeout(function () {
                        cartRecommend.classList.add('open');
                      }, 800);
                    }
                  }
                }, time);
              }
            } else {
              if (!response.errors) {
                this.getMainCartSectionRender().forEach((section) => {
                  if (section.selector != undefined) {
                    const elementToReplace =
                      document
                        .getElementById(section.id)
                        .querySelector(section.selector) ||
                      document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                      response.sections[section.id],
                      section.selector
                    );
                    const cart_gift_html = new DOMParser()
                      .parseFromString(
                        response.sections[section.id],
                        'text/html'
                      )
                      .querySelector('#gift');
                    const cart_gift = document.getElementById('gift');
                    if (cart_gift) {
                      cart_gift.innerHTML = cart_gift_html.innerHTML;
                      const gift_form_minicart =
                        document.getElementById('gift_form_minicart');
                      if (gift_form_minicart) {
                        gift_form_minicart.addEventListener(
                          'change',
                          (event) => {
                            if (event.currentTarget.checked) {
                              this.addGiftwrapCartClick(gift_form_minicart);
                            } else {
                              this.updateQuantity(
                                event.currentTarget.dataset.index,
                                0
                              );
                            }
                          }
                        );
                      }
                    }
                  }
                });
                var wrapperDiv = document.createElement('div');
                var messageDiv = document.createElement('div');
                messageDiv.className = `mt-10 newsletter-form__message--success success form__message inline-flex align-center`;
                messageDiv.setAttribute('tabindex', '-1');
                messageDiv.setAttribute('role', 'status');
                messageDiv.setAttribute('aria-live', 'polite');
                messageDiv.innerHTML = `
                  <svg width="18" height="18" fill="none">
                    <g stroke="#137F24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"><path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/></g>
                  </svg>
                `;
                var span = document.createElement('span');
                span.className = 'ml-5';
                span.textContent = 'Update cart successfully';
                messageDiv.appendChild(span);
                wrapperDiv.appendChild(messageDiv);
                showToast(wrapperDiv.innerHTML, 2000, 'modal-success');

                const totals = this.getSectionInnerHTML(
                  response.sections['main-cart-items'],
                  '.cart-info .totals'
                );
                const totals_content =
                  document.querySelector('.cart-info .totals');
                if (totals && totals_content) totals_content.innerHTML = totals;
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            BlsLazyloadImg.init();
            if (document.documentElement.classList.contains('open-popup')) {
              document.documentElement.classList.remove('open-popup');
            }
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
              this.submitButton.setAttribute('aria-disabled', 'false');
          });
      }

      getMainCartSectionRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items')?.dataset.id,
            selector: '.js-contents',
          },
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleErrorMessagePopup(errorMessage = false) {
        const url = `${window.location.pathname}?section_id=form-message`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            const elementErrorMessage = html.querySelector(
              '.product-form__error-message-wrapper'
            );
            const elementMessage = elementErrorMessage.querySelector(
              '.product-form__error-message'
            );
            elementMessage.textContent = errorMessage;
            showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
          })
          .catch((e) => {
            throw e;
          });
      }
    }
  );
}

// js loadmor product for collection and section product grid
class Loadmore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.collectionUrl = this.dataset.collectionUrl;
    this.sectionId = this.dataset.sectionId;
    this.all = this.dataset.allProducts;
    this.limit = this.dataset.limit;
    this.blockId = this.dataset.blockId;
    this.init();
  }
  init() {
    const _this = this;
    if (!this.button) return;
    this.button.addEventListener('click', function () {
      _this.scanData();
    });
  }
  scanData() {
    const _this = this;
    let url = this.dataset.url;
    if (!url) return;
    let sectionContainer = document.querySelector(
      `#shopify-section-${this.sectionId}`
    );
    sectionContainer?.classList.add('bls-image-js');
    this.querySelector('button').classList.add('loading');
    fetch(this.collectionUrl + url + `&section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = parser.parseFromString(text, 'text/html');
        let parentDiv = this.closest('.sec__products-loadmore');
        if (!parentDiv) return;
        let elements,
          itemDiv,
          fetchDiv,
          page,
          times,
          limit,
          remainder,
          end_load;
        if (this.blockId) {
          itemDiv = parentDiv.querySelector(
            `.collection-tab-${this.blockId} .product-ajax__append`
          );
          fetchDiv = html.querySelector(
            `.sec__products-loadmore .collection-tab-${this.blockId} .product-ajax__append`
          );
          elements = fetchDiv.querySelectorAll('.grid-custom-item');
        } else {
          itemDiv = parentDiv.querySelector('.product-ajax__append');
          fetchDiv = html.querySelector(
            '.sec__products-loadmore .product-ajax__append'
          );
          elements = fetchDiv.querySelectorAll('.grid-custom-item');
        }
        if (!itemDiv || !fetchDiv) return;
        page = Number(this.dataset.url.replace('?page=', ''));
        times = page * this.limit;
        limit = this.limit;
        end_load = false;
        if (times >= this.all) {
          end_load = true;
          limit = this.limit - (times - this.all);
        }
        elements.forEach((prodNode, index) => {
          index = index + 1;
          if (end_load && limit < index) {
            return;
          }
          itemDiv.appendChild(prodNode);
        });
      })
      .finally(() => {
        _this.updateUrl(Number(this.dataset.url.replace('?page=', '')));
        this.querySelector('button')?.classList.remove('loading');
        BlsAnimations.innit();
        initLazyloadItem();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  updateUrl(e) {
    if (this.all && this.limit && this.all > 0) {
      const times = ~~(this.all / this.limit);
      const remainder = this.all % this.limit;
      let pages = times;
      if (remainder > 0) {
        pages = times + 1;
      }
      if (e < pages) {
        this.dataset.url = '?page=' + ++e;
      } else {
        const btn = this.querySelector('button');
        if (btn) {
          btn.remove();
        }
      }
    }
  }

  handleCountItemToShow(pages) {
    if (this.all && this.limit && pages) {
      if (Number(this.all) < Number(this.limit) * pages) {
        const itemsNeedToRemove = Number(this.limit) * pages - Number(this.all);
        return itemsNeedToRemove;
      }
    }
    return 0;
  }
}
customElements.define('loadmore-function', Loadmore);

// js lookbook item
class LookbookItem extends HTMLElement {
  constructor() {
    super();
    this.itemPopup = this.querySelector('.lookbook-item__popup');
    this.type = this.dataset.type;
    this.position = this.dataset.productPosition;
    this.lookbookProductDiv = this.closest('.sec__lookbook-product');
    this.instagramShop = this.closest('.popup-content');
    this.allDots = this.closest('.sec__lookbook-product');
    this._boundClickOutside = this.onClickOutside.bind(this);
    this.init();
    document.body.addEventListener('click', this._boundClickOutside);
  }
  disconnectedCallback() {
    document.body.removeEventListener('click', this._boundClickOutside);
  }
  init() {
    if (this.type === 'open' || this.type === 'slide') {
      const atag = this.querySelector('a');
      if (!atag) return;
      atag.addEventListener('click', this.onClick.bind(this));
      const closeButton = this.querySelector('icon-close');
      if (!closeButton) return;
      closeButton.addEventListener('click', this.onClose.bind(this));
    }
  }
  onClickOutside(event) {
    if (!event.target.closest('lookbook-item')) {
      this.onClose();
    }
  }
  onClick() {
    if (this.type === 'open') {
      if (this.itemPopup) {
        const thisSection = this.closest('section');
        if (!thisSection) return;
        const allPopups = thisSection.querySelectorAll('.lookbook-item__popup');
        if (window.innerWidth >= 1024) {
          allPopups.forEach((popup) => {
            if (popup !== this.itemPopup) {
              popup.classList.add('invisible');
              const thisClosest = popup.closest('lookbook-item');
              if (thisClosest) {
                thisClosest.classList.remove('open');
              }
            }
          });
          this.onToggle();
        } else {
          const modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: 'Close',
            cssClass: ['lookbook-modal'],
            onOpen: function () {},
            onClose: function () {},
            beforeClose: function () {
              return true;
            },
          });
          modal.setContent(
            this.itemPopup.querySelector('.product-item').innerHTML
          );
          modal.open();
        }
      }
    } else {
      if (this.lookbookProductDiv && this.position) {
        const slideSEction = this.lookbookProductDiv.querySelector(
          'slide-section-lookbook'
        );
        const allDots = this.lookbookProductDiv.querySelectorAll(
          `lookbook-item[data-type='slide']`
        );
        allDots.forEach((dot) => {
          dot.classList.remove('active');
        });
        this.classList.add('active');
        if (slideSEction) {
          slideSEction.functionGoto(this.position);
        }
      } else if (this.instagramShop && this.position) {
        const slideSEction = this.instagramShop.querySelector(
          'slide-section-instagram'
        );
        if (slideSEction) {
          slideSEction.functionGoto(this.position);
        }
        const allDots = this.instagramShop.querySelectorAll(
          `lookbook-item[data-type='slide']`
        );
        allDots.forEach((dot) => {
          dot.classList.remove('active');
        });
        this.classList.add('active');
      }
    }
  }
  onToggle() {
    this.itemPopup?.classList.toggle('invisible');
    this.classList.toggle('open');
  }
  onClose() {
    this.itemPopup?.classList.add('invisible');
    this.classList.remove('open');
  }
}
customElements.define('lookbook-item', LookbookItem);

// js lookbook item
class SectionSlideLookbook extends SlideSection {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(position) {
    this.globalSlide.slideTo(position - 1, 500);
  }
}
customElements.define('slide-section-lookbook', SectionSlideLookbook);

class SectionSlideInstagramShop extends SlideSection {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(position) {
    this.globalSlide.slideTo(position - 1, 500);
  }
}
customElements.define('slide-section-instagram', SectionSlideInstagramShop);

// js for tab item
class TabItems extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.collection-tab__tab-item');
    this.select = this.querySelector('.select-collection-tab');
    this.content = this.querySelectorAll('.collection-tab__tab-content');
    this.select_li = this.querySelectorAll('.collection_title_input');
    this.type = this.dataset.type;
    this.init();
  }
  init() {
    if (this.type === 'horizontal' || this.type === 'vertical') {
      const self = this;
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          self.onClick(this);
        });
      });
    } else {
      const self = this;
      this.select.addEventListener('click', function (e) {
        if (e.target.classList.contains('select__selected_title')) {
          let select__dropdown = this.querySelector('.select-custom__content');
          this.classList.toggle('active');
          select__dropdown.classList.toggle('invisible');
        }
      });
      this._boundDocClick = function (event) {
        if (!event.target.closest('.select-collection-tab')) {
          self.select.classList.remove('active');
          document
            .querySelectorAll('.select-collection-tab .select-custom__content')
            ?.forEach((item) => {
              item.classList.add('invisible');
            });
        }
      };
      document.addEventListener('click', this._boundDocClick);
      this.select_li.forEach((item) => {
        item.addEventListener('click', function () {
          self.onClickBySelect(this);
          self.select.classList.remove('active');
          document
            .querySelectorAll('.select-collection-tab .select-custom__content')
            ?.forEach((item) => {
              item.classList.add('invisible');
            });
        });
      });
    }
  }
  onClick(tab) {
    const blockId = tab.dataset.blockId;
    this.showContent(blockId);
    this.tabs.forEach((t) => {
      t.classList.remove('active');
    });
    tab.classList.add('active');
  }

  onClickBySelect(selectedBlockId) {
    let select__selected_title = this.querySelector('.select__selected_title');
    select__selected_title.innerHTML =
      selectedBlockId.innerHTML +
      `<svg class="icon-down transition active-rotated" width="10" height="6">
    <use href="#icon-arrow-down"></use>
  </svg>`;
    this.showContent(selectedBlockId.dataset.id);
  }

  showContent(blockId) {
    this.content.forEach((content) => {
      if (content.dataset.blockId === blockId) {
        content.classList.add('active');
        let motion_element = content.querySelectorAll('motion-element');
        motion_element.forEach((motion) => {
          motion.refreshAnimation();
        });
      } else {
        content.classList.remove('active');
      }
    });
  }
  disconnectedCallback() {
    if (this._boundDocClick) {
      document.removeEventListener('click', this._boundDocClick);
    }
  }
}
customElements.define('tab-items', TabItems);

// js for shopable video
class ShopableVideo extends PopupBase {
  constructor() {
    super();
    this.popupDiv = this.querySelector('.video-item__popup');
    this.productPopupDiv = this.querySelector('.video-item__product-mobile');
    this.init();
  }
  init() {
    if (this.popupDiv || !this.classList.contains('instagram-item')) {
      window.addEventListener('resize', this.responsive.bind(this));
      window.addEventListener('load', this.responsive.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.connectedCallback();
    }
    if (this.productPopupDiv) {
      this.productPopupDiv.addEventListener(
        'click',
        this.onClickMobile.bind(this.productPopupDiv)
      );
    }
  }
  onClick() {
    if (this.popupDiv) {
      const html = this.popupDiv;
      const popup = document.querySelector('.tingle-modal.shopable-video');
      if (!html || popup) return;
      html.classList.remove('hidden');
      this.initPopup(html);
    } else {
      if (this.classList.contains('instagram-item')) {
        const sectionId = this.dataset.sectionId;
        const index = this.dataset.index;
        const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
        var _this = this;
        fetch(`${url}`)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              throw error;
            }
            return response.text();
          })
          .then((responseText) => {
            const newSection = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(`.popup-index-${index}`);
            _this.appendChild(newSection);
          })
          .catch((error) => {
            throw error;
          })
          .finally(() => {
            const html = _this.querySelector('.popup-content');
            if (html) {
              html.classList.remove('hidden');
              this.initPopup(html);
            }
          });
      }
    }
  }
  onCloseEvent() {
    const popup = document.querySelector('.tingle-modal.shopable-video');
    if (!popup) return;
    const productInformation = popup.querySelector(
      '.shopable-video__product-information'
    );
    if (!productInformation) return;
    productInformation.classList.add('hidden');
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const videos = this.querySelectorAll('video');
      videos.forEach((video) => {
        const dataSrc = video.dataset.src;
        if (dataSrc) {
          video.src = dataSrc;
          video.removeAttribute('data-src');
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }
  responsive() {
    const productDivs = document.querySelectorAll(
      '.shopable-video__product-information'
    );
    if (productDivs.length != 0) {
      if (window.innerWidth >= 768) {
        const flexDiv = this.popupDiv?.querySelector(
          '.video-item__popup--flex'
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.remove('hidden');
        });
      } else {
        const flexDiv = this.popupDiv?.querySelector(
          '.video-item__popup--flex'
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.add('hidden');
        });
      }
    }
  }
  onClickMobile() {
    const popup = this.closest('.video-item__popup');
    if (!popup) return;
    const productInformation = popup.querySelector(
      '.shopable-video__product-information'
    );
    if (!productInformation) return;
    productInformation.classList.toggle('hidden');
  }
}
customElements.define('shopable-video', ShopableVideo);

// js for shopable video
class InstagramShop extends ShopableVideo {
  constructor() {
    super();
    this.popupDiv = this.querySelector('.popup-content');
    if (this.popupDiv || this.classList.contains('instagram-item')) {
      this.addEventListener('click', this.onClick.bind(this));
    }
  }
}
customElements.define('instagram-shop', InstagramShop);

// js for instagram shop
class InstagramSection extends HTMLElement {
  constructor() {
    super();
    this.accessToken = this.dataset.accessToken;
    this.type = this.dataset.type;
    this.ratio = this.dataset.ratio;
    this.init();
  }
  async init() {
    if (this.accessToken) {
      const resp = await this.fetchDataInstagram(
        `https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=${this.accessToken}`
      );
      if (!resp) return;

      if (resp.error) {
        return console.error('Instagram error: ', resp.error?.message);
      }
      if (this.type === 'carousel') {
        this.generateCarousel(resp.data, this.ratio);
      } else {
        this.generateGrid(resp.data, this.ratio);
      }
    }
  }

  fetchDataInstagram(fetchUrl) {
    const map = new Map();
    return new Promise((resolve, reject) => {
      if (map.get(fetchUrl)) {
        return resolve(map.get(fetchUrl));
      }
      fetch(fetchUrl, {
        cache: 'force-cache',
      })
        .then((res) => {
          if (res.ok) {
            const json = res.json();
            resolve(json);
            map.set(fetchUrl, json);
            return json;
          } else {
            reject(res);
          }
        })
        .catch(reject);
    });
  }

  generateCarousel(items, ratio) {
    const wrapper = this.querySelector('.swiper-wrapper');
    if (wrapper) {
      let html = '';
      items.forEach((item) => {
        if (item.media_type === 'VIDEO') {
          html += `<a href="${item.permalink}" aria-label="${item.caption}" class="swiper-slide">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <video loop="true" muted="true" playsinline="true" autoplay="true" src="${item.media_url}"></video>
                                </div>
                            </a>`;
        } else {
          html += `<a href="${item.permalink}" aria-label="${item.caption}" class="swiper-slide">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <img src="${item.media_url}" srcset="${item.media_url}&amp;width=720 720w, ${item.media_url}&amp;width=660 660w, ${item.media_url}&amp;width=550 550w, ${item.media_url}&amp;width=480 480w, ${item.media_url}&amp;width=360 360w" width="1000" height="1000" loading="lazy" sizes="(min-width: 1200px) calc((100vw - 0px * 0) * 1), (min-width: 768px) calc( (100vw - 0px * 0 ) * 1), calc( (100vw - 0 * 0 ) * 1)" alt="${item.caption}">
                                </div>
                            </a>`;
        }
      });
      wrapper.innerHTML = html;
    }
  }

  generateGrid(items, ratio) {
    const wrapper = this.querySelector('.instagram--grid');
    if (wrapper) {
      let html = '';
      items.forEach((item) => {
        if (item.media_type === 'VIDEO') {
          html += `<a href="${item.permalink}" aria-label="${item.caption}">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <video loop="true" muted="true" playsinline="true" autoplay="true" src="${item.media_url}"></video>
                                </div>
                            </a>`;
        } else {
          html += `<a href="${item.permalink}" aria-label="${item.caption}">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <img src="${item.media_url}" srcset="${item.media_url}&amp;width=720 720w, ${item.media_url}&amp;width=660 660w, ${item.media_url}&amp;width=550 550w, ${item.media_url}&amp;width=480 480w, ${item.media_url}&amp;width=360 360w" width="1000" height="1000" loading="lazy" sizes="(min-width: 1200px) calc((100vw - 0px * 0) * 1), (min-width: 768px) calc( (100vw - 0px * 0 ) * 1), calc( (100vw - 0 * 0 ) * 1)" alt="${item.caption}">
                                </div>
                            </a>`;
        }
      });
      wrapper.innerHTML = html;
    }
  }
}
customElements.define('instagram-section', InstagramSection);

// js for grid custom
class GridCustom extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.parentElementt = document.querySelector(
      `#shopify-section-${this.dataset?.sectionId}`
    );
    this.loadmore = this.parentElementt?.querySelectorAll('loadmore-function');
    this.viewAll = this.parentElementt?.querySelector('.view_all');
    this.swiperSlideInnerHtml = this.innerHTML;
    this.init();
  }
  init() {
    if (this.enable == 'true') {
      let width = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 767) {
        this.actionOnMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add('swiper');
    this.classList.remove('grid', 'grid-cols');
    this.style.setProperty('padding-bottom', '52px');
    if (this.viewAll) {
      this.viewAll.classList.add('hidden');
    }
    if (this.loadmore && this.loadmore.length > 0) {
      this.loadmore.forEach((button) => {
        button.classList.add('hidden');
        button.classList.remove('block');
      });
    }
    const html = this.swiperSlideInnerHtml.replaceAll(
      'grid-custom-item',
      'swiper-slide'
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div>
      <div class="delta-trust-pagination-progressbar ${
        this.enable && this.dataset.mobile != 1.5 ? 'flex' : 'hidden'
      }">
        <div class="swiper-actions flex content-center gap-10 mb-0">
            <div class="trust-arrow trust-arrow-prev swiper-button-prev">
                <svg width="6" height="11" fill="none">
                    <use href="#icon-back" />
                </svg>
            </div>
            <div class="swiper-pagination"></div>
            <div class="trust-arrow trust-arrow-next swiper-button-next">
                <svg width="6" height="11" fill="none">
                    <use href="#icon-next" />
                </svg>
            </div>
        </div>
    </div>
    `;
    this.innerHTML = wrapper;
    this.initSlide();
  }
  actionOutMobile() {
    this.classList.remove('swiper');
    this.classList.add('grid', 'grid-cols');
    if (this.viewAll) {
      this.viewAll.classList.remove('hidden');
    }
    this.innerHTML = this.swiperSlideInnerHtml;
    if (this.loadmore && this.loadmore.length > 0) {
      this.loadmore.forEach((button) => {
        button.classList.add('block');
        button.classList.remove('hidden');
      });
    }
  }
}
customElements.define('grid-custom', GridCustom);

// js for slide with thumbnails
class SlideWithThumbs extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.thumbnailSlide = null;
    this.loop = false;
    this.deferInitForLCP();
  }
  deferInitForLCP() {
    const lcpImg = this.querySelector('img[fetchpriority="high"]');
    if (lcpImg && !lcpImg.complete) {
      lcpImg.addEventListener('load', () => this.init(), { once: true });
      setTimeout(() => { if (!this.globalSlide) this.init(); }, 3000);
    } else {
      this.init();
    }
  }
  init() {
    const nothumb = this.dataset?.nothumb;
    if (!nothumb) {
      this.initThumbnail();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () =>
          this.initThumbnail()
        );
      }
    }

    this.initSlide();
    this.pauseMedia();
    this.playMedia();
  }

  initSlide() {
    var autoplaying = this?.dataset.autoplay === 'true';
    this.loop = this?.dataset.loop === 'true';
    const rewind = this?.dataset.rewind === 'true';
    const itemMobile = this?.dataset.mobile ? this?.dataset.mobile : 1;
    const itemDesktop = this?.dataset.desktop ? this?.dataset.desktop : 4;
    var itemTablet = this?.dataset.tablet ? this?.dataset.tablet : '';
    var direction = this?.dataset.direction
      ? this?.dataset.direction
      : 'horizontal';
    var autoplaySpeed = this?.dataset.autoplaySpeed
      ? this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = this?.dataset.speed ? this?.dataset.speed : 400;
    const effect = this?.dataset.effect ? this?.dataset.effect : 'slide';
    var spacing = this?.dataset.spacing ? this?.dataset.spacing : 30;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    // For fade-effect carousels, defer autoplay until first user interaction
    // to prevent the second slide from becoming a new LCP candidate
    const deferAutoplay = autoplaying && effect === 'fade';
    if (window.innerWidth < 767) {
      direction = 'horizontal';
    }
    const container = this.querySelector('.main-slide__navigation');
    const initSwiper = this.querySelector('.swiper-wrapper-preview');
    var _this = this;
    const slideCount = initSwiper ? initSwiper.querySelectorAll('.swiper-slide').length : 0;
    const loopEnabled = this.loop && slideCount > Number(itemMobile) * 2;
    this.globalSlide = new Swiper(initSwiper, {
      slidesPerView: itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: deferAutoplay ? false : autoplaying,
      direction: direction,
      loop: loopEnabled,
      rewind: rewind,
      effect: effect,
      fadeEffect: effect === 'fade' ? {
        crossFade: true
      } : null,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: container?.querySelector('.swiper-button-next'),
        prevEl: container?.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el: this.querySelector('.swiper-pagination'),
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          return current + ' / ' + total;
        },
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet
        },
        1025: {
          slidesPerView: itemDesktop
        },
      },
      on: {
        init: function () {
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide:not(.swiper-slide-visible) motion-element'
          );
          slide_visibles?.forEach((slide) => {
            if (typeof slide?.initialize === 'function') slide?.initialize();
          });
          const currentSlide = this.slides[this.activeIndex];
          if (
            currentSlide &&
            currentSlide.classList.contains('cloudimage-360')
          ) {
            this.allowTouchMove = false;
          } else {
            this.allowTouchMove = true;
          }
        },
        slideChange: function () {
          const currentSlide = this.slides[this.activeIndex];
          if (currentSlide) {
            if (
              currentSlide.classList.contains('media-gallery__model') ||
              currentSlide.classList.contains('cloudimage-360')
            ) {
              this.allowTouchMove = false;
            } else {
              this.allowTouchMove = true;
            }
          }
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },
    });

    // Start autoplay only after user interacts, so the slide change
    // doesn't create a new LCP event before Chrome stops tracking
    if (deferAutoplay && this.globalSlide) {
      const swiper = this.globalSlide;
      const startAutoplay = () => {
        window.removeEventListener('scroll', startAutoplay);
        window.removeEventListener('click', startAutoplay);
        window.removeEventListener('touchstart', startAutoplay);
        if (!swiper || swiper.destroyed || !swiper.params) return;
        swiper.params.autoplay = autoplaying;
        swiper.autoplay.start();
      };
      window.addEventListener('scroll', startAutoplay, { passive: true });
      window.addEventListener('click', startAutoplay);
      window.addEventListener('touchstart', startAutoplay, { passive: true });
    }
  }

  initThumbnail() {
    const container = this.querySelector('.thumbnail-slide');
    if (!container) return;
    var direction = this.dataset.thumbDirection
      ? this.dataset.thumbDirection
      : 'horizontal';
    const slidesPerView = this.dataset.thumbSlidesPerView
      ? this.dataset.thumbSlidesPerView
      : 4;
    const spaceBetween = this.dataset.thumbSpaceBetween
      ? this.dataset.thumbSpaceBetween
      : 10;
    const watchSlidesVisibility = this.dataset.thumbWatchSlidesVisibility
      ? this.dataset.thumbWatchSlidesVisibility
      : true;
    const watchOverflow = this.dataset.thumbWatchOverflow
      ? this.dataset.thumbWatchOverflow
      : true;
    var thumbWrapEl = container.closest('.media-thumb-swiper');
    this.thumbnailSlide = new Swiper(container, {
      // centeredSlides: true,
      // centeredSlidesBounds: true,
      direction: 'horizontal',
      spaceBetween: spaceBetween,
      slidesPerView: 7.5,
      watchSlidesVisibility: watchSlidesVisibility,
      watchSlidesProgress: true,
      watchOverflow: watchOverflow,
      breakpoints: {
        768: {
          direction: direction,
          slidesPerView: direction == 'vertical' ? 10 : 11,
        },
      },
      on: {
        init: function () {
          updateThumbFadeMask(this, thumbWrapEl);
        },
        reachEnd: function () {
          updateThumbFadeMask(this, thumbWrapEl);
        },
        fromEdge: function () {
          updateThumbFadeMask(this, thumbWrapEl);
        },
        resize: function () {
          updateThumbFadeMask(this, thumbWrapEl);
        },
      },
    });

    function updateThumbFadeMask(swiper, wrapEl) {
      if (!wrapEl) return;
      var isEnd = swiper.isEnd || swiper.slides.length <= Math.ceil(swiper.params.slidesPerView);
      wrapEl.classList.toggle('thumbs-at-end', isEnd);
    }
  }

  pauseMedia() {
    this.globalSlide.on('slideChange', function () {
      // window.pauseAllMedia(); // Tinsley Modified
    });
  }

  playMedia() {
    const autoplay = this?.dataset.autoPlayVideo === 'true';
    if (!autoplay) return;
    // Load Vimeo API (guard against duplicate injection)
    if (!document.querySelector('script[src*="player.vimeo.com/api"]')) {
      var vimeoTag = document.createElement('script');
      vimeoTag.src = 'https://player.vimeo.com/api/player.js';
      document.head.appendChild(vimeoTag);
    }
    this.globalSlide.on('slideChangeTransitionEnd', function () {
      var activeSlide = this.slides[this.activeIndex];
      var video = activeSlide.querySelector('.media-video');
      if (video) {
        if (video.tagName === 'VIDEO') {
          video.play().catch(() => {});
        } else if (video.tagName === 'IFRAME') {
          // Play Vimeo
          if (video.src.includes('vimeo')) {
            var vimeoPlayer = new Vimeo.Player(video);
            vimeoPlayer.play();
          }
          // Play YouTube
          if (video.src.includes('youtube')) {
            video.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              '*'
            );
          }
        }
      }
    });
  }

  playActiveSlideVideo(swiper) {}

  functionGoto(position) {
    if (this.loop) {
      this.globalSlide.slideToLoop(position, 500);
    } else {
      this.globalSlide.slideTo(position, 500);
    }
  }

  updateSlide() {
    this.globalSlide.update();
  }

  updateThumbSlide() {
    this.thumbnailSlide.update();
  }

  appendSlide(item) {
    this.globalSlide.appendSlide(item);
  }
}
customElements.define('slide-with-thumbs', SlideWithThumbs);

class ProductRecentlyViewed extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.call();
  }
  initData() {
    var savedProductsArr = JSON.parse(
      localStorage.getItem('glozin__recently-viewed-products')
    );
    this.getStoredProducts(savedProductsArr);
  }
  getStoredProducts(p) {
    const limit = this.dataset?.limit;

    if (limit) {
      var query = '';
      var productAjaxURL = '';

      if (p && p.length > 0) {
        const sortedIds = p.slice();
        const idsToUse = sortedIds.slice(0, limit);
        query = idsToUse.join('%20OR%20id:');
        productAjaxURL = `&q=id:${query}`;
      }
    }
    fetch(`${this.dataset.url}${productAjaxURL}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recentlyViewedProducts = html.querySelector(
          'recently-viewed-products'
        );
        if (
          recentlyViewedProducts &&
          recentlyViewedProducts.innerHTML.trim().length
        ) {
          this.innerHTML = recentlyViewedProducts.innerHTML;
        }
        if (recentlyViewedProducts.innerHTML.trim().length === 0) {
          this.remove();
        }
      })
      .finally(() => {
        if (this.querySelector('.swiper-wrapper')) {
          this.initSlide();
        }
        initLazyloadItem();
        BlsLazyloadImg.init();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  call() {
    const __this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      __this.initData();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}
customElements.define('recently-viewed-products', ProductRecentlyViewed);

// js gallery
class MediaGallery extends HTMLElement {
  constructor() {
    super();
  }
  setActiveMedia(mediaId, prepend) {
    const activeMedia = this.querySelector(
      '[id^="GalleryViewer"]'
    ).querySelector(`[data-media-id="${mediaId}"]`);
    if (!activeMedia) return;
    this.querySelector('[id^="GalleryViewer"]')
      .querySelectorAll('[data-media-id]')
      .forEach((element) => {
        element.classList.remove('is-active');
      });
    activeMedia.classList.add('is-active');

    if (prepend) {
      activeMedia.parentElement.prepend(activeMedia);
    }
  }
}
customElements.define('media-gallery', MediaGallery);

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

var BlsCustomer = (function () {
  return {
    init: function () {
      this.toggleForm(), this.deleteAddresses(), this.addAddresses();
    },
    toggleForm: function () {
      const e = document.querySelector('.add-address');
      const c = document.querySelector('.cancel-add');
      if (e !== null && c !== null) {
        e.addEventListener('click', () => {
          if (e.getAttribute('aria-expanded') === 'false') {
            e.setAttribute('aria-expanded', 'true');
            e.closest('.bls-customer__address').classList.add('active');
          } else {
            e.setAttribute('aria-expanded', 'false');
            e.closest('.bls-customer__address').classList.remove('active');
          }
        });
        c.addEventListener('click', () => {
          if (
            c.closest('.bls-customer__address').classList.contains('active')
          ) {
            e.closest('.bls-customer__address').classList.remove('active');
            e.closest('.add-address').setAttribute('aria-expanded', 'false');
          }
        });
      }
    },
    deleteAddresses: function () {
      const btn = document.querySelectorAll('.address-delete');
      btn.forEach((e) => {
        e.addEventListener('click', () => {
          const id = e?.dataset.formId;
          const msg = e?.dataset.confirmMessage;
          if (confirm(msg || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + id, {
              parameters: { _method: 'delete' },
            });
          }
        });
      });
    },
    addAddresses: function () {
      if (Shopify && document.getElementById('AddressCountryNew')) {
        new Shopify.CountryProvinceSelector(
          'AddressCountryNew',
          'AddressProvinceNew',
          {
            hideElement: 'AddressProvinceNewContainer',
          }
        );
      }
      const edit = document.querySelectorAll('.edit-country-option');
      edit.forEach((e) => {
        const formId = e?.dataset.formId;
        const editCountry = 'AddressCountry_' + formId;
        const editProvince = 'AddressProvince_' + formId;
        const editContainer = 'AddressProvinceContainer_' + formId;
        new Shopify.CountryProvinceSelector(editCountry, editProvince, {
          hideElement: editContainer,
        });
      });
    },
  };
})();
BlsCustomer.init();
class ideaProducts extends HTMLElement {
  constructor() {
    super();
    this.view_idea_product = this.querySelector('.view_idea_product');
    this.content = this.querySelector('.idea-product-list');
    this.close = this.querySelector('.close');
    this.init();
  }
  init() {
    const _this = this;
    this.view_idea_product.addEventListener('click', (e) => {
      _this.toggleViewIdeaProducts('show');
    });
    this.close.addEventListener('click', (e) => {
      _this.toggleViewIdeaProducts.bind(_this)();
    });
  }

  toggleViewIdeaProducts(type = 'hidden') {
    if (type == 'hidden') {
      this.classList.remove('active');
    } else {
      this.classList.add('active');
    }
  }
}

customElements.define('idea-product', ideaProducts);

const outfit_idea = document.querySelector('.outfit_idea');
if (outfit_idea) {
  document.body.addEventListener('click', function (event) {
    if (!event.target.closest('.idea-product')) {
      const ideaProductInstances = document.querySelectorAll('idea-product');
      ideaProductInstances.forEach((instance) => {
        instance.toggleViewIdeaProducts();
      });
    }
  });
}

function PreloadPage() {
  const preload = document.querySelector('preload-page');
  window.addEventListener('DOMContentLoaded', () => {
    if (preload) {
      motion.animate(
        preload,
        {
          opacity: [1, 0],
          visibility: ['visible', 'hidden'],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 1,
        }
      );
    }
  });
}
PreloadPage();

class GridList extends HTMLElement {
  constructor() {
    super();
    if (!this.hasAttribute('hold')) {
      motion.inView(this, this.showGridItems.bind(this), {
        margin: '0px 0px -5px 0px',
      });
    }
  }

  get gridItems() {
    return this.querySelectorAll(
      "motion-element[hold]:not([data-image]):not([style*='opacity: 1']"
    );
  }

  get visibleGridItems() {
    return this.querySelectorAll(
      "motion-element:not([data-image])[style*='opacity: 1']"
    );
  }
  hideGrid() {
    motion.animate(
      this.gridItems,
      { transform: 'translateY(3.5rem)', opacity: 0.01, visibility: 'hidden' },
      { duration: 0 }
    );
  }

  hideGridItems() {
    if (!this.hasAttribute('hold')) {
      motion.animate(
        this.visibleGridItems,
        {
          transform: ['translateY(0)', 'translateY(3.5rem)'],
          opacity: [1, 0.01],
          visibility: ['visible', 'hidden'],
        },
        {
          duration: 0.4,
          delay: motion.stagger(0.1),
          easing: [0, 0, 0.3, 1],
        }
      );
    }
  }

  showGridItems() {
    if (!this.hasAttribute('hold')) {
      motion.animate(
        this.gridItems,
        {
          transform: ['translateY(3.5rem)', 'translateY(0)'],
          opacity: [0.01, 1],
          visibility: ['hidden', 'visible'],
        },
        {
          duration: 0.47,
          delay: motion.stagger(0.15, { startDelay: 0.1 }),
          easing: [0, 0, 0.3, 1],
        }
      );
    }
  }
}
customElements.define('grid-list', GridList);
class ProgressStockBar extends HTMLElement {
  constructor() {
    super();
    motion.inView(this, this.init.bind(this), { margin: '0px 0px -10px 0px' });
  }

  init() {
    this.style.setProperty('--percent', `100%`);

    setTimeout(() => {
      this.style.setProperty('--percent', `${this.dataset.progress}%`);
    }, 200);
  }
}
customElements.define('progress-stock-bar', ProgressStockBar);
class HeaderTotalPrice extends HTMLElement {
  constructor() {
    super();
  }
  updateTotal(cart) {
    this.minicart_total = this.querySelector("[data-cart-subtotal-price]");
    if (!this.minicart_total) return;
    if (cart.total_price == undefined) return;
    const price_format = Shopify.formatMoney(
      cart.total_price,
      cartStrings?.money_format
    );
    this.minicart_total.innerHTML = price_format;
  }
}
customElements.define("header-total-price", HeaderTotalPrice);
class ProductWithBanner extends HTMLElement {
  constructor() {
    super();
    this.bannerImages = this.querySelectorAll('.product-banner__image');
    this.init();
  }
  
  init() {
    this.waitForSlideSection();
  }
  
  waitForSlideSection(attempts = 0) {
    if (attempts > 50) return;
    const slideSection = this.querySelector('slide-section');
    if (!slideSection || !slideSection.globalSlide) {
      setTimeout(() => this.waitForSlideSection(attempts + 1), 100);
      return;
    }
    slideSection.updateActiveBanner = () => {};
    slideSection.globalSlide.on('slideChange', () => {
      this.updateActiveBanner(slideSection.globalSlide);
    });
    this.updateActiveBanner(slideSection.globalSlide, true);
  }
  
  updateActiveBanner(swiper, isInitial = false) {
    if (!swiper || !this.bannerImages || this.bannerImages.length <= 0) return;
    if (isInitial) {
    } else {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;
      const productIdFromSlide = activeSlide.querySelector('[data-product-id]')?.dataset.productId;
      const productId = productIdFromSlide || 
                        activeSlide.querySelector('.block-text-product__item')?.dataset.productId ||
                        this.querySelectorAll('.swiper-slide')[swiper.realIndex]?.dataset.productId;
      this.bannerImages.forEach(image => {
        image.classList.remove('active');
      });
      let matchingBanner;
      if (productId) {
        matchingBanner = Array.from(this.bannerImages).find(
          image => image.dataset.productId === productId
        );
      }
      
      if (matchingBanner) {
        matchingBanner.classList.add('active');
      } else {
        const index = swiper.realIndex;
        if (this.bannerImages[index]) {
          this.bannerImages[index].classList.add('active');
        }
      }
    }
  }
}
customElements.define('product-with-banner', ProductWithBanner);

//WW adding for custom function

class PopupAddons extends PopupBase {
  constructor() {
    super();
    this.popupPopupDiv = this.querySelector(".popup-addons__content");
    this.targetHash = this.dataset.hash; 
    this.init();
  }

  init() {
    if (this.popupPopupDiv) {
      this.addEventListener('click', this.onClick.bind(this));
      
      if (this.targetHash) {
        this.checkHashAndOpen();
        window.addEventListener('hashchange', this.checkHashAndOpen.bind(this), false);
      }
    } else {
      console.warn('PopupAddons Warning: No ".popup-addons__content" found inside this element. Popup cannot be initialized.', this);
    }
  }

  checkHashAndOpen() {
    if (!window.location.hash || !this.targetHash) return;

    const currentHash = window.location.hash.replace('#', '').toLowerCase();
    const target = this.targetHash.toLowerCase();
    
    if (currentHash === target) {
      setTimeout(() => {
        const existingPopup = document.querySelector('.tingle-modal--visible');
        if (!existingPopup) {
          this.onClick(); 
        }
      }, 500);
    }
  }

  onClick(e) {
    if (e) e.preventDefault(); 

    const html = this.popupPopupDiv;
    if (!html) return;
    html.classList.remove("hidden");
    this.initPopup(
      html,
      `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
    );
  }
}
customElements.define('popup-addons', PopupAddons);

class FoldupAddons extends PopupBase {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.trigger = this.querySelector('.foldup-trigger');
    if (this.trigger) {
      this.trigger.addEventListener('click', this.onClick);
    }
  }
  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener('click', this.onClick);
    }
  }
  onClick(e) {
    const isOpen = this.classList.toggle('open');
    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', isOpen);
    }
  }
}
customElements.define('foldup-addons', FoldupAddons);

class WWTabItems extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".ww-tab__tab-item");
    this.select = this.querySelector(".ww-tab__select-tab");
    this.content = this.querySelectorAll(".ww-tab__tab-content");
    this.init();
  }
  init() {
    const self = this;
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        self.onClick(this);
      });
    });
  }
  onClick(tab) {
    const blockId = tab.dataset.blockId;
    this.showContent(blockId);
    this.tabs.forEach((t) => {
      t.classList.remove("active");
    });
    tab.classList.add("active");
  }

  showContent(blockId) {
    this.content.forEach((content) => {
      if (content.dataset.blockId === blockId) {
        content.classList.add('active');
        let motion_element = content.querySelectorAll("motion-element");
        motion_element.forEach((motion) => {
          motion.refreshAnimation();
        });
      } else {
        content.classList.remove("active");
      }
    });
  }
}
customElements.define('ww-tab-items', WWTabItems);

// js for tab item
class WWTabMulti extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector(".ww-select-collection-tab");
    this.content = this.querySelectorAll(".ww-collection-tab__tab-content");
    this.select_li = this.querySelectorAll(".ww-collection_title_input");
    this.init();
  }
  init() {
    const self = this;
    this.select.addEventListener('click', function (e) {
      if (e.target.classList.contains("ww-select__selected_title")) {
        let select__dropdown = this.querySelector(".ww-select-custom__content");
        this.classList.toggle('active');
        select__dropdown.classList.toggle("invisible");
      }
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest(".ww-select-collection-tab")) {
        self.select.classList.remove("active");
        document
          .querySelectorAll(
            ".ww-select-collection-tab .ww-select-custom__content"
          )
          ?.forEach((item) => {
            item.classList.add("invisible");
          });
      }
    });
    this.select_li.forEach((item) => {
      item.addEventListener('click', function () {
        self.onClickBySelect(this);
        self.select.classList.remove('active');
        document
          .querySelectorAll(
            ".ww-select-collection-tab .ww-select-custom__content"
          )
          ?.forEach((item) => {
            item.classList.add("invisible");
          });
      });
    });
  }

  onClickBySelect(selectedBlockId) {
    let select__selected_title = this.querySelector(
      ".ww-select__selected_title"
    );
    select__selected_title.innerHTML =
      selectedBlockId.innerHTML +
      `<svg class="icon-down transition active-rotated" width="10" height="6">
         <use href="#icon-arrow-down"></use>
       </svg>`;
    this.showContent(selectedBlockId.dataset.id);
  }

  showContent(blockId) {
    this.content.forEach((content) => {
      if (content.dataset.blockId === blockId) {
        content.classList.add("active");
        let motion_element = content.querySelectorAll("motion-element");
        motion_element.forEach((motion) => {
          motion.refreshAnimation();
        });
      } else {
        content.classList.remove("active");
      }
    });
  }
}
customElements.define('ww-multi-tab-select', WWTabMulti);

// Tinsley
class RegionSelector extends PopupBase {
  constructor() {
    super();
    this.$host = window.location.host;
    this.currentPath = new URL(window.location.href).pathname;
    
    this.design_mode = this.dataset.design_mode === 'true';
    this.ip_guide = this.dataset.ip_guide === 'true';
    this.ip_guide_hide_days = parseInt(this.dataset.ip_guide_hide_days, 10) || 0;
    this.shop_iso_code = this.dataset.shop_iso_code;
    this.user_country = window.userSiteData?.country || '';
    this.user_market = window.userSiteData?.market_handle || '';
    this.user_country_iso_code = window.userSiteData?.country_iso_code || '';

    const currentHref = window.location.href;
    if (currentHref.startsWith('https://eu.plaud.ai/nl/') || currentHref === 'https://eu.plaud.ai/nl') {
      this.$host = 'eu.plaud.ai/nl';
      this.shop_iso_code = "NL";
    } else if (currentHref.startsWith('https://eu.plaud.ai/pt/') || currentHref === 'https://eu.plaud.ai/pt') {
      this.$host = 'eu.plaud.ai/pt';
      this.shop_iso_code = "PT";
    }

    // DTC-637: SEA runs multiple countries under one store via path-prefixed locales
    // (/en-th, /en-my, /en-vi, /en-ph). A single global site_iso_code can't represent
    // them, so on these sub-paths clear it and let getActiveSite() match by path, so the
    // displayed ISO comes from the matching region_data site instead of the SG root.
    if (this.$host === 'sea.plaud.ai' && /^\/en-(th|my|vi|ph)(\/|$)/.test(this.currentPath)) {
      this.shop_iso_code = '';
    }

    this.siteData = [];
    this.allSites = [];
    this.modalContent = '';
    this.modalTitle = `<h2 class="h2 font-semibold!">${this.dataset.modal_title || ''}</h2>`;

    this.activeSite = {};
    this.targetSite = {};
    this.$activeIsoCodeDom = this.querySelector('.active-store-iso-code');
    this.$ipGuideSection = document.querySelector('#ip-guide-section');
    this.$ipGuidePopup = document.querySelector('#ip-guide-popup');

    this.init();
  }

  init() {
    this.siteData = this.getSiteData();
    this.allSites = this.siteData.reduce((acc, region) => acc.concat(region.children || []), []);
    this.modalContent = this.getModalContent();

    this.activeSite = this.getActiveSite();
    if (this.$activeIsoCodeDom && this.activeSite.iso_code) {
      this.$activeIsoCodeDom.innerText = this.activeSite.iso_code;
    }

    window.addEventListener('load', () => {
      this.addEventListener('click', this.onThisClick.bind(this));
    })
    if (this.ip_guide && this.$ipGuideSection) {
      window.addEventListener('load', () => {
        // Shopify Liquid does NOT expose real IP (request.country is undefined; localization follows currency selection).
        // Fetch real IP from /browsing_context_suggestions.json before running popup logic so the recommendation matches actual location, not selected currency.
        fetch('/browsing_context_suggestions.json')
          .then(r => r.json())
          .then(data => {
            const realIso = data?.detected_values?.country?.handle?.toUpperCase();
            if (realIso) this.user_country_iso_code = realIso;
          })
          .catch(() => {})
          .finally(() => this.ipGuideHandle());
      })
    }
  }

  onThisClick() {
    this.initPopup(this.modalContent, this.modalTitle, 'region-selector-modal',($modalBox) => {
      if(window.innerWidth <= 768){
        $modalBox.querySelectorAll('.region-name').forEach((ele) => {
          var parentEle = ele.parentElement;
          parentEle.classList.add('hide');
          ele.addEventListener("click", function(){
            parentEle.classList.toggle('hide');
          })
        });
      }

      $modalBox.querySelectorAll('.site-item a').forEach((ele) => {
        ele.addEventListener("click", (e) => {
          e.preventDefault();
          const href = ele.getAttribute("href");
          if(!href) return;
          window.location.href = this._buildRedirectUrl(href);
        });
      })
    });
  }

  getSiteData() {
    const data = Array.isArray(window.siteData) ? window.siteData : [];
    if(!data) return;

    data.sort((a, b) => a.id - b.id);
    data.forEach(item => {
      if (item.children.length > 0) {
        item.children.sort((a, b) => a.id - b.id);
      }
    });

    const browserLang = navigator.language || navigator.userLanguage;
    const multiLangCountries = ['BE', 'LU', 'CH']; // Belgium, Luxembourg, Switzerland

    multiLangCountries.forEach(countryCode => {
      const matchSites = [];
      data.forEach(item => {
        if (item.children) {
          item.children.forEach(child => {
            if (child.iso_code === countryCode) {
              matchSites.push(child);
            }
          });
        }
      });

      if (matchSites.length > 1) {
        let targetSite = matchSites.find(site => browserLang.startsWith(site.language_isocode));
        if (!targetSite) {
            targetSite = matchSites.find(site => site.language_isocode === 'en');
        }
        if (targetSite) {
          data.forEach(item => {
            if (item.children) {
              item.children = item.children.filter(child => child.iso_code !== countryCode || child === targetSite);
            }
          });
        }
      }
    });

    return data;
  }

  getModalContent() {
    const regionItemTemplate = `
      <div class="region-item">
        <div class="region-name">
          <h3 class="h3 font-medium!" data-handle="{__handle}">{__region}</h3>
          <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m10.5867 6.69329-2.58671 2.58667-2.58667-2.58667c-.26-.26-.68-.26-.94 0s-.26.68 0 .94l3.06 3.06001c.26.26.68.26.94 0l3.05998-3.06001c.26-.26.26-.68 0-.94-.26-.25333-.6866-.26-.9466 0z" fill="currentColor"></path></svg>
        </div>
        <ul class="site-list list-none">{__children}</ul>
      </div>
    `;
    const siteItemTemplate = `
      <li class="site-item">
        <a href="{__website_url}" data-iso_code="{__iso_code}">
          <span class="h5 font-medium!">{__name}</span>
          <span class="h6 font-normal! text-gray" data-iso_code="{__language_isocode}">
            {__language_name} / {__currency}
          </span>
        </a>
      </li>
    `;

    var html = '';
    this.siteData.forEach(item => {
      var childrenHtml = '';
      item.children.forEach(site => {
        if(site.is_visible === 'false') return;

        childrenHtml += siteItemTemplate
          .replace('{__name}', site.local_name || site.name)
          .replace('{__iso_code}', site.iso_code)
          .replace('{__website_url}', site.website_url)
          .replace('{__language_name}', site.language_local_name || site.language_name)
          .replace('{__language_isocode}', site.language_isocode)
          .replace('{__currency}', site.currency);
      })
      html += regionItemTemplate
        .replace('{__handle}', item.handle)
        .replace('{__region}', item.region)
        .replace('{__children}', childrenHtml);
    })
    return `<div class="region-list">${html}</div>`;
  }

  getActiveSite() {
    const normalizePath = p => (p === '/' ? '/' : p.replace(/\/+$/, ''));

    if(this.shop_iso_code) {
      const isoMatch = this.allSites.find(site => site.iso_code === this.shop_iso_code);
      if (isoMatch) return isoMatch;
    }

    // DTC-637: multiple sites can share a host (e.g. sea.plaud.ai root + /en-th, /en-my…).
    // The root site (path '/') matches every path, so pick the longest matching path prefix
    // rather than the first match, so /en-th resolves to the TH site, not the root.
    let matched = {};
    let matchedLen = -1;
    for (const site of this.allSites) {
      try {
        const url = new URL(site.website_url);
        if (url.host !== this.$host) continue;
        const sitePath = normalizePath(url.pathname);
        if (sitePath !== '/' && !this.currentPath.startsWith(sitePath)) continue;
        const len = sitePath === '/' ? 0 : sitePath.length;
        if (len > matchedLen) {
          matched = site;
          matchedLen = len;
        }
      } catch (err) {
        console.warn('[getActiveSite] Invalid URL:', site.website_url, err);
      }
    }
    return matched;
  }

  getTargetSite() {
    const byIso = this.allSites.find(site => site.iso_code === this.user_country_iso_code);
    if (byIso) return byIso;

    for (const region of this.siteData) {
      if (region.market === this.user_market) return region.main_site || region.children[0];
    }

    const globalRegion = this.siteData.find(r => r.market === 'global');
    if (globalRegion) return globalRegion.main_site || globalRegion.children[0];

    return null;
  }

  // Append current page's UTM params + manual_redirect=1 to a destination URL.
  // Preserves any existing query string on the destination.
  _buildRedirectUrl(baseUrl) {
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
    const current = new URLSearchParams(window.location.search);
    const carry   = new URLSearchParams();

    utmKeys.forEach(k => {
      const v = current.get(k);
      if (v) carry.set(k, v);
    });
    carry.set('manual_redirect', '1');

    const sep = baseUrl.includes('?') ? '&' : '?';
    return baseUrl + sep + carry.toString();
  }

  goToTargetSite() {
    window.location.href = this._buildRedirectUrl(this.targetSite.website_url);
  }

  ipGuideHandle() {
    // user_country_iso_code is now set by init()'s /browsing_context_suggestions.json fetch (real IP).
    // dataset.detectedIso is localization-based (follows currency selection) — DO NOT use it to override real IP.
    const detectedName = this.$ipGuideSection?.dataset?.detectedName || '';

    if (this.activeSite && this.activeSite.iso_code === this.user_country_iso_code) return;
    this.targetSite = this.getTargetSite();
    if (!this.targetSite || !this.targetSite.website_url) return;
    if (this.activeSite.website_url === this.targetSite.website_url) return;

    if (!this.design_mode && getCookie('ip_guide_stay')) return;

    const $bar        = this.$ipGuidePopup;
    if (!$bar) return;
    const $select     = $bar.querySelector('.ip-guide-select');
    const $trigger    = $bar.querySelector('.ip-guide-select__trigger');
    const $trigLabel  = $trigger?.querySelector('.ip-guide-select__label-text');
    const $optCountry = $bar.querySelector('.ip-guide-select__option--country');
    const $optOther   = $bar.querySelector('.ip-guide-select__option--other');
    const $continue   = $bar.querySelector('.guide-btn');
    const $close      = $bar.querySelector('.close-btn');

    // Country label: Shopify-native name (already pre-filled in Liquid), then site data fallback
    const countryLabel = detectedName || this.targetSite.local_name || this.targetSite.name || '';
    const otherLabel   = $optOther ? $optOther.textContent.trim() : '';

    // Sync country name nodes (Liquid pre-fills on render; JS corrects if targetSite differs).
    // Target the inner text spans only — .guide-country is the outer wrapper that also contains
    // the SVG checkmark; setting textContent on it would destroy child nodes including $trigLabel.
    $bar.querySelectorAll('.ip-guide-select__label-text, .guide-country-option').forEach(el => {
      el.textContent = countryLabel;
    });

    let selectedType = 'country';

    const setSelected = (type) => {
      selectedType = type;
      const isCountry = type === 'country';
      if ($optCountry) $optCountry.setAttribute('aria-selected', isCountry ? 'true' : 'false');
      if ($optOther)   $optOther.setAttribute('aria-selected',   isCountry ? 'false' : 'true');
      if ($trigLabel)  $trigLabel.textContent = isCountry ? countryLabel : otherLabel;
    };

    const closeDropdown = () => $trigger?.setAttribute('aria-expanded', 'false');

    const toggleDropdown = () => {
      if (!$trigger) return;
      const open = $trigger.getAttribute('aria-expanded') === 'true';
      $trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open) {
        // Focus the currently selected option so keyboard users can navigate immediately
        requestAnimationFrame(() => {
          const selected = $bar.querySelector('.ip-guide-select__option[aria-selected="true"]');
          (selected || $optCountry)?.focus();
        });
      }
    };

    // One-time listener guard — prevents double-binding on design_mode reconnects.
    // e.stopPropagation() only stops bubbling; it does NOT prevent multiple listeners
    // on the same element from firing. Without this guard, a second ipGuideHandle() call
    // adds a second click listener, causing two toggles (false→true→false) per click.
    if (!$bar.dataset.ipGuideReady) {
      $bar.dataset.ipGuideReady = '1';

      if ($trigger) {
        $trigger.addEventListener('click', (e) => { e.stopImmediatePropagation(); toggleDropdown(); });
        $trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleDropdown(); }
          if (e.key === 'Escape') closeDropdown();
        });
      }
      if ($optCountry) {
        $optCountry.addEventListener('click', () => { setSelected('country'); closeDropdown(); $trigger?.focus(); });
        $optCountry.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelected('country'); closeDropdown(); $trigger?.focus(); }
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            setSelected('other');
            $optOther?.focus();
          }
          if (e.key === 'Escape') { closeDropdown(); $trigger?.focus(); }
        });
      }
      if ($optOther) {
        $optOther.addEventListener('click',   () => { setSelected('other');   closeDropdown(); $trigger?.focus(); });
        $optOther.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelected('other'); closeDropdown(); $trigger?.focus(); }
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            setSelected('country');
            $optCountry?.focus();
          }
          if (e.key === 'Escape') { closeDropdown(); $trigger?.focus(); }
        });
      }

      // Close dropdown when focus leaves the entire select widget (e.g. Tab out).
      // Use setTimeout(0) + document.activeElement instead of relatedTarget:
      // relatedTarget can be null in Firefox/Edge when tabindex changes mid-focus,
      // causing a false "focus left the widget" close that reverts aria-selected.
      if ($select) {
        $select.addEventListener('focusout', () => {
          setTimeout(() => {
            if ($select && !$select.contains(document.activeElement)) closeDropdown();
          }, 0);
        });
      }

      document.addEventListener('click', (e) => {
        if ($select && !$select.contains(e.target)) closeDropdown();
      }, { passive: true });

      if ($continue) {
        $continue.addEventListener('click', () => {
          if (selectedType === 'other') {
            this._closeBar($bar);
            this.onThisClick();
          } else {
            this.goToTargetSite();
          }
        });
      }

      if ($close) {
        $close.addEventListener('click', () => {
          this._closeBar($bar);
          if (!this.design_mode) {
            setCookie('ip_guide_stay', 'true', this.ip_guide_hide_days);
          }
        });
      }
    }

    this._openBar($bar);
  }

  _openBar($bar) {
    $bar.style.willChange = 'max-height, opacity';
    $bar.style.display = '';
    // Double rAF ensures display:'' is painted before transition starts
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        $bar.classList.add('ip-guide-bar--open');
        $bar.addEventListener('transitionend', () => {
          $bar.style.willChange = '';
        }, { once: true });
      });
    });
  }

  _closeBar($bar) {
    $bar.style.willChange = 'max-height, opacity';
    $bar.classList.remove('ip-guide-bar--open');
    $bar.addEventListener('transitionend', () => {
      $bar.style.display = 'none';
      $bar.style.willChange = '';
    }, { once: true });
  }
}
customElements.define('region-selector', RegionSelector);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.inputElement = null;
  }

  connectedCallback() {
    this.inputElement = this.querySelector(".quantity-selector-input");
    if (!this.inputElement) return;

    const val = parseInt(this.dataset.min_count, 10);
    this.min_count = isNaN(val) ? 1 : val;
    const [minusBtn, plusBtn] = this.querySelectorAll(".quantity-selector-btn");

    if (minusBtn) {
      minusBtn.addEventListener("click", () => {
        this.updateQuantity(this.getValue() - 1);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener("click", () => {
        this.updateQuantity(this.getValue() + 1);
      });
    }
  }

  getValue() {
    const val = parseInt(this.inputElement.value, 10);
    return isNaN(val) ? 1 : val;
  }

  updateQuantity(newValue) {
    if (newValue < this.min_count) newValue = this.min_count;
    this.inputElement.value = newValue;
    this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
customElements.define("quantity-selector", QuantitySelector);

class AIPlanRecommendation extends HTMLElement {
  constructor() {
    super();

    this.$cartCountDomList = document.querySelectorAll(".cart-count");
    this.$headerTotalPrice = document.querySelector("header-total-price");
    this.$mainCart = document.querySelector("new-main-cart");
    this.$popupCon = this.querySelector('.recommendation-popup-con');
    this.$mask = this.querySelector('.mask');
    this.$closeBtn = this.querySelector('.popup-close-btn');
    this.$confirmBtn = this.querySelector('.popup-confirm-btn');
    this.$switchBtn = this.querySelector(".recommendation-switch");
    this.$productItemList = this.querySelectorAll(".product-item");

    this.$firstYearlyProduct = this.querySelector(`.product-item[data-type="yearly"]`);
    this.$firstMonthlyProduct = this.querySelector(`.product-item[data-type="monthly"]`);

    this.productHandleList = Array.from(this.$productItemList).map(i => i.dataset.handle);

    this.init();
  }

  init() {
    this.$confirmBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.confirm();
    });
    this.$closeBtn?.addEventListener("click", () => this.close());
    this.$mask?.addEventListener("click", () => this.close());
    this.$switchBtn?.addEventListener("click", () => this.toggleType());
    this.addEventListener('click', (e) => {
      const item = e.target.closest('.product-item');
      if(item) this.selectProduct(item.dataset.handle);
    });
  }

  open(handle) {
    if(!handle || !this.productHandleList.includes(handle)) {
      handle = this.$firstYearlyProduct?.dataset.handle || this.$firstMonthlyProduct?.dataset.handle;
    }
    if(!handle) return;

    document.documentElement.classList.add('open-popup');
    this.classList.add('open');
    this.selectProduct(handle);
  }

  close() {
    document.documentElement.classList.remove('open-popup');
    this.classList.remove('open');
  }

  toggleType() {
    const isYearly = this.$popupCon.classList.contains("yearly");
    const product = isYearly ? this.$firstMonthlyProduct : this.$firstYearlyProduct;
    if(product) this.selectProduct(product.dataset.handle);
  }

  selectProduct(handle) {
    if(!handle) return;

    const $target = this.querySelector(`.product-item[data-handle="${handle}"]`);
    if (!$target) return;

    const type = $target.dataset.type;
    this.$popupCon.classList.toggle("yearly", type === "yearly");
    this.querySelector(".product-item.selected")?.classList.remove("selected");
    $target.classList.add("selected");
  }

  async confirm() {
    const $selected = this.querySelector(".product-item.selected");
    if (!$selected) return;

    const id = $selected.dataset.id;
    const selling_plan = $selected.dataset.selling_plan_id || undefined;
    if (!id) return;

    if (typeof handleAddToCart === "function") {
      handleAddToCart($selected);
    }

    this.$confirmBtn?.classList.add('loading');

    try {
      if (selling_plan) {
        const cartInfo = await this.getCartInfo();
        if (cartInfo.ids.includes(id)) return;

        const updates = {};
        cartInfo.sellingPlanItems.forEach(itemId => { updates[itemId] = 0; });
        if (Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            ...fetchConfig(),
            body: JSON.stringify({ updates })
          });
        }
      }

      await this.addProduct(id, selling_plan, true);
      this.openCartDrawer();
    } catch(e) {
      console.error(e);
    } finally {
      this.$confirmBtn?.classList.remove('loading');
      this.close();
    }
  }

  async getCartInfo() {
    const ids = [];
    const sellingPlanItems = [];

    if (this.$mainCart) {
      document.querySelectorAll("new-main-cart .cart-items-card > .cart-item").forEach(item => {
        ids.push(item.dataset.id);
        if (item.dataset.selling_plan_id) sellingPlanItems.push(item.dataset.id);
      });
    } else {
      const cart = await fetch('/cart.json').then(r => r.json());
      cart.items.forEach(item => {
        ids.push(String(item.id));
        if (item.selling_plan_allocation) sellingPlanItems.push(String(item.id));
      });
    }

    return { ids, sellingPlanItems };
  }

  openCartDrawer() {
    if (this.$mainCart) return;
    const cartElement =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');
    if (cartElement) {
      cartElement.open();
    } else {
      window.location = window.routes.cart_url;
    }
  }

  async addProduct(id, selling_plan = null, isRender = true, callback = null) {
    if(!id) return;

    const body = JSON.stringify({
      id,
      quantity: 1,
      selling_plan: selling_plan || undefined,
      sections: this.$mainCart?.getSectionsToRender()?.map(s => s.section) || [],
      sections_url: window.location.pathname
    });

    try {
      const res = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body });
      const stateText = await res.text();
      const parsedState = JSON.parse(stateText);
      if(parsedState.errors) {
        this.toastError(parsedState.errors);
        return;
      }
      if(isRender) this.updateCart(parsedState, true);
    } catch (err) {
      console.error(err);
    } finally {
      callback?.();
    }
  }

  updateCart(parsedState, showToast = false) {
    if (this.$mainCart) {
      this.$mainCart.renderData(parsedState, 1);
      return;
    }

    if (parsedState.item_count !== undefined) {
      this.updateItemsCount(parsedState, showToast);
      return;
    }

    fetch("/cart.json")
    .then(res => res.json())
    .then(cart => {
      parsedState.item_count = cart.item_count;
      this.updateItemsCount(parsedState, showToast);
    })
    .catch(err => {
      console.error("Error fetching cart:", err);
      parsedState.item_count = parsedState.item_count ?? 0;
      this.updateItemsCount(parsedState, showToast);
    });
  }

  updateItemsCount(parsedState, showToast = false) {
    this.$cartCountDomList.forEach((el) => {
      el.innerHTML = el.classList.contains("cart-count-drawer")
        ? `(${parsedState.item_count})`
        : (parsedState.item_count > 100 ? "~" : parsedState.item_count);
    });
    if (this.$headerTotalPrice) this.$headerTotalPrice.updateTotal(parsedState);
    if(showToast) this.toastSuccess(window.variantStrings.addSuccess);
  }

  toastSuccess(message) {
    const wrapperDiv = document.createElement("div");
    wrapperDiv.innerHTML = `
      <div class="mt-10 newsletter-form__message--success success form__message inline-flex align-center" tabindex="-1" role="status" aria-live="polite">
        <svg width="18" height="18" fill="none">
          <g stroke="#137F24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
            <path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>
          </g>
        </svg>
        <span class="ml-5">${message}</span>
      </div>
    `;
    showToast(wrapperDiv.innerHTML, 2000, "modal-success");
  }

  toastError(message, line) {
    const wrapperDiv = document.createElement("div");
    wrapperDiv.innerHTML = `
      <div class="mt-10 line-item-error-${line || 1} error form__message inline-flex align-center" tabindex="-1" role="alert" aria-live="assertive">
          <svg width="18" height="18" fill="none" class="flex-auto">
              <g stroke="#D0473E" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
                  <path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>
              </g>
          </svg>
          <span class="ml-5">${message}</span>
      </div>
    `;
    showToast(wrapperDiv.innerHTML, 2000, "modal-error");
  }
}
customElements.define("ai-plan-recommendation", AIPlanRecommendation);


class KlaviyoNewsletter extends HTMLElement {
  constructor() {
    super();

    this.publicKey = this.dataset.publicKey;
    this.listId = this.dataset.listId;
    this.customSource = this.dataset.source || 'footer';
    this.successMsg = this.dataset.successMsg;
    this.errorMsg = this.dataset.errorMsg;

    this.form = this.querySelector('form');
    this.submitBtn = this.querySelector('button[type="submit"]');
    this.emailInput = this.querySelector('input[name="email"]');

    if(!this.publicKey || !this.listId) {
      console.warn('Klaviyo Configuration missing: Please set List ID & Public Key in settings.');
      if(this.emailInput) {
        this.emailInput.disabled = true;
        this.emailInput.placeholder = "Subscription unavailable";
      }
      if(this.submitBtn) this.submitBtn.disabled = true;
      return;
    }

    this.successMessageDiv = this.querySelector('.klaviyo-success');
    this.errorMessageDiv = this.querySelector('.klaviyo-error');

    this.init();
  }
  init() {
    if(this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      if(this.submitBtn) this.submitBtn.disabled = false;
    }
  }
  onSubmit(e) {
    e.preventDefault();

    const email = this.emailInput?.value;
    if(!email) {
      console.warn('Email is empty.');
      return;
    }

    this.submitBtn?.classList.add('loading');
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.publicKey}`;
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: this.customSource,
          profile: {
            data: {
              type: "profile",
              attributes: {email: email}
            }
          }
        },
        relationships: {
          list: {
            data: {type: "list", id: this.listId}
          }
        }
      }
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        'accept': 'application/vnd.api+json',
        'revision': '2025-10-15'
      },
      body: JSON.stringify(payload)
    }).then(async res => {
      if (res.ok) {
        try {
          return await res.json();
        } catch {
          return ({});
        }
      }
      throw await res.json();
    }).then(data => {
      if(this.successMessageDiv) {
        this.successMessageDiv.style.display = 'inline-flex';
        setTimeout(() => { this.successMessageDiv.style.display = 'none'; }, 5000);
      }else {
        this.toastSuccess(this.successMsg);
      }
      if(this.emailInput) {
        this.emailInput.value = '';
        this.emailInput.blur();
      };
    }).catch(err => {
      console.error('Klaviyo Subscribe error:', err);
      if (this.errorMessageDiv) {
        this.errorMessageDiv.style.display = 'inline-flex';
        setTimeout(() => { this.errorMessageDiv.style.display = 'none'; }, 5000);
      } else {
        this.toastError(this.errorMsg);
      }
    }).finally(() => {
      this.submitBtn?.classList.remove('loading');
    });
  }
  toastSuccess(message) {
    const wrapperDiv = document.createElement("div");
    wrapperDiv.innerHTML = `
      <div class="mt-10 newsletter-form__message--success success form__message inline-flex align-center" tabindex="-1" role="status" aria-live="polite">
        <svg width="18" height="18" fill="none">
          <g stroke="#137F24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
            <path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>
          </g>
        </svg>
        <span class="ml-5">${message}</span>
      </div>
    `;
    showToast(wrapperDiv.innerHTML, 2000, "modal-success");
  }
  toastError(message, line) {
    const wrapperDiv = document.createElement("div");
    wrapperDiv.innerHTML = `
      <div class="mt-10 line-item-error-${line || 1} error form__message inline-flex align-center" tabindex="-1" role="alert" aria-live="assertive">
          <svg width="18" height="18" fill="none" class="flex-auto">
              <g stroke="#D0473E" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
                  <path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>
              </g>
          </svg>
          <span class="ml-5">${message}</span>
      </div>
    `;
    showToast(wrapperDiv.innerHTML, 2000, "modal-error");
  }
}
customElements.define("klaviyo-newsletter", KlaviyoNewsletter);

/**
 * =================================================================
 * PLAUD NAVIGATION SYSTEM 2.0 - INTERACTION CORE
 * Handles Desktop Tabs, Mobile Slide-outs, and Mobile Accordions.
 * =================================================================
 */
(function() {
  if (window.isPlaudNavInitialized) return;
  window.isPlaudNavInitialized = true;

  const initNavigation = () => {

    // Tayler added it for ADA EAA tab event .... 20260228
    // --- 1. DESKTOP: Atlassian Tab Hover & Keyboard Focus (Roving Tabindex) ---
    const tabSelectors = {
      container: '[data-atlassian-menu]',
      tab: '.at-tab-item',
      panel: '.at-content-panel',
      visual: '.at-visual-item',
      activeClass: 'active'
    };

    const handleTabActivation = (tabElement) => {
      if (window.innerWidth <= 1279) return; // [HEADER-BP-1280] was 1024

      const container = tabElement.closest(tabSelectors.container);
      if (!container) return;

      if (tabElement.classList.contains(tabSelectors.activeClass)) return;

      // 1. 熄灭所有 Tab：移除 active 类，并将 tabindex 设为 -1 (使其对 Tab 键隐身)
      container.querySelectorAll(tabSelectors.tab).forEach(el => {
        el.classList.remove(tabSelectors.activeClass);
        el.setAttribute('aria-expanded', 'false');
        el.setAttribute('tabindex', '-1'); 
      });

      // 2. 隐藏所有右侧面板与图片
      container.querySelectorAll(`.${tabSelectors.activeClass}`).forEach(el => {
        el.classList.remove(tabSelectors.activeClass);
      });

      // 3. 点亮当前 Tab：赋予 active 类，恢复 tabindex="0"，向读屏器宣告已展开
      tabElement.classList.add(tabSelectors.activeClass);
      tabElement.setAttribute('aria-expanded', 'true');
      tabElement.setAttribute('tabindex', '0'); 

      // 4. 显示对应的右侧面板与图片
      const panelId = tabElement.dataset.target;
      if (panelId) {
        const panel = document.getElementById(panelId);
        if (panel) panel.classList.add(tabSelectors.activeClass);
        
        const visualId = panelId.replace('panel-', 'visual-');
        const visual = document.getElementById(visualId);
        if (visual) visual.classList.add(tabSelectors.activeClass);
      }
    };

    // 为每个 Mega Menu 容器独立挂载事件，彻底消除 CPU 节流
    document.querySelectorAll(tabSelectors.container).forEach(menu => {
      
      // 处理鼠标悬停
      menu.addEventListener('mouseover', (e) => {
        if (window.innerWidth <= 1279) return; // [HEADER-BP-1280] was 1024
        if (!e.target || typeof e.target.closest !== 'function') return;
        const tab = e.target.closest(tabSelectors.tab);
        if (tab) handleTabActivation(tab);
      });

      // 处理键盘 Focus 切入
      menu.addEventListener('focusin', (e) => {
        if (window.innerWidth <= 1279) return; // [HEADER-BP-1280] was 1024
        if (!e.target || typeof e.target.closest !== 'function') return;
        const tab = e.target.closest(tabSelectors.tab);
        if (tab) handleTabActivation(tab);
      });

      // 核心：接管键盘上下方向键，实现焦点游走 (Roving Tabindex)
      menu.addEventListener('keydown', (e) => {
        if (window.innerWidth <= 1279) return; // [HEADER-BP-1280] was 1024
        
        const currentTab = e.target.closest(tabSelectors.tab);
        // 如果当前焦点不在 Tab 按钮上（而在右侧面板的内容里），则不拦截按键
        if (!currentTab) return; 

        const tabs = Array.from(menu.querySelectorAll(tabSelectors.tab));
        let index = tabs.indexOf(currentTab);
        if (index === -1) return;

        let newIndex = index;
        
        // 使用向下或向上方向键在 Tab 之间无缝穿梭
        if (e.key === 'ArrowDown') {
          e.preventDefault(); // 阻止页面整体滚动
          newIndex = (index + 1) % tabs.length; // 触底反弹到顶部
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          newIndex = (index - 1 + tabs.length) % tabs.length; // 触顶反弹到底部
        }

        // 切换焦点
        if (newIndex !== index) {
          tabs[newIndex].focus(); // 聚焦会自动触发上面的 'focusin' 事件并切换面板
        }
      });
    });

    // --- 2. MOBILE: Level 1 Slide-Out Trigger ---
    // Makes clicking the text behave like clicking the arrow
    const mobileToggles = document.querySelectorAll('.mobile-toggle-trigger');
    mobileToggles.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        if (window.innerWidth > 1279) return; // [HEADER-BP-1280] was 1024 -- Mobile only

        // Prevent default link navigation
        e.preventDefault();
        e.stopPropagation();

        // Find the parent Menu Item container
        const menuItem = trigger.closest('menu-item');
        if (!menuItem) return;

        // Find the native arrow (sibling of the link)
        const nativeArrow = menuItem.querySelector('open-children-toggle');
        if (nativeArrow) {
          // Trigger the theme's native logic (which adds .is-open and handles slide animation)
          nativeArrow.click();
        }
      });
    });

    // --- 3. MOBILE: Level 2 Accordion Trigger ---
    // Handles the custom Atlassian structure inside the slide-out panel
    document.body.addEventListener('click', (e) => {
      if (window.innerWidth > 1279) return; // [HEADER-BP-1280] was 1024

      const trigger = e.target.closest('[data-accordion-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();

        // Find content
        const parentLi = trigger.closest('li');
        const content = parentLi ? parentLi.querySelector('.mobile-accordion-content') : null;

        if (content) {
          // Toggle State
          const isOpen = content.classList.contains('is-open');
          
          // Optional: Accordion behavior (close others)
          /*
          const container = trigger.closest('ul');
          if (container) {
            container.querySelectorAll('.mobile-accordion-content').forEach(el => el.classList.remove('is-open'));
            container.querySelectorAll('[aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
          }
          */

          if (isOpen) {
            content.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            content.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        }
      }
    });

    // --- 4. BREAKPOINT STATE SYNCHRONIZATION ---
    // Tayler added 20260228.... for 架构优化：监听屏幕旋转或缩放导致的断点跨越，清理僵尸 class，防止 UI 错乱
    const syncToggleAccessibility = (isDesktop) => {
      document.querySelectorAll('open-children-toggle.static-1025').forEach(toggle => {
        if (isDesktop) {
          toggle.setAttribute('tabindex', '-1');
          toggle.setAttribute('aria-hidden', 'true');
        } else {
          toggle.setAttribute('tabindex', '0');
          if (!toggle.hasAttribute('aria-expanded')) {
             toggle.removeAttribute('aria-hidden');
          } else {
             toggle.removeAttribute('aria-hidden'); // 优先依赖 aria-expanded
          }
        }
      });
    };

    const mql = window.matchMedia('(max-width: 1279px)'); // [HEADER-BP-1280] was 1024
    
    syncToggleAccessibility(!mql.matches);

    mql.addEventListener('change', (e) => {
      const isMobile = e.matches;
      const isDesktop = !e.matches;

      syncToggleAccessibility(isDesktop);

      document.querySelectorAll('.at-tab-item.active, .at-content-panel.active, .at-visual-item.active').forEach(el => {
        el.classList.remove('active');
      });
      
      document.querySelectorAll('.mobile-accordion-content.is-open').forEach(el => {
        el.classList.remove('is-open');
      });
      document.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach(el => {
        el.setAttribute('aria-expanded', 'false');
      });

      if (isDesktop) { 
        document.querySelectorAll('[data-atlassian-menu]').forEach(menu => {
          const firstTab = menu.querySelector('.at-tab-item');
          if (firstTab) {
            firstTab.classList.add('active');
            firstTab.setAttribute('aria-expanded', 'true');
            firstTab.setAttribute('tabindex', '0');
            const panelId = firstTab.dataset.target;
            if (panelId) {
              const panel = document.getElementById(panelId);
              if (panel) panel.classList.add('active');
              const visualId = panelId.replace('panel-', 'visual-');
              const visual = document.getElementById(visualId);
              if (visual) visual.classList.add('active');
            }
          }
        });
      }
    });
  };

  // Initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavigation);
  } else {
    initNavigation();
  }
  // Re-init for Theme Editor
  document.addEventListener('shopify:section:load', initNavigation);
})();



/**
 * =================================================================
 * PLAUD FOOTER ACCORDION (Mobile Only)
 * Handles the expand/collapse logic for the footer grid on mobile devices.
 * Ensures ADA compliance by toggling aria-expanded attributes.
 * =================================================================
 */
(function() {
  const initFooterAccordion = () => {
    // Select all footer accordion buttons
    const triggers = document.querySelectorAll('.footer__accordion-btn');

    if (triggers.length === 0) return;

    triggers.forEach(btn => {
      // Remove any existing listeners to prevent duplicates if re-initialized
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });

    // Re-select fresh buttons
    const activeTriggers = document.querySelectorAll('.footer__accordion-btn');

    activeTriggers.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();

        // 1. Get Control Targets
        const targetId = this.getAttribute('aria-controls');
        const content = document.getElementById(targetId);
        
        if (!content) return;

        // 2. Check Current State
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // 3. Optional: Close other open accordions (Accordion Behavior)
        // If you want "One Open at a Time", uncomment the block below:
        /*
        activeTriggers.forEach(otherBtn => {
          if (otherBtn !== this && otherBtn.getAttribute('aria-expanded') === 'true') {
            otherBtn.setAttribute('aria-expanded', 'false');
            const otherContentId = otherBtn.getAttribute('aria-controls');
            const otherContent = document.getElementById(otherContentId);
            if (otherContent) otherContent.classList.remove('is-open');
          }
        });
        */

        // 4. Toggle State
        this.setAttribute('aria-expanded', !isExpanded);
        
        if (!isExpanded) {
          content.classList.add('is-open');
        } else {
          content.classList.remove('is-open');
        }
      });
    });
  };

  // Initialize on Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }

  // Re-init for Theme Editor (Shopify Design Mode Support)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.id.includes('footer')) {
      initFooterAccordion();
    }
  });
})();


/* ==========================================================================
   WW Oura-Style Expandable Card Controller (V10 - Navigation Fix)
   Refined: Native Swiper Navigation Integration
   ========================================================================== */
(function() {
  class OuraCardController {
    constructor(container) {
      this.container = container;
      this.items = Array.from(container.querySelectorAll('.ww-expandable-col')); 
      this.triggers = container.querySelectorAll('.ww-col-expand-trigger'); 
      this.parallaxImages = container.querySelectorAll('.ww-parallax-image-container');
      
      this.isSliderMode = container.dataset.desktopEnable === 'true';
      this.swiperInstance = null; 
      this.syncFrameId = null;
      this.isInteracting = false; // Internal lock
      this.collapseDuration = 800;
      this.expandDuration = 950;
      this.desktopNavDelay = 850;
      this.mobileNavDuration = 900;
      this.mobileSliderDefaults = null;
      
      this.init();
    }

    init() {
      // 1. 绑定基础点击事件
      this.bindClickEvents();

      // 2. 绑定视差
      /* Tayler disable parallax .... 20260604
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll(); 
      */

      // 3. 模式分流
      if (this.isSliderMode) {
          this.waitForSwiper();
      } else {
          this.container.setAttribute('data-oura-ready', 'true');
      }
    }

    bindClickEvents() {
      this.container.addEventListener('click', (e) => {
        const btn = e.target.closest('.ww-col-expand-trigger');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          const targetCol = btn.closest('.ww-expandable-col');
          this.toggleState(targetCol);
        }
      });
    }

    getSwiperInstance() {
      let swiper = this.container.globalSlide || this.container.swiper;
      if (!swiper) {
        const swiperContainer = this.container.querySelector('.swiper');
        if (swiperContainer && swiperContainer.swiper) {
          swiper = swiperContainer.swiper;
        }
      }

      if (swiper && swiper.initialized) {
        this.swiperInstance = swiper;
        return swiper;
      }

      if (this.swiperInstance && this.swiperInstance.initialized) {
        return this.swiperInstance;
      }

      this.swiperInstance = null;
      return null;
    }

    isMobileViewport() {
      return window.matchMedia('(max-width: 767.98px)').matches;
    }

    getMobileSliderDefaults(swiper) {
      if (this.mobileSliderDefaults) return this.mobileSliderDefaults;

      const fallbackSlidesPerView = this.container.dataset.mobile
        ? parseFloat(this.container.dataset.mobile)
        : swiper.params.slidesPerView;
      const fallbackSpaceBetween = this.container.dataset.spacingMb
        ? parseFloat(this.container.dataset.spacingMb)
        : (this.container.dataset.spacing
          ? parseFloat(this.container.dataset.spacing)
          : swiper.params.spaceBetween);

      this.mobileSliderDefaults = {
        slidesPerView: fallbackSlidesPerView || 1,
        spaceBetween: Number.isFinite(fallbackSpaceBetween) ? fallbackSpaceBetween : 0,
        slidesOffsetAfter: swiper.params.slidesOffsetAfter || 0,
      };

      return this.mobileSliderDefaults;
    }

    setExpandedMobileSwiperLayout(swiper, expanded) {
      if (!swiper) return;

      if (!this.isMobileViewport()) {
        swiper.update();
        return;
      }

      const defaults = this.getMobileSliderDefaults(swiper);
      const slideSize = (swiper.width - ((defaults.slidesPerView - 1) * defaults.spaceBetween)) / defaults.slidesPerView;
      const expandedOffsetAfter = Math.max(0, swiper.width - slideSize);
      const nextSlidesOffsetAfter = expanded
        ? defaults.slidesOffsetAfter + expandedOffsetAfter
        : defaults.slidesOffsetAfter;

      if (
        swiper.params.slidesPerView !== defaults.slidesPerView ||
        swiper.params.spaceBetween !== defaults.spaceBetween ||
        swiper.params.slidesOffsetAfter !== nextSlidesOffsetAfter
      ) {
        swiper.params.slidesPerView = defaults.slidesPerView;
        swiper.params.spaceBetween = defaults.spaceBetween;
        swiper.params.slidesOffsetAfter = nextSlidesOffsetAfter;
      }

      if (swiper.setTransition) {
        swiper.setTransition(0);
      }
      swiper.update();
    }

    freezeMobileSwiperPosition(swiper) {
      if (!swiper || !this.isMobileViewport()) return false;

      const translate = typeof swiper.getTranslate === 'function'
        ? swiper.getTranslate()
        : (swiper.translate || 0);

      this.container.style.setProperty('--ww-frozen-swiper-x', `${translate}px`);
      this.container.setAttribute('data-oura-freeze-swiper', 'true');

      if (swiper.setTransition) {
        swiper.setTransition(0);
      }

      return true;
    }

    unfreezeMobileSwiperPosition() {
      this.container.removeAttribute('data-oura-freeze-swiper');
      this.container.style.removeProperty('--ww-frozen-swiper-x');
    }

    getMobileExpandedHeight() {
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      return Math.max(0, Math.round(viewportHeight || window.innerHeight || 0));
    }

    getMobileExpandedWidth(swiper) {
      return Math.round(swiper?.width || this.container.getBoundingClientRect().width || window.innerWidth || 0);
    }

    getMobileCollapsedSize(swiper, item) {
      if (swiper && swiper.width) {
        const defaults = this.getMobileSliderDefaults(swiper);
        return Math.round((swiper.width - ((defaults.slidesPerView - 1) * defaults.spaceBetween)) / defaults.slidesPerView);
      }

      return Math.round(item?.getBoundingClientRect().width || 0);
    }

    startMobileSlideHeightTransition(item, expanding, swiper) {
      if (!item || !this.isMobileViewport()) return false;

      const rect = item.getBoundingClientRect();
      const currentWidth = Math.round(rect.width || 0);
      const currentHeight = Math.round(rect.height || 0);
      const targetWidth = expanding
        ? this.getMobileExpandedWidth(swiper)
        : this.getMobileCollapsedSize(swiper, item);
      const targetHeight = expanding
        ? this.getMobileExpandedHeight()
        : this.getMobileCollapsedSize(swiper, item);

      if (!currentWidth || !currentHeight || !targetWidth || !targetHeight) return false;

      item.setAttribute('data-oura-height-animating', 'true');
      item.style.setProperty('--ww-anim-width', `${currentWidth}px`);
      item.style.setProperty('--ww-anim-height', `${currentHeight}px`);

      item.offsetHeight;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (item.hasAttribute('data-oura-height-animating')) {
            item.style.setProperty('--ww-anim-width', `${targetWidth}px`);
            item.style.setProperty('--ww-anim-height', `${targetHeight}px`);
          }
        });
      });

      return true;
    }

    finishMobileSlideHeightTransition(item) {
      if (!item) return;

      item.removeAttribute('data-oura-height-animating');
      item.style.removeProperty('--ww-anim-width');
      item.style.removeProperty('--ww-anim-height');
    }

    waitForSwiper() {
      let attempts = 0;
      const checkSwiper = setInterval(() => {
        if (++attempts > 50) {
          clearInterval(checkSwiper);
          return;
        }
        let swiper = this.container.globalSlide || this.container.swiper;
        if (!swiper) {
           const swiperContainer = this.container.querySelector('.swiper');
           if (swiperContainer && swiperContainer.swiper) {
             swiper = swiperContainer.swiper;
           }
        }

        if (swiper && swiper.initialized) {
          clearInterval(checkSwiper);
          this.swiperInstance = swiper;
          this.setupSwiperControls();
          this.container.setAttribute('data-oura-ready', 'true');

          if(this.swiperInstance.navigation) this.swiperInstance.navigation.update();
        }
      }, 200);
    }

    setupSwiperControls() {
      if (!this.swiperInstance) return;

      const nextBtn = this.container.querySelector('.swiper-button-next');
      const prevBtn = this.container.querySelector('.swiper-button-prev');

      // 使用 Capture 拦截点击
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => this.handleNavigation(e, 'next'), true);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => this.handleNavigation(e, 'prev'), true);
      }

      this.swiperInstance.on('sliderMove', (swiper, e) => {
         const event = e.originalEvent || e;
         
         if (!event || !event.target) return;

         if (event.target.closest('.ww-col-expand-trigger') || 
             event.target.closest('.swiper-button-next') || 
             event.target.closest('.swiper-button-prev')) {
             return;
         }

         // 只有点击“卡片空白处”或“试图拖动 Slider”时，才触发自动收缩
         if (this.container.hasAttribute('data-has-expanded')) {
            this.collapseAll();
         }
      });
      
      this.swiperInstance.on('slideChange', () => {
         if(this.swiperInstance.navigation) this.swiperInstance.navigation.update();
      });
    }

    handleNavigation(e, direction) {
      e.preventDefault();
      e.stopPropagation(); 
      
      if (!this.getSwiperInstance() || this.isInteracting) return;
      
      const slideAction = () => {
          const swiper = this.getSwiperInstance();
          if (!swiper) return;

          if (direction === 'next') {
              swiper.slideNext();
          } else {
              swiper.slidePrev();
          }
          if (swiper.navigation) {
             swiper.navigation.update();
          }
      };

      if (this.container.hasAttribute('data-has-expanded')) {
        if (this.isMobileViewport()) {
          this.navigateExpandedMobile(direction);
          return;
        }

        this.isInteracting = true;
        this.collapseAll(false);

        setTimeout(() => {
           const swiper = this.getSwiperInstance();
           if (swiper) {
             swiper.update();
             if (swiper.navigation) swiper.navigation.update();
           }
           slideAction();
           this.isInteracting = false;
        }, this.desktopNavDelay);
      } else {
        slideAction();
      }
    }

    navigateExpandedMobile(direction) {
      const swiper = this.getSwiperInstance();
      if (!swiper) return;

      const currentIndex = this.items.findIndex(item => item.classList.contains('is-expanded'));
      const baseIndex = currentIndex >= 0 ? currentIndex : swiper.activeIndex;
      const targetIndex = direction === 'next'
        ? Math.min(baseIndex + 1, this.items.length - 1)
        : Math.max(baseIndex - 1, 0);
      const targetItem = this.items[targetIndex];

      if (targetIndex === baseIndex || !targetItem) {
        if (swiper.navigation) swiper.navigation.update();
        return;
      }

      this.stopAnimationLoop();
      this.isInteracting = true;
      this.container.setAttribute('data-has-expanded', 'true');

      this.items.forEach((item, index) => {
        if (index !== targetIndex) {
          item.classList.remove('is-expanded');
          this.resetButtonState(item);
        }
      });

      targetItem.classList.add('is-expanded');
      const btn = targetItem.querySelector('.ww-col-expand-trigger');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
      }

      this.setExpandedMobileSwiperLayout(swiper, true);
      if (swiper.navigation) swiper.navigation.update();
      swiper.slideTo(targetIndex, 600);

      this.runAnimationSync(this.mobileNavDuration, () => {
        const latestSwiper = this.getSwiperInstance();
        if (latestSwiper) {
          this.setExpandedMobileSwiperLayout(latestSwiper, true);
          latestSwiper.slideTo(targetIndex, 0);
          if (latestSwiper.navigation) latestSwiper.navigation.update();
        }
        this.isInteracting = false;
      }, false);
    }

    stopAnimationLoop() {
        if (this.syncFrameId) {
            cancelAnimationFrame(this.syncFrameId);
            this.syncFrameId = null;
        }
    }

    collapseAll(unlock = true) {
      this.stopAnimationLoop();

      if (!this.container.hasAttribute('data-has-expanded')) return;

      const currentSwiper = this.getSwiperInstance();
      const expandedIndex = this.items.findIndex(item => item.classList.contains('is-expanded'));
      const collapseIndex = expandedIndex >= 0 ? expandedIndex : (currentSwiper ? currentSwiper.activeIndex : 0);

      const collapseItem = this.items[collapseIndex];

      if (currentSwiper && this.isMobileViewport()) {
        this.freezeMobileSwiperPosition(currentSwiper);
        this.startMobileSlideHeightTransition(collapseItem, false, currentSwiper);
        this.container.setAttribute('data-oura-collapsing', 'true');
      }

      this.items.forEach(item => {
        item.classList.remove('is-expanded');
        this.resetButtonState(item);
      });
      this.container.removeAttribute('data-has-expanded');

      if (!this.isSliderMode) {
          this.unfreezeMobileSwiperPosition();
          this.container.removeAttribute('data-oura-collapsing');
          if (unlock) this.isInteracting = false;
          return;
      }

      if (currentSwiper && !this.isMobileViewport()) {
        this.setExpandedMobileSwiperLayout(currentSwiper, false);
      }

      this.runAnimationSync(this.collapseDuration, () => {
         const swiper = this.getSwiperInstance();
         if (swiper) {
            this.setExpandedMobileSwiperLayout(swiper, false);
            if (this.isMobileViewport()) swiper.slideTo(collapseIndex, 0);
            if(swiper.navigation) swiper.navigation.update();
         }
         this.finishMobileSlideHeightTransition(collapseItem);
         this.unfreezeMobileSwiperPosition();
         this.container.removeAttribute('data-oura-collapsing');
         if (unlock) this.isInteracting = false;
      }, !this.isMobileViewport());
    }

    toggleState(activeItem) {
      if (this.isInteracting) return; 

      this.stopAnimationLoop();
      this.isInteracting = true; 
      
      const isAlreadyExpanded = activeItem.classList.contains('is-expanded');
      const slideIndex = this.items.indexOf(activeItem);
      const swiper = this.getSwiperInstance();

      if (isAlreadyExpanded) {
        // --- 收缩 ---
        if (this.isSliderMode && swiper && this.isMobileViewport()) {
          this.freezeMobileSwiperPosition(swiper);
          this.startMobileSlideHeightTransition(activeItem, false, swiper);
          this.container.setAttribute('data-oura-collapsing', 'true');
        }

        activeItem.classList.remove('is-expanded');
        this.resetButtonState(activeItem);
        this.container.removeAttribute('data-has-expanded');
        
        if (this.isSliderMode && swiper) {
            if (!this.isMobileViewport()) {
              this.setExpandedMobileSwiperLayout(swiper, false);
            }
            this.runAnimationSync(this.collapseDuration, () => {
                 const latestSwiper = this.getSwiperInstance();
                 if (latestSwiper) {
                   this.setExpandedMobileSwiperLayout(latestSwiper, false);
                   latestSwiper.slideTo(slideIndex, this.isMobileViewport() ? 0 : 600);
                   if(latestSwiper.navigation) latestSwiper.navigation.update();
                 }
                 this.finishMobileSlideHeightTransition(activeItem);
                 this.unfreezeMobileSwiperPosition();
                 this.container.removeAttribute('data-oura-collapsing');
                 this.isInteracting = false;
            }, !this.isMobileViewport());
        } else {
            // Grid 模式
            setTimeout(() => { this.isInteracting = false; }, this.collapseDuration);
        }
        return;
      }

      // --- 展开 ---
      if (this.isSliderMode && swiper && this.isMobileViewport()) {
        this.freezeMobileSwiperPosition(swiper);
        this.startMobileSlideHeightTransition(activeItem, true, swiper);
      }

      this.items.forEach(item => {
        if (item !== activeItem) {
          item.classList.remove('is-expanded');
          this.resetButtonState(item);
        }
      });

      activeItem.classList.add('is-expanded');
      this.container.setAttribute('data-has-expanded', 'true');
      
      const btn = activeItem.querySelector('.ww-col-expand-trigger');
      if(btn) {
          btn.setAttribute('aria-expanded', 'true');
      }

      if (this.isSliderMode && swiper) {
          if (!this.isMobileViewport()) {
            this.setExpandedMobileSwiperLayout(swiper, true);
            swiper.slideTo(slideIndex, 600);
          }
          
          this.runAnimationSync(this.expandDuration, () => {
              const latestSwiper = this.getSwiperInstance();
              if (latestSwiper) {
                this.setExpandedMobileSwiperLayout(latestSwiper, true);
                latestSwiper.slideTo(slideIndex, this.isMobileViewport() ? 0 : 300);
                if(latestSwiper.navigation) latestSwiper.navigation.update();
              }
              this.finishMobileSlideHeightTransition(activeItem);
              this.unfreezeMobileSwiperPosition();
              this.isInteracting = false;
          }, !this.isMobileViewport());
      } else {
          setTimeout(() => {
              if(this.isMobileViewport()) {
                  activeItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              this.isInteracting = false;
          }, this.collapseDuration);
      }
    }

    resetButtonState(item) {
        const btn = item.querySelector('.ww-col-expand-trigger');
        if(btn) {
            btn.setAttribute('aria-expanded', 'false');
        }
    }

    runAnimationSync(duration, onComplete, syncDuringAnimation = true) {
      const startTime = Date.now();
      const frame = () => {
        const now = Date.now();
        const progress = now - startTime;
        
        if (syncDuringAnimation && this.swiperInstance) {
            this.swiperInstance.update();
        }
        
        if (progress < duration) {
          this.syncFrameId = requestAnimationFrame(frame);
        } else {
          this.syncFrameId = null;
          if (onComplete) onComplete();
        }
      };
      this.syncFrameId = requestAnimationFrame(frame);
    }

    /* Tayler disable parallax .... 20260604
    onScroll() {
      const rect = this.container.getBoundingClientRect();
      const viewHeight = window.innerHeight;
      if (rect.top <= viewHeight && rect.bottom >= 0) {
        this.parallaxImages.forEach(imgContainer => {
          const speed = 0.06; 
          const yPos = (rect.top * speed);
          imgContainer.style.transform = `translate3d(0, ${yPos}px, 0)`;
        });
      }
    }*/
  }

  const initOuraCards = () => {
    const sections = document.querySelectorAll('multi-content-ww[data-expandable="true"]');
    sections.forEach(section => {
      if (!section.dataset.ouraInit) {
        new OuraCardController(section);
        section.dataset.ouraInit = 'true';
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initOuraCards);
  document.addEventListener('shopify:section:load', initOuraCards);
})();

//Tayler added it .... for Badge shown for unavialable region bug....20260324
//Updated 2026-05-19: dual-render badges + real-IP refinement now actually syncs badges AND buy buttons; delegation handles dynamic class additions
// [DTC-819] 精修抽成 refineRegionByRealIP(root)：DOMContentLoaded 只跑一次，AJAX 注入面（quickview）需对注入节点单独调用；真实 IP 结果跨调用缓存
let _realIpCountryPromise = null;
function fetchRealIpCountryCode() {
  if (!_realIpCountryPromise) {
    _realIpCountryPromise = fetch('/browsing_context_suggestions.json')
      .then(response => response.json())
      // .toUpperCase() to match target_markets ISO codes (auto-redirection.js:76 uses the same normalization)
      .then(data => data?.detected_values?.country?.handle?.toUpperCase() || null)
      .catch(error => {
        // 失败清缓存：一次网络抖动不能永久毒化后续精修（如稍后打开的 quickview）
        _realIpCountryPromise = null;
        console.error('Error fetching geolocation for badges:', error);
        return null;
      });
  }
  return _realIpCountryPromise;
}

function refineRegionByRealIP(root = document) {
  // [data-region-aware="true"] matches all region-feature-on containers regardless of OOS, so in-stock products also get region badge toggled
  const badgeContainers = root.querySelectorAll('.product__badges[data-region-aware="true"]');
  if (badgeContainers.length === 0) return; // 无锚点（region 功能未开）时连 fetch 都不发

  fetchRealIpCountryCode()
    .then(userRealCountryCode => {
      if (!userRealCountryCode) return;

      badgeContainers.forEach(container => {
        const allowedMarketsStr = container.getAttribute('data-allowed-markets');
        if (!allowedMarketsStr) return;
        const allowedMarkets = allowedMarketsStr.split(',');
        const isOutOfRegion = !allowedMarkets.includes(userRealCountryCode);
        // [DTC-930] 全局开关 enable_region_buy（容器 data-region-buy-enabled）：
        // 开=768 行为（徽章/tip 恒隐、售罄徽章拦截防复显）；关=768 前行为（region 徽章/tip 按真实 IP 展示）
        const regionBuyEnabled = container.getAttribute('data-region-buy-enabled') === 'true';
        // [DTC-768] 真实 IP 结果写回容器，renderLabel 变体切换时据此拦截售罄徽章复显（仅开关开时生效）
        container.setAttribute('data-region-out', regionBuyEnabled && isOutOfRegion);

        const soldOutBadge = container.querySelector('.js-badge-sold-out');
        const regionBadge = container.querySelector('.js-badge-region');
        if (regionBadge) {
          if (regionBuyEnabled) {
            // [DTC-768] 二次反馈：CTA 统一由购买按钮承载，产品名上方徽章恒隐藏
            regionBadge.classList.add('hidden-important');
          } else {
            regionBadge.classList.toggle('hidden-important', !isOutOfRegion);
          }
        }

        // Use hidden-important (critical.css: display:none !important) — plain .hidden gets overridden by .inline-flex due to Tailwind utility order
        // 两态同式：非售卖区 IP 隐售罄徽章（开=拦截无替代物；关=由 region 徽章替换展示，768 前原逻辑）
        if (soldOutBadge) soldOutBadge.classList.toggle('hidden-important', isOutOfRegion);

        // scope 契约：closest 取最近祖先——徽章锚点与 section 根之间不得插入带 [data-section-id] 的包装层，否则 scope 静默收窄，sticky bar 等同 section 表单将脱离精修
        const scope = container.closest('.shopify-section, [data-section-id], .product-quickview__content');
        if (!scope) return;
        scope.querySelectorAll('[data-region-tip]').forEach(tip => {
          if (regionBuyEnabled) {
            tip.classList.add('hidden-important');
          } else {
            tip.classList.toggle('hidden-important', !isOutOfRegion);
          }
        });

        // [DTC-768] 非售卖区 IP（与库存无关）：主购买按钮换 Go To Local Site、隐藏 dynamic checkout（服务端已按 request.country 初始渲染，这里按真实 IP 双向精修）
        scope.querySelectorAll('product-form').forEach(pf => {
          const regionBtn = pf.querySelector('.js-region-buy-btn');
          if (!regionBtn) return; // 未开 region 功能或非 buy-buttons 渲染面不处理
          regionBtn.classList.toggle('hidden-important', !isOutOfRegion);
          const submitBtn = pf.querySelector('.product-form__submit');
          if (submitBtn) {
            submitBtn.classList.toggle('hidden-important', isOutOfRegion);
            // hidden-important 只是视觉隐藏：数量框回车仍会隐式提交表单，须同步 aria-disabled（onSubmitHandler 据此拦截；renderBtnStatus 变体切换只写 disabled 不碰 aria-disabled）
            if (isOutOfRegion) {
              submitBtn.setAttribute('aria-disabled', 'true');
            } else if (submitBtn.getAttribute('aria-disabled') === 'true') {
              submitBtn.removeAttribute('aria-disabled');
            }
          }
          pf.querySelectorAll('[data-region-hide-checkout]').forEach(el => {
            el.classList.toggle('hidden-important', isOutOfRegion);
          });
        });
      });
    })
    .catch(error => console.error('Error refining region state:', error));
}

document.addEventListener('DOMContentLoaded', function() {
  // 1. Event delegation: any .js-open-region-selector (server-rendered or JS-added) opens region selector
  //    document 级只注册一次——不得挪进 refineRegionByRealIP（quickview 每次注入都会调用它，会重复注册）
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.js-open-region-selector');
    if (!trigger) return;
    e.preventDefault();
    const regionSelectorComponent = document.querySelector('region-selector');
    if (regionSelectorComponent) {
      regionSelectorComponent.click();
    } else {
      console.warn('Region selector component not found on this page.');
    }
  });

  // 2. IP-based refinement: server uses localization.country.iso_code (may disagree with real IP under multi-currency), refine with /browsing_context_suggestions.json
  refineRegionByRealIP();
});
